import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useMemo,
} from "react";
import {
  Table,
  Button,
  Input,
  Select,
  Upload,
  Space,
  Checkbox,
  message,
  Spin,
  Tooltip,
  Modal,
  Dropdown,
  Row,
  Col,
  Card,
  DatePicker,
  TimePicker,
  Pagination,
  Tag,
  Menu,
  Drawer,
  Statistic,
  Avatar,
  Image,
  Form,
  theme,
} from "antd";
import { FaAddressCard, FaInfoCircle, FaPen, FaTrashAlt, FaWhatsapp, FaLinkedin, FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaTelegram, FaGoogle, FaGlobe, FaEnvelope, FaPhoneAlt, FaUserFriends, FaReddit, FaDiscord, FaTiktok, FaSnapchat, FaPinterest } from "react-icons/fa";
import { RiAddBoxFill, RiCheckLine } from "react-icons/ri";
import AddRawDataModal from "./Add";
import EditRawDataModal from "./Edit";
import {
  addPinLead,
  deleteRawData,
  deleteRawDataSummary,
  getallDeveloperForTask,
  getAllRawData,
  getAllRawDataForPin,
  getLeadStatus,
  getPinnedLeads,
  getRawDataById,
  getRawDataLog,
  transferRawData,
  updateRawData,
  getAllTags,
  getAllSources,
} from "../../utils/API"; // âœ… your axios instance
import dayjs, { Dayjs } from "dayjs";
import { hasPermission } from "../../utils/HasPermission";
import {
  BarChartOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  DatabaseOutlined,
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  EyeOutlined,
  FileTextFilled,
  FilterOutlined,
  LinkOutlined,
  MailOutlined,
  MessageOutlined,
  PhoneOutlined,
  SearchOutlined,
  TagsOutlined,
  UploadOutlined,
  UserOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { color } from "echarts";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { updateRawDataStatus, setRawDatas } from "../store/slice/rawdataSlice";
import type { RootState, AppDispatch } from "../store/index";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import TiptapImage from "@tiptap/extension-image";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import Placeholder from "@tiptap/extension-placeholder";
import Heading from "@tiptap/extension-heading";
import BulletList from "@tiptap/extension-bullet-list";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import { TiPin, TiPinOutline } from "react-icons/ti";
import {
  Building2,
  BriefcaseBusiness,
  CalendarDays,
  Activity,
  Bell,
  Calendar,
  ChartNoAxesCombined,
  Clock3,
  Clock,
  CircleUserRound,
  FileText,
  Flag,
  Hourglass,
  IndianRupee,
  Link2,
  List,
  ListOrdered,
  Mail as LucideMail,
  MapPin,
  MessageCircle,
  Pencil,
  PhoneCall,
  Phone as LucidePhone,
  ChevronRight,
  Plus,
  Send,
  Tags as LucideTags,
  Trash2,
  User as LucideUser,
  X,
} from "lucide-react";
import { RiUnpinLine } from "react-icons/ri";
import { FcMoneyTransfer } from "react-icons/fc";
import { RiFileCopyLine } from "react-icons/ri";

const { Option } = Select;
export type SortOrder = "descend" | "ascend" | null;

// Status Badge
const StatusBadge = ({ status, color }: any) => (
  <span
    style={{
      backgroundColor: color ? `${color}33` : "#f0f0f0",
      color: color || "#000000",
      fontSize: "10px",
      padding: "2px 8px",
      borderRadius: "4px",
      fontWeight: 700,
      display: "inline-block",
    }}
  >
    {status}
  </span>
);

// Tag Badge
const TagBadge = ({ tag, color }: any) => (
  <span
    style={{
      backgroundColor: color ? `${color}33` : "#f0f0f0",
      color: color || "#000000",
      fontSize: "10px",
      padding: "2px 8px",
      borderRadius: "4px",
      fontWeight: 700,
      display: "inline-block",
    }}
  >
    {tag}
  </span>
);

const SourceBadge = ({ source, color }: any) => (
  <span
    style={{
      backgroundColor: color ? `${color}1A` : "#f5f5f5", // subtle bg tint
      color: color || "#262626", // darker text for better contrast
      fontSize: "12px",
      padding: "3px 10px",
      borderRadius: "6px", // smoother rounded look
      fontWeight: 500,
      border: `1px solid ${color ? `${color}4D` : "#d9d9d9"}`, // faint border
      display: "inline-block",
    }}
  >
    {source}
  </span>
);

const SOURCE_ICON_MAP: Array<{ pattern: RegExp; icon: React.ElementType; color: string }> = [
  { pattern: /whatsapp/i,  icon: FaWhatsapp,    color: "#25D366" },
  { pattern: /linkedin/i,  icon: FaLinkedin,    color: "#0A66C2" },
  { pattern: /facebook|fb\b/i, icon: FaFacebook, color: "#1877F2" },
  { pattern: /instagram|insta\b/i, icon: FaInstagram, color: "#E1306C" },
  { pattern: /twitter|x\.com|\btwit\b/i, icon: FaTwitter, color: "#1DA1F2" },
  { pattern: /youtube|yt\b/i, icon: FaYoutube,  color: "#FF0000" },
  { pattern: /telegram/i,  icon: FaTelegram,    color: "#26A5E4" },
  { pattern: /tiktok/i,    icon: FaTiktok,      color: "#010101" },
  { pattern: /snapchat/i,  icon: FaSnapchat,    color: "#FFFC00" },
  { pattern: /pinterest/i, icon: FaPinterest,   color: "#E60023" },
  { pattern: /reddit/i,    icon: FaReddit,      color: "#FF4500" },
  { pattern: /discord/i,   icon: FaDiscord,     color: "#5865F2" },
  { pattern: /google/i,    icon: FaGoogle,      color: "#4285F4" },
  { pattern: /referral/i,  icon: FaUserFriends, color: "#7c3aed" },
  { pattern: /email|mail/i, icon: FaEnvelope,   color: "#f59e0b" },
  { pattern: /call|phone/i, icon: FaPhoneAlt,   color: "#10b981" },
  { pattern: /website|web\b|online/i, icon: FaGlobe, color: "#0ea5e9" },
];

const getSourceIcon = (sourceName: string): { Icon: React.ElementType; color: string } | null => {
  if (!sourceName) return null;
  const match = SOURCE_ICON_MAP.find(({ pattern }) => pattern.test(sourceName));
  return match ? { Icon: match.icon, color: match.color } : null;
};

const getSourceIconFromUrl = (url: string): { Icon: React.ElementType; color: string } | null => {
  if (!url) return null;
  let hostname = "";
  try {
    hostname = new URL(url.startsWith("http") ? url : `https://${url}`).hostname.replace(/^www\./, "");
  } catch {
    hostname = url;
  }
  const URL_ICON_MAP: Array<{ pattern: RegExp; icon: React.ElementType; color: string }> = [
    { pattern: /whatsapp\.com|wa\.me/i,     icon: FaWhatsapp,    color: "#25D366" },
    { pattern: /linkedin\.com/i,             icon: FaLinkedin,    color: "#0A66C2" },
    { pattern: /facebook\.com|fb\.com/i,     icon: FaFacebook,    color: "#1877F2" },
    { pattern: /instagram\.com/i,            icon: FaInstagram,   color: "#E1306C" },
    { pattern: /twitter\.com|x\.com/i,       icon: FaTwitter,     color: "#1DA1F2" },
    { pattern: /youtube\.com|youtu\.be/i,    icon: FaYoutube,     color: "#FF0000" },
    { pattern: /t\.me|telegram\.me|telegram\.org/i, icon: FaTelegram, color: "#26A5E4" },
    { pattern: /tiktok\.com/i,               icon: FaTiktok,      color: "#010101" },
    { pattern: /snapchat\.com/i,             icon: FaSnapchat,    color: "#FFFC00" },
    { pattern: /pinterest\.com/i,            icon: FaPinterest,   color: "#E60023" },
    { pattern: /reddit\.com/i,               icon: FaReddit,      color: "#FF4500" },
    { pattern: /discord\.com|discord\.gg/i,  icon: FaDiscord,     color: "#5865F2" },
    { pattern: /google\.com/i,               icon: FaGoogle,      color: "#4285F4" },
  ];
  const match = URL_ICON_MAP.find(({ pattern }) => pattern.test(hostname));
  return match ? { Icon: match.icon, color: match.color } : null;
};

const getInitials = (name: string) => {
  if (!name) return "??";
  const parts = name.split(" ").filter((p) => p.length > 0);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return parts[0] ? parts[0].slice(0, 2).toUpperCase() : "??";
};

const cleanDisplayText = (value: any): string =>
  String(value ?? "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/\s+/g, " ")
    .trim();

const ProbabilityIcon = ({
  size = 27,
  color = "#2563eb",
  strokeWidth = 2.45,
}: {
  size?: number | string;
  color?: string;
  strokeWidth?: number | string;
}) => {
  const stroke =
    typeof strokeWidth === "number" ? strokeWidth : Number(strokeWidth) || 2.45;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="14" cy="14" r="9.4" stroke={color} strokeWidth={stroke} />
      <path
        d="M14 14L19.4 8.6"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
      />
      <circle cx="14" cy="14" r="2.15" fill={color} />
      <path
        d="M19.35 5.45H22.45V8.55"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const formatProbability = (value: any): string => {
  if (value === undefined || value === null || String(value).trim() === "") {
    return "0%";
  }

  const probabilityText = String(value).trim();
  return probabilityText.endsWith("%") ? probabilityText : `${probabilityText}%`;
};

const getPersonName = (person: any): string => {
  if (!person) return "";
  if (typeof person === "string") return cleanDisplayText(person);

  const fullName = [person.firstName, person.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  return cleanDisplayText(
    fullName ||
      person.fullName ||
      person.name ||
      person.username ||
      person.employeeName ||
      person.email,
  );
};

const getRoleLabel = (role: any): string => {
  if (!role) return "";
  if (typeof role === "number") {
    if (role === 1) return "Super Admin";
    if (role === 2) return "Developer";
    return "";
  }
  if (typeof role === "string") {
    const cleanRole = cleanDisplayText(role);
    if (/^[0-9]+$/.test(cleanRole)) return getRoleLabel(Number(cleanRole));
    return cleanRole;
  }

  return cleanDisplayText(
    role.name ||
      role.roleName ||
      role.title ||
      role.label ||
      getRoleLabel(role.roleId) ||
      getRoleLabel(role.id),
  );
};

const getUserRoleLabel = (user: any): string =>
  getRoleLabel(user?.roleId) ||
  getRoleLabel(user?.role) ||
  cleanDisplayText(
    user?.roleName ||
      user?.userRole ||
      user?.designation ||
      user?.designationName,
  );

const getLogUpdatedByFromMessage = (message?: string): string => {
  const text = cleanDisplayText(message);
  return (
    text.match(/updated\s*by\s*:?\s*(.*?)(?=\s*(?:\||changes?\s*:|$))/i)?.[1] ||
    text.match(/updatedby\s*:?\s*(.*?)(?=\s*(?:\||changes?\s*:|$))/i)?.[1] ||
    ""
  ).trim();
};

const getLogUpdaterName = (log: any): string =>
  getLogUpdatedByFromMessage(log?.message) ||
  getPersonName(log?.performedBy) ||
  getPersonName(log?.updatedBy) ||
  getPersonName(log?.changedBy) ||
  getPersonName(log?.modifiedBy) ||
  getPersonName(log?.createdBy) ||
  getPersonName(log?.actor) ||
  getPersonName(log?.user) ||
  cleanDisplayText(
    log?.updatedByName ||
      log?.performedByName ||
      log?.changedByName ||
      log?.userName ||
      log?.username,
  ) ||
  "System";

const getLogUpdaterId = (log: any): string =>
  cleanDisplayText(
    log?.performedBy?._id ||
      log?.performedBy?.id ||
      log?.updatedBy?._id ||
      log?.updatedBy?.id ||
      log?.changedBy?._id ||
      log?.changedBy?.id ||
      log?.modifiedBy?._id ||
      log?.modifiedBy?.id ||
      log?.createdBy?._id ||
      log?.createdBy?.id ||
      log?.actor?._id ||
      log?.actor?.id ||
      log?.user?._id ||
      log?.user?.id ||
      log?.performedById ||
      log?.updatedById ||
      log?.changedById ||
      log?.userId,
  );

const findTeamMemberForLog = (log: any, teamMembers: any[]) => {
  const updaterId = getLogUpdaterId(log);
  const updaterName = getLogUpdaterName(log).toLowerCase();

  return teamMembers.find((member) => {
    const memberId = cleanDisplayText(member?._id || member?.id);
    const memberName = getPersonName(member).toLowerCase();

    return (
      (updaterId && memberId && updaterId === memberId) ||
      (updaterName && memberName && updaterName === memberName)
    );
  });
};

const getLogUpdaterRole = (log: any, teamMembers: any[] = []): string =>
  getUserRoleLabel(log?.performedBy) ||
  getUserRoleLabel(log?.updatedBy) ||
  getUserRoleLabel(log?.changedBy) ||
  getUserRoleLabel(log?.modifiedBy) ||
  getUserRoleLabel(log?.createdBy) ||
  getUserRoleLabel(log?.actor) ||
  getUserRoleLabel(log?.user) ||
  getUserRoleLabel(findTeamMemberForLog(log, teamMembers)) ||
  getRoleLabel(log?.roleId) ||
  getRoleLabel(log?.role) ||
  cleanDisplayText(log?.roleName || log?.userRole);

// âœ… API function

const getLeadLogActivityVisual = (log: any) => {
  const message = String(log?.message || "");
  const plainText = message
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  const lowerText = plainText.toLowerCase();
  const changedFieldKeys = Array.isArray(log?.details?.changedFields)
    ? log.details.changedFields
        .map((field: any) => String(field?.key || "").toLowerCase())
        .filter(Boolean)
    : [];
  const hasChangedField = (...keys: string[]) =>
    keys.some((key) => changedFieldKeys.includes(key.toLowerCase()));

  if (/whats\s*app|whatsapp/.test(lowerText)) {
    return {
      icon: <WhatsAppOutlined style={{ fontSize: 19 }} />,
      color: "#16a34a",
      backgroundColor: "#dcfce7",
    };
  }
  if (/call connected|call completed|phone call|called/.test(lowerText)) {
    return {
      icon: <PhoneCall size={19} strokeWidth={2.8} />,
      color: "#1677ff",
      backgroundColor: "#dcebff",
    };
  }
  if (
    /email sent|mail sent|sent email|sent mail/.test(lowerText) ||
    hasChangedField("email") ||
    /\bemail\s*:|\bmail\s*:/.test(lowerText)
  ) {
    return {
      icon: <LucideMail size={20} strokeWidth={2.4} />,
      color: "#ef4444",
      backgroundColor: "#fee2e2",
    };
  }
  if (hasChangedField("link") || /\blink\s*:/.test(lowerText)) {
    return {
      icon: <Link2 size={20} strokeWidth={2.4} />,
      color: "#2563eb",
      backgroundColor: "#dbeafe",
    };
  }
  if (
    hasChangedField("description") ||
    /\bdescription\s*:/.test(lowerText)
  ) {
    return {
      icon: <FileText size={20} strokeWidth={2.4} />,
      color: "#64748b",
      backgroundColor: "#f1f5f9",
    };
  }
  if (
    hasChangedField("leadtags") ||
    /\bleadtags\s*:/.test(lowerText) ||
    /tags? updated|changed tags?/.test(lowerText)
  ) {
    return {
      icon: <MessageCircle size={20} strokeWidth={2.4} />,
      color: "#1677ff",
      backgroundColor: "#dbeafe",
    };
  }
  if (/created|added manually|new lead/.test(lowerText)) {
    return {
      icon: <FileTextFilled style={{ fontSize: 19 }} />,
      color: "#7c3aed",
      backgroundColor: "#eadcff",
    };
  }
  if (/proposal|pdf|document|file/.test(lowerText)) {
    return {
      icon: <FileText size={20} strokeWidth={2.4} />,
      color: "#f59e0b",
      backgroundColor: "#ffedd5",
    };
  }
  if (/summary/.test(lowerText) || hasChangedField("summaries")) {
    return {
      icon: <RiAddBoxFill size={19} />,
      color: "#7c3aed",
      backgroundColor: "#f3e8ff",
    };
  }
  if (/status/.test(lowerText) || hasChangedField("leadstatus")) {
    return {
      icon: <LucideTags size={20} strokeWidth={2.4} />,
      color: "#2563eb",
      backgroundColor: "#dbeafe",
    };
  }
  return {
    icon: <Pencil size={18} strokeWidth={2.4} />,
    color: "#047857",
    backgroundColor: "#d1fae5",
  };
};

const RawDataPage = () => {
  const { token } = theme.useToken();

  const SIDEBAR_BLUE = "#0080ff";
  const ACCENT = token?.colorPrimary || SIDEBAR_BLUE;
  const ICON_COLOR = token?.colorTextSecondary || "#475569";
  const IMAGEURL = process.env.REACT_APP_IMAGE_URL + "/developers/";
  const RAWDATA_IMAGEURL = process.env.REACT_APP_IMAGE_URL + "/rawdata/";
  const storedAuthData = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("authData") || "{}");
    } catch {
      return {};
    }
  }, []);
  const isDeveloper =
    storedAuthData?.roleId?.roleId === 2 ||
    storedAuthData?.roleId?.name?.toLowerCase() === "developer";
  const [rawData, setRawData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [dataSource, setDataSource] = useState<any>([]);
  const [totalCount, setTotalCount] = useState<number>(0);

  // modal states
  const [newSummary, setNewSummary] = useState<{
    date: Dayjs | null;
    description: string;
    followUpDate: Dayjs | null;
  }>({
    date: dayjs(),
    description: "",
    followUpDate: dayjs(),
  });
  //Logs
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const [currentLeadLogId, setCurrentLeadLogId] = useState<string | null>(null);
  const [selectedLeadLogs, setSelectedLeadLogs] = useState<any[]>([]);
  const [logsPagination, setLogsPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [logLoading, setLogLoading] = useState(false);
  const [logSearchText, setLogSearchText] = useState("");
  const modalScrollRef = useRef<HTMLDivElement>(null);
  const previewRefs = useRef<(HTMLDivElement | null)[]>([]);

  const dispatch = useDispatch<AppDispatch>();
  const dataSources = useSelector(
    (state: RootState) => state.rawData.dataSource,
  );

  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [currentRawDataId, setcurrentRawDataId] = useState<any>(null);
  const [statuses, setStatuses] = useState<
    Array<{
      _id: string;
      name: string;
      color: string;
      slug: string;
      createdAt: string;
      __v: number;
    }>
  >([]);
  const [searchText, setSearchText] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string[]>([]);
  const [timeFilter, setTimeFilter] = useState<
    "today" | "thisMonth" | "lastMonth" | "custom" | undefined
  >(undefined);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<any>(10); // default 10
  const [showRangePicker, setShowRangePicker] = useState(false);
  const [tempStartDate, setTempStartDate] = useState<Dayjs | null>(null);
  const [tempEndDate, setTempEndDate] = useState<Dayjs | null>(null);
  const [favouriteFilters, setFavouriteFilters] = useState<any[]>([]);
  const [selectedFav, setSelectedFav] = useState<number | null>(null);
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);
  const [summaryData, setSummaryData] = useState<any[]>([]);
  const [currentSummaryrawDataId, setCurrentSummaryrawDataId] = useState<
    string | null
  >(null);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [bulkDelete, setBulkDelete] = useState(false);
  const [priorityFilter, setPriorityFilter] = useState<string | undefined>(
    undefined,
  );
  const [filteredData, setFilteredData] = useState<any[]>();
  const [platform, setplatform] = useState([]);
  const [viewLead, setViewLead] = useState<any | null>(null);
  const [viewLeadLoading, setViewLeadLoading] = useState(false);
  const [viewLeadLogs, setViewLeadLogs] = useState<any[]>([]);
  const [viewLeadLogsLoading, setViewLeadLogsLoading] = useState(false);
  const [viewLeadLogsPagination, setViewLeadLogsPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [activeViewLeadTab, setActiveViewLeadTab] = useState<
    "details" | "summary" | "tags" | "logs"
  >("details");
  const [summaryComposerOpen, setSummaryComposerOpen] = useState(false);
  const [editingSummaryId, setEditingSummaryId] = useState<string | null>(null);
  const [summaryDeleteTarget, setSummaryDeleteTarget] = useState<{
    rawDataId: string;
    summaryId: string;
  } | null>(null);
  const [currentImage, setCurrentImage] = useState("");
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const [newFavName, setNewFavName] = useState("");
  // const [selectedFav, setSelectedFav] = useState<number | null>(null);
  const [selectedFavLabel, setSelectedFavLabel] = useState<string | null>(null);
  const { search, pathname } = useLocation();
  const params = new URLSearchParams(search);
  const filterParam = params.get("filter");
  const filter = filterParam ? JSON.parse(filterParam) : null;
  const slug = params.get("slug");
  const navigate = useNavigate();
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);
  const [platformOptions, setPlatformOptions] = useState<any[]>([]);
  const [developers, setDevelopers] = useState<any[]>([]); // your owners if needed
  const [teamMembers, setTeamMembers] = useState<any[]>([]);
  const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);
  const [descValue, setDescValue] = useState("");
  const [uploadedImages, setUploadedImages] = useState<File[]>([]);
  const [editorFocused, setEditorFocused] = useState(false);
  const [, refreshEditorToolbar] = useState(0);
  const [overflowIndexes, setOverflowIndexes] = useState<number[]>([]);
  const [pinnedLeads, setPinnedLeads] = useState<string[]>([]);
  const [totalValue, setTotalValue] = useState(0);
  const [copiedId, setCopiedId] = useState<string | null>(null);
  const [isClick, setIsClick] = useState<string | null>(null);
  const [isCurrectData, setIsCurrectData] = useState<string | null>(null);
  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
  const [transferDeveloperId, setTransferDeveloperId] = useState<string | null>(
    null,
  );
  const [selectedTargetDeveloper, setSelectedTargetDeveloper] = useState<
    string | null
  >(null);
  const [allTags, setAllTags] = useState<
    Array<{ _id: string; name: string; color: string }>
  >([]);
  const [tagDropdownOpenId, setTagDropdownOpenId] = useState<string | null>(
    null,
  );
  const [addTagDropdownOpenId, setAddTagDropdownOpenId] = useState<
    string | null
  >(null);
  const [drawerStageChain, setDrawerStageChain] = useState<any[]>([]);
  const [removedPipelineStages, setRemovedPipelineStages] = useState<Record<string, string[]>>(() => {
    try {
      const stored = localStorage.getItem("crm_removedPipelineStages");
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  });
  const viewLeadRequestRef = useRef<string | null>(null);
  const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [sectionEditVisible, setSectionEditVisible] = useState<null | "basic" | "description" | "source">(null);
  const [sectionEditForm] = Form.useForm();
  const [sectionEditLoading, setSectionEditLoading] = useState(false);
  const [sectionSources, setSectionSources] = useState<any[]>([]);
  const statusScrollRef = useRef<HTMLDivElement>(null);
  const pipelineScrollRef = useRef<HTMLDivElement>(null);
  const summaryPanelRef = useRef<HTMLDivElement>(null);
  const addSummaryBtnRef = useRef<HTMLButtonElement>(null);
  const syncingStageScrollRef = useRef(false);

  dayjs.extend(customParseFormat);
  dayjs.extend(utc);

  const syncStageScroll = (
    sourceRef: React.RefObject<HTMLDivElement>,
    targetRef: React.RefObject<HTMLDivElement>,
  ) => {
    if (syncingStageScrollRef.current) return;

    const source = sourceRef.current;
    const target = targetRef.current;
    if (!source || !target) return;

    const sourceMaxScroll = source.scrollWidth - source.clientWidth;
    const targetMaxScroll = target.scrollWidth - target.clientWidth;
    const nextScrollLeft =
      sourceMaxScroll > 0
        ? (source.scrollLeft / sourceMaxScroll) * Math.max(targetMaxScroll, 0)
        : 0;

    syncingStageScrollRef.current = true;
    target.scrollLeft = nextScrollLeft;
    window.requestAnimationFrame(() => {
      syncingStageScrollRef.current = false;
    });
  };

  const fetchDevelopers = async () => {
    try {
      const res = await getallDeveloperForTask("", "");
      if (res.data) {
        setTeamMembers(res.data || []);
        // Owners (if needed for other columns)
        const owners = res.data.filter((dev: any) => dev.isOwner === true);
        setDevelopers(owners);
      }
    } catch (err) {
      console.error("Error fetching developers:", err);
    }
  };

  // Developer options for transfer
  const developerTransferOptions = developers
    .filter((dev) => dev._id !== transferDeveloperId)
    .map((dev) => ({
      label: dev.username,
      value: dev._id,
    }));

  const sortedData = useMemo(() => {
    if (!rawData?.length) return [];

    return [...rawData].sort((a: any, b: any) => {
      const aPinned = pinnedLeads.includes(a.leadCode);
      const bPinned = pinnedLeads.includes(b.leadCode);

      // pinned items first
      if (aPinned && !bPinned) return -1;
      if (!aPinned && bPinned) return 1;

      // keep original order if both pinned or both unpinned
      return 0;
    });
  }, [rawData, pinnedLeads]);

  const formatDateTime = (value?: string | Date | null) => {
    if (!value) return "—";

    console.log("Date:", value);

    let d;

    // Case 1: old data → "DD-MM-YYYY"
    if (typeof value === "string" && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
      d = dayjs(value, "DD-MM-YYYY", true);
      if (!d.isValid()) return "—";
      return d.format("DD-MM-YYYY");
    }

    // Case 2: ISO date with time (new data)
    d = dayjs(value);
    if (!d.isValid()) return "—";

    const hasTime =
      typeof value === "string" &&
      value.includes("T") &&
      !value.endsWith("T00:00:00.000Z");

    return hasTime ? d.format("DD-MM-YYYY HH:mm") : d.format("DD-MM-YYYY");
  };

  const handlePinClick = async (leadCode: string) => {
    try {
      const res = await addPinLead(leadCode);
      setPinnedLeads(res.pinnedLeads); // always sync with backend
      // Refetch from page 1 so the (un)pinned lead is re-ordered by the
      // backend and a newly pinned lead floats to the top of the list.
      setPage(1);
      fetchRawData({ ...activeFilters, page: 1 });
    } catch {
      message.error("Failed to update pin");
    }
  };

  useEffect(() => {
    const loadPins = async () => {
      const pins = await getPinnedLeads();
      setPinnedLeads(pins);
    };

    loadPins();
  }, []);

  const addImage = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = true;
    input.click();

    input.onchange = () => {
      const files = Array.from(input.files || []);
      const imageFiles = files.filter((file) => file.type.startsWith("image/"));

      // Add all images to uploaded images at once
      setUploadedImages((prev) => [...prev, ...imageFiles]);

      // Insert images one by one
      imageFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          editor
            ?.chain()
            .focus()
            .setImage({
              src: reader.result as string,
              alt: file.name,
              title: file.name,
              width: 300,
            })
            .run();
        };
        reader.readAsDataURL(file);
      });
    };
  };
  const scrollRef = useRef<HTMLDivElement>(null);

  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: false,
        // Don't disable these - let them work normally
        bulletList: {
          HTMLAttributes: {
            class: "bullet-list",
          },
        },
        orderedList: {
          HTMLAttributes: {
            class: "ordered-list",
          },
        },
      }),

      Heading.configure({
        levels: [1, 2, 3],
      }),

      Underline,
      Link.configure({
        openOnClick: true,
        HTMLAttributes: { class: "text-blue-500 underline" },
      }),

      TiptapImage.extend({
        addAttributes() {
          return {
            src: { default: null },
            alt: { default: null },
            title: { default: null },
            width: {
              default: 300,
              renderHTML: (attributes: any) => ({
                width: attributes.width,
                style: `width: ${attributes.width}px; height: auto; max-width: 100%;`,
              }),
            },
            height: { default: "auto" },
          };
        },
      }).configure({
        inline: false,
        HTMLAttributes: {
          class: "rounded-md",
          style: "max-width: 100%; height: auto;",
        },
      }),

      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),

      Placeholder.configure({
        placeholder: "Enter description...",
      }),
    ],

    content: descValue || "",

    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      // const text = editor.getText(); // Get plain text
      setDescValue(html);
    },

    onSelectionUpdate: () => {
      refreshEditorToolbar((version) => version + 1);
    },

    onTransaction: () => {
      refreshEditorToolbar((version) => version + 1);
    },

    editorProps: {
      handlePaste(view, event) {
        const items = Array.from(event.clipboardData?.items || []);
        let imageProcessed = false;

        for (const item of items) {
          if (item.type.startsWith("image/")) {
            event.preventDefault();
            const file = item.getAsFile();
            if (!file) continue;

            setUploadedImages((prev) => [...prev, file]);

            const reader = new FileReader();
            reader.onload = () => {
              const transaction = view.state.tr.insert(
                view.state.selection.from,
                view.state.schema.nodes.image.create({
                  src: reader.result,
                  alt: "Pasted image",
                  title: "Pasted image",
                  width: 300,
                }),
              );
              view.dispatch(transaction);
            };
            reader.readAsDataURL(file);
            imageProcessed = true;
            break;
          }
        }
        return imageProcessed;
      },

      handleDrop(view, event) {
        if (event.dataTransfer?.files) {
          const files = Array.from(event.dataTransfer.files);
          let imageProcessed = false;

          files.forEach((file) => {
            if (file.type.startsWith("image/")) {
              event.preventDefault();
              imageProcessed = true;

              setUploadedImages((prev) => [...prev, file]);

              const reader = new FileReader();
              reader.onload = () => {
                const coordinates = view.posAtCoords({
                  left: event.clientX,
                  top: event.clientY,
                });

                if (coordinates) {
                  const transaction = view.state.tr.insert(
                    coordinates.pos,
                    view.state.schema.nodes.image.create({
                      src: reader.result,
                      alt: file.name,
                      title: file.name,
                      width: 300,
                    }),
                  );
                  view.dispatch(transaction);
                }
              };
              reader.readAsDataURL(file);
            }
          });

          return imageProcessed;
        }
        return false;
      },
    },
  });

  // Replace the Toolbar component
  // Add this inside your RawData component

  const Toolbar = () => {
    if (!editor) return null;

    const addImage = () => {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.multiple = true;
      input.click();

      input.onchange = () => {
        const files = Array.from(input.files || []);
        const imageFiles = files.filter((file) =>
          file.type.startsWith("image/"),
        );

        setUploadedImages((prev) => [...prev, ...imageFiles]);

        imageFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = () => {
            editor
              ?.chain()
              .focus()
              .setImage({
                src: reader.result as string,
                alt: file.name,
                title: file.name,
                width: 300,
              })
              .run();
          };
          reader.readAsDataURL(file);
        });
      };
    };

    return (
      <div className="border-b border-gray-200 p-2 flex flex-wrap items-center gap-1 bg-gray-50">
        {/* Text formatting */}
        <Button
          type={editor.isActive("bold") ? "primary" : "default"}
          size="small"
          onClick={() => editor.chain().focus().toggleBold().run()}
          title="Bold"
        >
          <strong>B</strong>
        </Button>
        <div className="flex items-center gap-1 pr-2">
          <Button
            type={editor.isActive("bulletList") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            title="Bullet List"
          >
            • List
          </Button>
          <Button
            type={editor.isActive("paragraph") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().setParagraph().run()}
            title="Paragraph"
          >
            P
          </Button>
          {
            <Button
              type={editor.isActive("italic") ? "primary" : "default"}
              size="small"
              onClick={() => editor.chain().focus().toggleItalic().run()}
              title="Italic"
            >
              <em>I</em>
            </Button>
          }
          {
            <Button
              type={editor.isActive("underline") ? "primary" : "default"}
              size="small"
              onClick={() => editor.chain().focus().toggleUnderline().run()}
              title="Underline"
            >
              <u>U</u>
            </Button>
          }
          <Button
            type={editor.isActive("strike") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleStrike().run()}
            title="Strikethrough"
          >
            <s>S</s>
          </Button>
        </div>

        {/* Headings */}
        <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          <Button
            type={
              editor.isActive("heading", { level: 1 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 1 }).run()
            }
            title="Heading 1"
          >
            H1
          </Button>
          <Button
            type={
              editor.isActive("heading", { level: 2 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 2 }).run()
            }
            title="Heading 2"
          >
            H2
          </Button>
          <Button
            type={
              editor.isActive("heading", { level: 3 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 3 }).run()
            }
            title="Heading 3"
          >
            H3
          </Button>
          <Button
            type={editor.isActive("paragraph") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().setParagraph().run()}
            title="Paragraph"
          >
            P
          </Button>
        </div>

        {/* Lists */}
        <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          <Button
            type={editor.isActive("bulletList") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            title="Bullet List"
          >
            • List
          </Button>
          <Button
            type={editor.isActive("orderedList") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
            title="Numbered List"
          >
            1. List
          </Button>
        </div>

        {/* Media */}
        {/* <div className="flex items-center gap-1">
          <Button
            size="small"
            onClick={addImage}
            title="Insert Image"
            icon={<UploadOutlined />}
          >
            Image
          </Button>
        </div> */}
      </div>
    );
  };
  // Call this function on component mount
  useEffect(() => {
    fetchDevelopers();
  }, []);

  useEffect(() => {
    const newOverflowIndexes: number[] = [];
    previewRefs.current.forEach((el, idx) => {
      if (el && el.scrollHeight > el.clientHeight) {
        newOverflowIndexes.push(idx);
      }
    });
    setOverflowIndexes(newOverflowIndexes);
  }, [summaryData]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [summaryData]);
  useLayoutEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        const el = textRef.current;
        setIsOverflow(
          el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight,
        );
      }
    };

    checkOverflow();

    // Optional: observe resize if content or container changes
    const resizeObserver = new ResizeObserver(checkOverflow);
    if (textRef.current) {
      resizeObserver.observe(textRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [newSummary.description]);

  const [sortConfig, setSortConfig] = useState<{
    field: string;
    direction: SortOrder;
  }>({
    field: "date",
    direction: "descend",
  });
  const [activeFilters, setActiveFilters] = useState<any>({});
  // 🔹 Function to open modal
  const handleViewSummary = async (rawDataId: string) => {
    setCurrentSummaryrawDataId(rawDataId);
    setIsSummaryModalOpen(true);
    setSummaryLoading(true);

    try {
      // ✅ Use your API function
      const res = await getRawDataById(rawDataId);

      // assuming summaries are stored in `res.data.summaries`
      const summaries = res?.data?.summaries || [];
      setSummaryData(summaries);
      if (viewLeadRequestRef.current === rawDataId) {
        setViewLead((previous: any) =>
          previous ? { ...previous, summaries } : previous,
        );
      }
    } catch (err) {
      console.error("Error fetching summary:", err);
      setSummaryData([]);
    } finally {
      setSummaryLoading(false);
    }
  };

  // Reusable Avatar component
  const UserAvatar = ({ user }: { user: any }) => {
    const [imgError, setImgError] = React.useState(false);

    if (!user) return <span>-</span>;

    const imageUrl = user?.photo ? `${IMAGEURL}${user.photo}` : null;

    return (
      <Tooltip title={user?.username}>
        <Image
          src={!imgError && imageUrl ? imageUrl : undefined} // only show if no error
          alt={user?.username?.[0]?.toUpperCase()}
          width={32}
          height={32}
          // style={{ cursor: "pointer" }}
          style={{ cursor: "pointer", borderRadius: "50%" }} // ⬅ makes image round
          onError={() => {
            setImgError(true); // trigger fallback
            return false; // Avatar uses children fallback
          }}
        />
      </Tooltip>
    );
  };

  // ✅ Fetch data
  const fetchRawData = async (params: any = {}, overrideState = false) => {
    try {
      setLoading(true);

      // If lead ID is in URL, only fetch that specific lead data
      const currentParams = new URLSearchParams(window.location.search);
      const leadParam = currentParams.get("lead");
      if (leadParam) {
        const res = await getAllRawData({ ids: leadParam.split(",") });
        const data = Array.isArray(res.data) ? res.data : [res.data];
        setRawData(data);
        setTotalCount(data.length);
        setTotalValue(
          data.reduce(
            (sum: number, item: any) => sum + (item.leadValue || 0),
            0,
          ),
        );
        applyPagination(data, 1);
        return;
      }

      const query = {
        searchText: params.searchText || "",
        source: params.source || [],
        sourceid: params.sourceid || [],
        priority: params.priority || [],
        country: params.country || [],
        status: params.status || [],
        tags: params.tags || [],
        owner: params.owner || [],
        assignee: params.Assignee || "",
        timeFilter: params.timeFilter || null,
        startDate: params.startDate,
        endDate: params.endDate,
        followupdate: params.followupdate || null,
        followupstartDate: params.followupstartDate,
        followupendDate: params.followupendDate,

        sortField: params.sortField,
        sortOrder: params.sortOrder,

        page: params.page || page,
        limit: params.limit || pageSize,
      };

      const res = await getAllRawDataForPin(query);

      setRawData(res.data);
      setTotalCount(res.totalRecords || res.data.length);
      // Use totalLeadValue from backend (sum across ALL records, not just current page)
      setTotalValue(res.totalLeadValue || 0);
    } catch (error) {
      message.error("Failed to fetch raw data");
    } finally {
      setLoading(false);
    }
  };

  const applyPagination = (data: any[], page: number) => {
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    setDataSource(data.slice(start, end));
  };

  const onPageChange = (page: number) => {
    applyPagination(rawData, page);
  };

  useEffect(() => {
    const params = new URLSearchParams(search);

    if (pathname === "/rawdata") {
      const leadId = params.get("lead") || params.get("leadId");
      if (leadId) {
        // Fetch one or more leads by ID (backend supports comma-separated IDs)
        const fetchSingleLead = async () => {
          setLoading(true);
          try {
            const res = await getAllRawData({ ids: leadId.split(",") });

            // Backend may return an object for a single lead, or an array when multiple IDs are provided.
            const data = Array.isArray(res.data) ? res.data : [res.data];

            setRawData(data);
            setTotalCount(data.length);
            setTotalValue(
              data.reduce(
                (sum: number, item: any) => sum + (item.leadValue || 0),
                0,
              ),
            );
            applyPagination(data, 1);
          } catch (error) {
            message.error("Failed to fetch lead data");
            setRawData([]);
            setTotalCount(0);
            setTotalValue(0);
            setDataSource([]);
          } finally {
            setLoading(false);
          }
        };
        fetchSingleLead();
      } else {
        // Check if there are any query params
        const hasQueryParams = Array.from(params.keys()).length > 0;

        if (hasQueryParams) {
          // Build filter from query params
          const filter = {
            searchText: searchText || "",
            source: params.get("source")
              ? params.get("source")!.split(",")
              : [],
            sourceid: params.get("sourceid")
              ? params.get("sourceid")!.split(",")
              : [],
            priority: params.get("priority")
              ? params.get("priority")!.split(",")
              : [],
            country: params.get("country")
              ? params.get("country")!.split(",")
              : [],
            status: params.get("status")
              ? params.get("status")!.split(",")
              : [],
            tags: params.get("tags") ? params.get("tags")!.split(",") : [],
            owner: params.get("owner") ? params.get("owner")!.split(",") : [],
            Assignee: params.get("Assignee") ? params.get("Assignee") : "",
            timeFilter: params.get("time") || null,
            startDate: params.get("startDate")
              ? dayjs(params.get("startDate")).format("YYYY-MM-DD")
              : undefined,
            endDate: params.get("endDate")
              ? dayjs(params.get("endDate")).format("YYYY-MM-DD")
              : undefined,
            followupdate: params.get("followupdate") || null,
            followupstartDate: params.get("followupstartDate")
              ? dayjs(params.get("followupstartDate")).format("YYYY-MM-DD")
              : undefined,
            followupendDate: params.get("followupendDate")
              ? dayjs(params.get("followupendDate")).format("YYYY-MM-DD")
              : undefined,
            page,
            // sortField: sortField,
            // sortOrder: sortOrder
          };
          setActiveFilters(filter);
          fetchRawData(filter, true);
        } else {
          // No query params: use default search/filter
          const filter = {
            searchText: searchText || "",
            page,
            limit: pageSize, // 👈 dynamic
          };
          setActiveFilters(filter);
          fetchRawData(filter, true);
        }
      }
    }
  }, [search, searchText, pathname]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    // Update sort config
    const { field, order } = sorter;
    const newSort = field && order ? { field, direction: order } : sortConfig;
    setSortConfig(newSort);

    // Keep the controlled `current` page in sync, otherwise the table's
    // active page indicator stays stuck on page 1 and paging breaks.
    setPage(pagination.current);

    // Merge filters from state + pagination + sorting
    fetchRawData({
      ...activeFilters, // keep existing filters
      page: pagination.current,
      limit: pagination.pageSize || 10,
      sortField: newSort.field,
      sortOrder: newSort.direction === "ascend" ? "asc" : "desc",
    });
  };

  const handleSearch = (value: string) => {
    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    
    // Set new timeout - search only after user stops typing for 500ms
    searchTimeoutRef.current = setTimeout(() => {
      setSearchText(value);
      setPage(1);
    }, 500);
  };

  const fetchStatuses = async () => {
    try {
      if (isDeveloper) {
        setStatuses([]);
        return;
      }

      const response = await getLeadStatus();
      setStatuses(response.data || []);
    } catch (error) {
      console.error("Error fetching statuses:", error);
      message.error("Failed to fetch lead statuses");
    }
  };

  const fetchAllTags = async () => {
    try {
      const response = await getAllTags();
      setAllTags(response.tags || []);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  useEffect(() => {
    fetchStatuses();
    fetchAllTags();
  }, []);

  useEffect(() => {
    if (viewLead) {
      const sv = viewLead.leadstatus;
      const initial = sv
        ? typeof sv === "object"
          ? sv
          : { name: sv, color: "#16a34a" }
        : null;
      try {
        const stored = localStorage.getItem("crm_drawerStageChain");
        const map = stored ? JSON.parse(stored) : {};
        if (map[viewLead._id]?.length > 0) {
          setDrawerStageChain(map[viewLead._id]);
          return;
        }
      } catch {}
      setDrawerStageChain(initial ? [initial] : []);
    } else {
      setDrawerStageChain([]);
    }
  }, [viewLead?._id]);

  useEffect(() => {
    if (!viewLead?._id) return;
    try {
      const stored = localStorage.getItem("crm_drawerStageChain");
      const map = stored ? JSON.parse(stored) : {};
      map[viewLead._id] = drawerStageChain;
      localStorage.setItem("crm_drawerStageChain", JSON.stringify(map));
    } catch {}
  }, [drawerStageChain, viewLead?._id]);

  useEffect(() => {
    localStorage.setItem("crm_removedPipelineStages", JSON.stringify(removedPipelineStages));
  }, [removedPipelineStages]);

  useLayoutEffect(() => {
    if (activeViewLeadTab !== "summary") return;
    const panel = summaryPanelRef.current;
    const btn = addSummaryBtnRef.current;
    if (panel) panel.scrollTop = panel.scrollHeight;
    if (btn) btn.focus({ preventScroll: true });
  }, [activeViewLeadTab]);

  useEffect(() => {
    if (!sectionEditVisible || !viewLead) return;
    if (sectionEditVisible === "basic") {
      sectionEditForm.setFieldsValue({
        contactName: viewLead.contactName || viewLead.title || "",
        company: viewLead.company || "",
        phone: viewLead.phone || "",
        email: viewLead.email || "",
        country: viewLead.country || viewLead.location || viewLead.city || "",
      });
    } else if (sectionEditVisible === "description") {
      sectionEditForm.setFieldsValue({ description: viewLead.description || "" });
    } else if (sectionEditVisible === "source") {
      getAllSources("", 1).then((res) => {
        const filtered = (res.sources || []).filter((s: any) =>
          Array.isArray(s.category) ? s.category.includes("Sales") : true
        );
        setSectionSources(filtered);
      }).catch(() => {});
      sectionEditForm.setFieldsValue({
        leadSource: viewLead.leadSource?._id || viewLead.leadSource || undefined,
        link: viewLead.link || "",
      });
    }
  }, [sectionEditVisible, viewLead]);

  const handleSectionEditSubmit = async (values: any) => {
    if (!viewLead?._id) return;
    setSectionEditLoading(true);
    try {
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        if (values[key] !== undefined && values[key] !== null) {
          formData.append(key, values[key]);
        }
      });
      await updateRawData(viewLead._id, formData);
      message.success("Updated successfully!");
      setSectionEditVisible(null);
      sectionEditForm.resetFields();
      await fetchViewLeadDetails(viewLead._id);
    } catch {
      message.error("Failed to update.");
    } finally {
      setSectionEditLoading(false);
    }
  };

  // add modal
  const handleAddRawData = () => {
    setIsAddModalVisible(true);
  };

  const handleCreate = async () => {
    setIsAddModalVisible(false);
    await fetchRawData({ ...activeFilters, page });
  };

  const LOCAL_STORAGE_KEY = "Filters";
  const getFavouriteFilters = (): any[] => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  };

  const saveFavouriteFilters = (filters: any[]) => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(filters));
  };

  const addFavouriteFilter = (fav: any) => {
    if (!fav.label.trim()) return;

    const filters = getFavouriteFilters();
    filters.push(fav);
    saveFavouriteFilters(filters);
    setFavouriteFilters(filters);
    message.success("Favorite filter saved!");
  };

  const deleteFavouriteFilter = (id: number) => {
    const filters = getFavouriteFilters().filter((f) => f.id !== id);
    saveFavouriteFilters(filters);
    setFavouriteFilters(filters);
    message.success("Filter deleted!");
  };

  // edit modal
  const handleEdit = (record: any) => {
    setcurrentRawDataId(record);
    setIsEditModalVisible(true);
  };

  const handleUpdate = async (updatedLead?: any) => {
    setIsEditModalVisible(false);
    const updatedLeadData = updatedLead?.data || updatedLead;
    const editedRawDataId =
      updatedLeadData?._id || currentRawDataId?._id || currentRawDataId;
    const shouldRefreshViewLead =
      editedRawDataId && viewLeadRequestRef.current === editedRawDataId;

    if (shouldRefreshViewLead && updatedLeadData?._id) {
      setViewLead((previous: any) =>
        previous ? { ...previous, ...updatedLeadData } : updatedLeadData,
      );
    }

    // merge page with current activeFilters
    const params = {
      ...activeFilters,
      page, // overwrite page if needed
    };

    await Promise.all([
      fetchRawData(params),
      shouldRefreshViewLead
        ? refreshOpenViewLeadActivity(editedRawDataId)
        : Promise.resolve(),
    ]);
  };

  const handleDeleteConfirmation = (id: string) => {
    setDeleteId(id);
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await deleteRawData(deleteId);
      message.success("RawData deleted successfully");
      fetchRawData({ ...activeFilters, page });
    } catch (error) {
      message.error("Failed to delete lead");
      console.error("Delete error:", error);
      fetchRawData({ ...activeFilters, page });
    } finally {
      setDeleteId(null);
    }
  };

  const handleTransferRawData = async () => {
    if (!selectedTargetDeveloper || !transferDeveloperId) {
      message.error("Please select a target developer");
      return;
    }
    try {
      await transferRawData(transferDeveloperId, selectedTargetDeveloper);
      message.success("Leads transferred successfully");
      setIsTransferModalOpen(false);
      setSelectedTargetDeveloper(null);
      setTransferDeveloperId(null);
      // Refresh data
      fetchRawData({ ...activeFilters, page });
    } catch (error) {
      console.error("Error transferring leads:", error);
      message.error("Failed to transfer leads");
    }
  };

  const handleStatusFilterChange = (value: any) => {
    // console.log(value)
    setStatusFilter((prev) => {
      const newStatus = prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value];

      // Fetch data with new status filter
      fetchRawData({ status: newStatus, page: 1 });

      return newStatus;
    });
    setPage(1);
  };

  const statusOptions = statuses.map((status) => ({
    value: status.slug,
    id: status._id,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div
          style={{
            width: "12px",
            height: "12px",
            backgroundColor: status.color,
            borderRadius: "2px",
          }}
        />
        <span>{status.name}</span>
      </div>
    ),
  }));

  //@ts-ignore
  const handleStatusChange = async (rawdataId: string, statusName: string) => {
    try {
      const newStatus = statuses.find((status) => status.name === statusName);
      if (!newStatus) {
        message.error("Selected status not found");
        return;
      }

      // Optimistic UI update via Redux
      dispatch(updateRawDataStatus({ rawdataId, newStatus }));

      // Build FormData for backend update
      const formData = new FormData();
      formData.append("leadstatus", newStatus._id);

      // Update backend
      await updateRawData(rawdataId, formData);

      // Refetch latest and sync Redux
      await Promise.all([
        fetchRawData({
          ...activeFilters,
          page,
          limit: pageSize,
          sortField: sortConfig.field,
          sortOrder: sortConfig.direction === "ascend" ? "asc" : "desc",
        }),
        refreshOpenViewLeadActivity(rawdataId),
      ]);

      message.success(`Status updated to ${newStatus.name} `);
    } catch (error) {
      console.error("Error updating lead status:", error);
      message.error("Failed to update lead status");
    }
  };

  const handleClearLeadStatus = async (rawdataId: string) => {
    try {
      dispatch(updateRawDataStatus({ rawdataId, newStatus: null }));
      const formData = new FormData();
      formData.append("leadstatus", "");
      await updateRawData(rawdataId, formData);
      await Promise.all([
        fetchRawData({
          ...activeFilters,
          page,
          limit: pageSize,
          sortField: sortConfig.field,
          sortOrder: sortConfig.direction === "ascend" ? "asc" : "desc",
        }),
        refreshOpenViewLeadActivity(rawdataId),
      ]);
      message.success("Stage removed");
    } catch (error) {
      console.error("Error clearing lead status:", error);
      message.error("Failed to remove stage");
    }
  };

  const handleRemoveTag = async (
    leadId: string,
    tagId: string,
    currentTags: any[],
  ) => {
    try {
      const getTagId = (tag: any) =>
        String(tag?._id || tag?.id || tag?.value || tag || "");
      const normalizedTagId = String(tagId);
      const updatedTagObjects = (currentTags || []).filter(
        (tag: any) => getTagId(tag) !== normalizedTagId,
      );
      const updatedTags = updatedTagObjects.map(getTagId).filter(Boolean);
      const formData = new FormData();
      formData.append("leadTags", JSON.stringify(updatedTags));
      await updateRawData(leadId, formData);
      setViewLead((previous: any) =>
        previous && String(previous._id) === String(leadId)
          ? { ...previous, leadTags: updatedTagObjects }
          : previous,
      );
      await Promise.all([
        fetchRawData({ ...activeFilters, page, limit: pageSize }),
        refreshOpenViewLeadActivity(leadId),
      ]);
    } catch {
      message.error("Failed to remove tag");
    }
  };

  const handleChangeTag = async (
    leadId: string,
    oldTagId: string,
    newTagId: string,
    currentTags: any[],
  ) => {
    try {
      const updatedTags = currentTags.map((t: any) =>
        t._id === oldTagId ? newTagId : t._id,
      );
      const formData = new FormData();
      formData.append("leadTags", JSON.stringify(updatedTags));
      await updateRawData(leadId, formData);
      setTagDropdownOpenId(null);
      await Promise.all([
        fetchRawData({ ...activeFilters, page, limit: pageSize }),
        refreshOpenViewLeadActivity(leadId),
      ]);
    } catch {
      message.error("Failed to update tag");
    }
  };

  const handleAddTag = async (
    leadId: string,
    newTagId: string,
    currentTags: any[],
  ) => {
    try {
      if (currentTags.some((t: any) => t._id === newTagId)) return;
      const updatedTags = [...currentTags.map((t: any) => t._id), newTagId];
      const formData = new FormData();
      formData.append("leadTags", JSON.stringify(updatedTags));
      await updateRawData(leadId, formData);
      setAddTagDropdownOpenId(null);
      await Promise.all([
        fetchRawData({ ...activeFilters, page, limit: pageSize }),
        refreshOpenViewLeadActivity(leadId),
      ]);
    } catch {
      message.error("Failed to add tag");
    }
  };

  const timeFilterOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" }, // âœ… New
    { value: "last7days", label: "Last 7 Days" }, // âœ… New
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "Last3Month", label: "Last 3 Month" },
    { value: "Last6Month", label: "Last 6 Month" },
  ];

  // Function
  const handleUpdatePriority = async (
    id: string,
    field: string,
    value: string,
    label: string,
  ) => {
    try {
      const formData = new FormData();
      formData.append(field, value);

      const response = await updateRawData(id, formData);

      if (response) {
        message.success(`${label} updated to ${value}`);
        await Promise.all([
          fetchRawData({ ...activeFilters, page }),
          refreshOpenViewLeadActivity(id),
        ]);
      } else {
        message.error(`Failed to update ${label}`);
      }
    } catch (error) {
      console.error(error);
      message.error(`Error updating ${label}`);
    }
  };

  const handleUpdateField = async (
    id: string,
    field: string,
    value: any, // can be string, array, or object
    label: string,
  ) => {
    try {
      const formData = new FormData();

      // If value is an object or array, convert to JSON string
      if (typeof value === "object") {
        formData.append(field, JSON.stringify(value));
      } else {
        formData.append(field, value);
      }

      const response = await updateRawData(id, formData);

      if (response) {
        message.success(`${label} updated successfully`);
        const params = {
          ...activeFilters,
          page, // overwrite page if needed
        };

        await Promise.all([
          fetchRawData(params),
          refreshOpenViewLeadActivity(id),
        ]);
      } else {
        message.error(`Failed to update ${label}`);
      }
    } catch (error) {
      console.error(error);
      message.error(`Error updating ${label}`);
    }
  };

  const fetchViewLeadDetails = async (rawDataId: string) => {
    setViewLeadLoading(true);
    try {
      const res = await getRawDataById(rawDataId);
      const leadDetails = res?.data || res;

      if (viewLeadRequestRef.current === rawDataId) {
        setViewLead((previous: any) =>
          previous ? { ...previous, ...leadDetails } : leadDetails,
        );
      }
    } catch (error) {
      console.error("Error fetching lead details:", error);
    } finally {
      if (viewLeadRequestRef.current === rawDataId) {
        setViewLeadLoading(false);
      }
    }
  };

  const fetchViewLeadLogs = async (leadId: string, page = 1) => {
    setViewLeadLogsLoading(true);
    try {
      const data = await getRawDataLog(
        leadId,
        page,
        viewLeadLogsPagination.pageSize,
        "",
        "CRM",
      );

      if (viewLeadRequestRef.current === leadId) {
        setViewLeadLogs(data?.logs || []);
        setViewLeadLogsPagination((prev) => ({
          ...prev,
          current: page,
          total: data?.pagination?.total || 0,
          pageSize: data?.pagination?.pageSize || prev.pageSize,
        }));
      }
    } catch (error) {
      console.error("Failed to fetch drawer lead logs:", error);
      if (viewLeadRequestRef.current === leadId) {
        setViewLeadLogs([]);
        setViewLeadLogsPagination((prev) => ({
          ...prev,
          current: page,
          total: 0,
        }));
      }
    } finally {
      if (viewLeadRequestRef.current === leadId) {
        setViewLeadLogsLoading(false);
      }
    }
  };

  const refreshOpenViewLeadActivity = async (rawDataId: string) => {
    if (!rawDataId || viewLeadRequestRef.current !== rawDataId) return;

    await Promise.all([
      fetchViewLeadDetails(rawDataId),
      fetchViewLeadLogs(rawDataId),
    ]);
  };

  const resetSummaryForm = () => {
    editor?.commands.clearContent();
    setDescValue("");
    setNewSummary({
      date: dayjs(),
      description: "",
      followUpDate: null,
    });
    setEditingSummaryId(null);
  };

  const openSummaryComposer = () => {
    resetSummaryForm();
    setSummaryComposerOpen(true);
  };

  const closeSummaryComposer = () => {
    resetSummaryForm();
    setSummaryComposerOpen(false);
  };

  const openSummaryComposerForEdit = (summary: any) => {
    const description = summary?.description || summary?.summary || "";
    const parsedDate = summary?.date ? dayjs(summary.date) : null;
    const parsedFollowUpDate = summary?.followUpDate
      ? dayjs(summary.followUpDate)
      : summary?.nextActionDate
        ? dayjs(summary.nextActionDate)
        : null;
    editor?.commands.setContent(description);
    setDescValue(description);
    setNewSummary({
      date: parsedDate?.isValid() ? parsedDate : dayjs(),
      description,
      followUpDate: parsedFollowUpDate?.isValid() ? parsedFollowUpDate : null,
    });
    setEditingSummaryId(summary?._id || null);
    setSummaryComposerOpen(true);

    requestAnimationFrame(() => {
      editor?.chain().focus("end").run();
    });
  };

  const handleConfirmDeleteSummary = async () => {
    if (!summaryDeleteTarget) return;

    const { rawDataId, summaryId } = summaryDeleteTarget;

    try {
      setSummaryLoading(true);
      await deleteRawDataSummary(rawDataId, summaryId);
      message.success("Summary deleted successfully");

      const res = await getRawDataById(rawDataId);
      const summaries = res?.data?.summaries || [];
      setSummaryData(summaries);

      if (viewLeadRequestRef.current === rawDataId) {
        setViewLead((previous: any) =>
          previous ? { ...previous, summaries } : previous,
        );
        await fetchViewLeadLogs(rawDataId);
      }

      if (String(editingSummaryId) === String(summaryId)) {
        closeSummaryComposer();
      }
      setSummaryDeleteTarget(null);
    } catch (err: any) {
      message.error(err.response?.data?.message || "Error deleting summary");
    } finally {
      setSummaryLoading(false);
    }
  };

  const handleDrawerAddSummary = async () => {
    const rawDataId = viewLead?._id || currentSummaryrawDataId;
    if (!rawDataId) return;

    const htmlContent = editor?.getHTML() || "";
    const plainText = editor?.getText().trim() || "";

    if (!plainText || htmlContent === "<p></p>") {
      message.error("Please enter a description");
      return;
    }

    try {
      setSummaryLoading(true);
      const formData = new FormData();
      const summaryPayload = {
        ...(editingSummaryId ? { summaryId: editingSummaryId } : {}),
        description: htmlContent,
        date: newSummary.date?.toISOString() || dayjs().toISOString(),
        ...(newSummary.followUpDate
          ? { followUpDate: newSummary.followUpDate.toISOString() }
          : {}),
      };
      formData.append(
        editingSummaryId ? "editSummary" : "newSummary",
        JSON.stringify(summaryPayload),
      );

      await updateRawData(rawDataId, formData);
      message.success(
        editingSummaryId
          ? "Summary updated successfully"
          : "Summary added successfully",
      );

      resetSummaryForm();
      setSummaryComposerOpen(false);

      const res = await getRawDataById(rawDataId);
      const summaries = res?.data?.summaries || [];
      setSummaryData(summaries);

      if (viewLeadRequestRef.current === rawDataId) {
        setViewLead((previous: any) =>
          previous ? { ...previous, summaries } : previous,
        );
        await fetchViewLeadLogs(rawDataId);
      }
    } catch (err: any) {
      message.error(
        err.response?.data?.message ||
          (editingSummaryId
            ? "Error updating summary"
            : "Error adding summary"),
      );
    } finally {
      setSummaryLoading(false);
    }
  };

  const closeViewDrawer = () => {
    viewLeadRequestRef.current = null;
    setIsViewModalVisible(false);
    setViewLead(null);
    setViewLeadLogs([]);
    setViewLeadLogsPagination({ current: 1, pageSize: 5, total: 0 });
    setViewLeadLoading(false);
    setViewLeadLogsLoading(false);
    setActiveViewLeadTab("details");
    setSummaryComposerOpen(false);
    setSummaryDeleteTarget(null);
    resetSummaryForm();
    setDrawerStageChain([]);
  };

  const handleView = (record: any) => {
    viewLeadRequestRef.current = record._id;
    setViewLead(record);
    setViewLeadLogs([]);
    setViewLeadLogsPagination({ current: 1, pageSize: 5, total: 0 });
    setActiveViewLeadTab("details");
    setSummaryComposerOpen(false);
    resetSummaryForm();
    setCurrentImage(record.profilePhoto || "download.png");
    setIsViewModalVisible(true);
    fetchViewLeadDetails(record._id);
    fetchViewLeadLogs(record._id);
  };
  // const resetFilters = () => {
  //   fetchRawData({});
  //   navigate("/rawdata");
  // };

  const handleViewLeadLogs = async (leadId: string, page = 1, search = "") => {
    try {
      setCurrentLeadLogId(leadId);
      setIsLogModalOpen(true);
      setLogLoading(true);
      let type = "CRM";

      const data = await getRawDataLog(
        leadId,
        page,
        logsPagination.pageSize,
        search,
        type,
      );

      setSelectedLeadLogs(data.logs);
      setLogsPagination((prev) => ({
        ...prev,
        current: page,
        total: data.pagination.total,
        pageSize: data.pagination.pageSize,
      }));

      // scroll to top of modal
      setTimeout(() => {
        modalScrollRef.current?.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    } catch (error) {
      console.error("Failed to fetch lead logs:", error);
    } finally {
      setLogLoading(false);
    }
  };

  const deslugify = (slug: string) =>
    slug
      .replace(/-/g, " ") // replace dashes with spaces
      .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize each word

  const copyToClipboard = (text: string) => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text);
    } else {
      // fallback for HTTP / unsupported browsers
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed"; // avoid scroll jump
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }
  };

  const handleCopy = (rowId: string, data: string, text: string) => {
    copyToClipboard(text);
    setCopiedId(rowId);
    setIsCurrectData(data);

    setTimeout(() => {
      setCopiedId(null);
      setIsCurrectData(null);
    }, 1500);
  };

  const handleViewLeadCopy = (click: string, text: string) => {
    copyToClipboard(text);
    setIsClick(click);

    setTimeout(() => {
      setIsClick(null);
    }, 1500);
  };

  const TwoLineClampWithTooltip = ({
    text,
    preserveFormatting = false,
    className = "",
    tooltipPlacement = "top",
    tooltipMaxWidth = "500px",
  }: {
    text: string;
    preserveFormatting?: boolean;
    className?: string;
    tooltipPlacement?: React.ComponentProps<typeof Tooltip>["placement"];
    tooltipMaxWidth?: string;
  }) => {
    const textRef = useRef<HTMLDivElement>(null);
    const measureRef = useRef<HTMLDivElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const plainText = text
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    useLayoutEffect(() => {
      const checkOverflow = () => {
        const el = textRef.current;
        const measureEl = measureRef.current;
        if (!el || !measureEl) return;

        const computedStyle = window.getComputedStyle(el);
        const horizontalPadding =
          Number.parseFloat(computedStyle.paddingLeft || "0") +
          Number.parseFloat(computedStyle.paddingRight || "0");
        measureEl.style.width = `${Math.max(
          0,
          el.clientWidth - horizontalPadding,
        )}px`;
        measureEl.style.fontFamily = computedStyle.fontFamily;
        measureEl.style.fontWeight = computedStyle.fontWeight;
        measureEl.style.letterSpacing = computedStyle.letterSpacing;
        const twoLineHeight = 40;

        setIsOverflowing(
          Math.ceil(measureEl.scrollHeight) > twoLineHeight + 1 ||
            Math.ceil(measureEl.scrollWidth) > Math.ceil(el.clientWidth) + 1,
        );
      };

      const frameId = window.requestAnimationFrame(checkOverflow);
      const timeoutId = window.setTimeout(checkOverflow, 120);

      const resizeObserver = new ResizeObserver(checkOverflow);

      if (textRef.current) {
        resizeObserver.observe(textRef.current);
      }
      window.addEventListener("resize", checkOverflow);

      return () => {
        window.cancelAnimationFrame(frameId);
        window.clearTimeout(timeoutId);
        resizeObserver.disconnect();
        window.removeEventListener("resize", checkOverflow);
      };
    }, [className, preserveFormatting, text]);

    const content = (
      <div style={{ position: "relative" }}>
        <div
          ref={textRef}
          className={className}
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: isOverflowing ? "pointer" : "default",
            fontSize: "14px",
            lineHeight: "20px",
            maxHeight: "40px",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
          }}
          dangerouslySetInnerHTML={
            preserveFormatting ? { __html: text } : undefined
          }
        >
          {preserveFormatting ? null : plainText}
        </div>
        <div
          ref={measureRef}
          aria-hidden="true"
          className={
            preserveFormatting ? "summary-history-description-measure" : ""
          }
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            visibility: "hidden",
            pointerEvents: "none",
            fontSize: "14px",
            lineHeight: "20px",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            height: "auto",
            maxHeight: "none",
            overflow: "visible",
          }}
          dangerouslySetInnerHTML={
            preserveFormatting ? { __html: text } : undefined
          }
        >
          {preserveFormatting ? null : plainText}
        </div>
      </div>
    );

    if (!isOverflowing) {
      return content;
    }
    return (
      <Tooltip
        title={
          <div
            className="max-h-[250px] overflow-y-auto"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        }
        classNames={
          preserveFormatting
            ? { root: "summary-history-tooltip" }
            : undefined
        }
        placement={tooltipPlacement}
        color="#CCCCCC"
        mouseLeaveDelay={0.3}
        overlayStyle={{ maxWidth: tooltipMaxWidth }}
        overlayInnerStyle={{
          color: "#000",
          padding: "12px",
          maxWidth: tooltipMaxWidth,
        }}
      >
        {content}
      </Tooltip>
    );
  };

  // table columns
  const columns = [
    {
      title: <div style={{ textAlign: "center" }}>#</div>,
      dataIndex: "leadCode",
      key: "leadCode",
      render: (text: any, record: any) => (
        <div className="flex justify-between gap-2">
          {/* Pin or Unpin Icon */}
          <div
            onClick={() => handlePinClick(record.leadCode)} // Toggle pin on click
            className={`cursor-pointer ${pinnedLeads.includes(record.leadCode) ? "pinned" : ""}`} // Add class when pinned
          >
            {pinnedLeads.includes(record.leadCode) ? (
              <RiUnpinLine size={20} color="#1677ff" /> // Red pin for pinned state
            ) : (
              <TiPinOutline size={20} className="row-pin cursor-pointer" /> // Outline pin for unpinned state
            )}
          </div>
          {/* Lead Code */}
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      fixed: "left" as const,
      width: 150,
      ellipsis: true,
      render: (title: any, record: any) => (
        <Tooltip
          title={title}
          color="#CCCCCC"
          overlayInnerStyle={{
            color: "#000", // âœ… font color
            padding: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              maxWidth: "140px", // ensure ellipsis works
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              cursor: "pointer",
            }}
          >
            {/* If you re-enable image */}
            {/* <img
          src={record.profilePhoto}
          alt={title}
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "50%",
            objectFit: "contain",
          }}
        /> */}
            <span>{title}</span>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Lead Source",
      dataIndex: "leadSource",
      key: "leadSource",
      fixed: "left" as const,
      width: 120,
      align: "center" as const,
      render: (_: any, record: any) => {
        const { leadSource, link } = record;

        if (!leadSource) {
          return <span>-</span>;
        }

        const rowId = record._id; // âœ… UNIQUE PER ROW

        return (
          <div
            className="lead-source-wrapper"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {/* Lead source tooltip */}
            <Tooltip
              title={link || "No link"}
              color="#CCCCCC"
              overlayInnerStyle={{ color: "#000", padding: "12px" }}
            >
              <span
                onClick={() => {
                  if (link) {
                    window.open(link, "_blank", "noopener,noreferrer");
                  }
                }}
                style={{ cursor: link ? "pointer" : "default" }}
              >
                <SourceBadge
                  source={leadSource.name}
                  color={leadSource.color}
                />
              </span>
            </Tooltip>

            {/* Copy icon */}
            <Tooltip
              title={
                copiedId === rowId && isCurrectData === link
                  ? "Copied"
                  : "Copy Link"
              }
              color="#CCCCCC"
              overlayInnerStyle={{
                color: "#000", // âœ… font color
                padding: "12px",
              }}
            >
              {copiedId === rowId && isCurrectData === link ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    lineHeight: 1,
                  }}
                >
                  <RiCheckLine size={20} style={{ color: "#1890ff" }} />
                  <span
                    style={{
                      fontSize: "9px",
                      color: "#1890ff",
                      marginTop: "2px",
                    }}
                  >
                    Copied
                  </span>
                </div>
              ) : (
                <RiFileCopyLine
                  size={20}
                  className="copy-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(rowId, link.toString(), link);
                  }}
                />
              )}
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Client Name",
      dataIndex: "contactName",
      key: "contactName",
      fixed: "left" as const,
      render: (text: string, record: any) => (
        <span style={{ cursor: "pointer" }} onClick={() => handleView(record)}>
          {text}
        </span>
      ),
    },
    //  {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    //   width: 120,
    //   align: "center" as const,
    //   render: (value: string | null | undefined) => value && value.trim() !== "" ? value : "N/A",
    // },
    {
      title: "Owner",
      dataIndex: "leadowner",
      key: "leadowner",
      align: "center" as const,

      sorter: true,
      sortDirections: ["ascend", "descend"] as SortOrder[],
      render: (leadowner: any) => <UserAvatar user={leadowner} />,
    },
    {
      title: "Platform",
      dataIndex: "platform",
      key: "platform",
      sorter: true,
      width: 80,
      align: "center" as const,
      sortDirections: ["ascend", "descend"] as SortOrder[],
      render: (platform: any) => <UserAvatar user={platform} />,
    },
    {
      title: "Lead Assignee",
      dataIndex: "leadAssigne",
      key: "leadAssigne",
      width: 80,
      align: "center" as const,
      render: (lead: any, record: any) => {
        const selectedUser = lead ? [lead] : [];

        const handleChange = async (newUserId: string) => {
          await handleUpdateField(
            record._id,
            "leadAssigne",
            newUserId,
            "Lead Assignee",
          );
          setOpenDropdownId(null); // âœ… close only this dropdown
        };

        return (
          <Dropdown
            trigger={["click"]}
            destroyPopupOnHide
            open={openDropdownId === record._id} // âœ… control per-row dropdown
            onOpenChange={(visible) =>
              setOpenDropdownId(visible ? record._id : null)
            }
            dropdownRender={() => (
              <div className="p-2 rounded-lg shadow-lg bg-white max-h-64 overflow-y-auto">
                {developers.map((dev) => {
                  const isSelected = lead?._id === dev._id;
                  return (
                    <div
                      key={dev._id}
                      onClick={() => handleChange(dev._id)}
                      className={`flex items-center px-3 py-2 rounded-md cursor-pointer transition ${
                        isSelected ? "bg-gray-100" : "hover:bg-gray-50"
                      }`}
                    >
                      <Avatar
                        size="small"
                        src={dev.photo ? `${IMAGEURL}${dev.photo}` : undefined}
                        style={{
                          backgroundColor: dev.photo
                            ? "transparent"
                            : "#7265e6",
                          marginRight: 8,
                        }}
                      >
                        {!dev.photo && dev.username?.charAt(0).toUpperCase()}
                      </Avatar>
                      <span className="text-sm text-gray-800">
                        {dev.username}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          >
            <div className="flex items-center gap-1 cursor-pointer">
              {selectedUser.map((u) => (
                <Tooltip
                  key={u._id}
                  title={u.username || "Unknown"}
                  placement="top"
                  color="#CCCCCC"
                  overlayInnerStyle={{ color: "#000", padding: "12px" }}
                >
                  <Avatar
                    size={34}
                    src={u.photo ? `${IMAGEURL}${u.photo}` : undefined}
                    style={{
                      backgroundColor: u.photo ? "transparent" : "#7265e6",
                      cursor: "pointer",
                    }}
                  >
                    {!u.photo && u.username?.charAt(0).toUpperCase()}
                  </Avatar>
                </Tooltip>
              ))}
              <DownOutlined
                style={{ fontSize: 10, color: "#888", marginLeft: 4 }}
              />
            </div>
          </Dropdown>
        );
      },
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      width: 10,
      align: "center" as const,
      sorter: true,
      sortDirections: ["ascend", "descend"] as SortOrder[],
      render: (text: string, record: any) => {
        const priorityColors: Record<string, string> = {
          Low: "#26bf94",
          Medium: "#23b7e5",
          High: "#e6533c",
        };

        const color = priorityColors[text] || "#999";

        // Dropdown menu
        const menu = (
          <Menu
            onClick={({ key }) =>
              handleUpdatePriority(record._id, "priority", key, "Priority")
            }
            items={Object.entries(priorityColors).map(([label, clr]) => ({
              key: label,
              label: (
                <Tag
                  style={{
                    backgroundColor: `${clr}1A`, // light tint
                    color: clr,
                    fontSize: "12px",
                    padding: "2px 10px",
                    borderRadius: "6px",
                    fontWeight: 600,
                    border: `1px solid ${clr}`,
                  }}
                >
                  {label}
                </Tag>
              ),
            }))}
          />
        );

        return (
          <Dropdown overlay={menu} trigger={["click"]}>
            <Tag
              style={{
                backgroundColor: `${color}1A`,
                color: color,
                fontSize: "12px",
                padding: "2px 10px",
                borderRadius: "6px",
                fontWeight: 600,
                cursor: "pointer",
                border: `1px solid ${color}`,
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              {text ?? "Select"}
            </Tag>
          </Dropdown>
        );
      },
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date", // âœ… lowercase
      render: (date: string | Date) => {
        if (!date) return "-";
        const parsed = dayjs(date, ["D-M-YYYY", "DD-MM-YYYY"], true);
        return parsed.isValid() ? parsed.format("DD-MM-YYYY") : "-";
      },
      sorter: true,
      sortDirections: ["ascend", "descend"] as SortOrder[],
    },
    {
      title: "Rank",
      dataIndex: "rank",
      key: "rank",
      align: "center" as const,
      render: (rank: any) => (
        <Tag color="blue" className="px-2 py-0.5 text-xs font-semibold">
          {rank ?? "--"}
        </Tag>
      ),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      align: "center" as const,
      render: (_: any, record: any) => {
        const { phone } = record;
        const rowId = record._id; // âœ… UNIQUE PER ROW

        return (
          <div
            className="lead-source-wrapper"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "3px",
            }}
          >
            <Tag
              icon={<PhoneOutlined />}
              color="green"
              className="px-2 py-0.5 text-sm font-medium"
            >
              {phone && phone.trim() !== "" ? phone : "N/A"}
            </Tag>

            {/* Copy icon */}
            <Tooltip
              title={
                copiedId === rowId && isCurrectData === phone
                  ? "Copied"
                  : "Copy Link"
              }
              color="#CCCCCC"
              overlayInnerStyle={{
                color: "#000", // âœ… font color
                padding: "12px",
              }}
            >
              {copiedId === rowId && isCurrectData === phone ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    lineHeight: 1,
                  }}
                >
                  <RiCheckLine size={20} style={{ color: "#1890ff" }} />
                  <span
                    style={{
                      fontSize: "9px",
                      color: "#1890ff",
                      marginTop: "2px",
                    }}
                  >
                    Copied
                  </span>
                </div>
              ) : (
                <RiFileCopyLine
                  size={20}
                  className="copy-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(rowId, phone.toString(), phone);
                  }}
                />
              )}
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Phone No. 2",
      dataIndex: "phone_2",
      key: "phone_2",
      align: "center" as const,
      render: (_: any, record: any) => {
        const { phone_2 } = record;
        const rowId = record._id; // âœ… UNIQUE PER ROW

        return (
          <div
            className="lead-source-wrapper"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "3px",
            }}
          >
            <Tag
              icon={<PhoneOutlined />}
              color="green"
              className="px-2 py-0.5 text-sm font-medium"
            >
              {phone_2 && phone_2.trim() !== "" ? phone_2 : "N/A"}
            </Tag>

            {/* Copy icon */}
            <Tooltip
              title={
                copiedId === rowId && isCurrectData === phone_2
                  ? "Copied"
                  : "Copy Link"
              }
              color="#CCCCCC"
              overlayInnerStyle={{
                color: "#000", // âœ… font color
                padding: "12px",
              }}
            >
              {copiedId === rowId && isCurrectData === phone_2 ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    lineHeight: 1,
                  }}
                >
                  <RiCheckLine size={20} style={{ color: "#1890ff" }} />
                  <span
                    style={{
                      fontSize: "9px",
                      color: "#1890ff",
                      marginTop: "2px",
                    }}
                  >
                    Copied
                  </span>
                </div>
              ) : (
                <RiFileCopyLine
                  size={20}
                  className="copy-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(rowId, phone_2.toString(), phone_2);
                  }}
                />
              )}
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Company",
      dataIndex: "company",
      key: "company",
    },
    {
      title: "Lead Value",
      dataIndex: "leadValue",
      key: "leadValue",
    },
    {
      title: "Probability",
      dataIndex: "probability",
      key: "probability",
      render: (value: any) => formatProbability(value),
    },
    {
      title: "Description",
      key: "description",
      dataIndex: "description",
      width: 200,
      render: (text?: string) => {
        if (!text) return <div className="text-gray-400">N/A</div>;
        return <TwoLineClampWithTooltip text={text} />;
      },
    },
    {
      title: "Tags",
      dataIndex: "leadTags",
      key: "leadTags",
      width: 150,
      align: "center" as const,

      render: (
        tags: { _id: string; name: string; color: string }[],
        record: any,
      ) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: "4px",
              alignItems: "center",
            }}
          >
            {(tags || []).map((tag) => (
              <Dropdown
                key={tag._id}
                open={tagDropdownOpenId === `${record._id}-${tag._id}`}
                onOpenChange={(open) =>
                  setTagDropdownOpenId(open ? `${record._id}-${tag._id}` : null)
                }
                trigger={["click"]}
                menu={{
                  items: allTags.map((t) => ({
                    key: t._id,
                    label: (
                      <span style={{ color: t.color, fontWeight: 700 }}>
                        {t.name}
                      </span>
                    ),
                  })),
                  onClick: ({ key }) =>
                    handleChangeTag(record._id, tag._id, key, tags),
                  style: { maxHeight: 165, overflowY: "auto" },
                }}
              >
                <span
                  style={{
                    backgroundColor: tag.color ? `${tag.color}33` : "#f0f0f0",
                    color: tag.color || "#000",
                    fontSize: "10px",
                    padding: "2px 4px 2px 8px",
                    borderRadius: "4px",
                    fontWeight: 700,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    cursor: "pointer",
                  }}
                >
                  {tag.name}
                  <CloseOutlined
                    style={{ fontSize: "9px", cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveTag(record._id, tag._id, tags);
                    }}
                  />
                </span>
              </Dropdown>
            ))}
            <Dropdown
              open={addTagDropdownOpenId === record._id}
              onOpenChange={(open) =>
                setAddTagDropdownOpenId(open ? record._id : null)
              }
              trigger={["click"]}
              menu={{
                items: allTags.map((t) => ({
                  key: t._id,
                  label: (
                    <span style={{ color: t.color, fontWeight: 700 }}>
                      {t.name}
                    </span>
                  ),
                })),
                onClick: ({ key }) => handleAddTag(record._id, key, tags || []),
                style: { maxHeight: 165, overflowY: "auto" },
              }}
            >
              <span
                style={{
                  width: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  background: "#e6f4ff",
                  color: "#1677ff",
                  fontSize: "14px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  fontWeight: 700,
                  lineHeight: 1,
                }}
                title="Add tag"
              >
                +
              </span>
            </Dropdown>
          </div>
        );
      },
    },
    {
      title: "Lead Status",
      dataIndex: "leadstatus",
      key: "leadstatus",
      align: "center" as const,

      render: (
        leadStatus:
          | {
              _id: string;
              name: string;
              color: string;
              slug: string;
              createdAt: string;
              __v: number;
            }
          | undefined,
        record: any,
      ) => {
        const getStatusBadge = (status: {
          _id: string;
          name: string;
          color: string;
        }) => <StatusBadge status={status?.name} color={status?.color} />;
        const handleMenuClick = ({ key }: { key: string }) => {
          const selectedStatus = statuses.find((status) => status._id === key);
          if (selectedStatus) {
            handleStatusChange(record._id, selectedStatus.name);
          }
        };
        return (
          <Dropdown
            menu={{
              items: statuses.map((status) => ({
                key: status._id,
                label: getStatusBadge(status),
              })),
              onClick: handleMenuClick,
              style: {
                maxHeight: 165, // adjust height (~5 items)
                overflowY: "auto",
              },
            }}
            trigger={["click"]}
          >
            <span className="cursor-pointer">
              {leadStatus ? (
                getStatusBadge(leadStatus)
              ) : (
                <span>Select Status</span>
              )}
            </span>
          </Dropdown>
        );
      },
    },

    {
      title: "Summary",
      key: "summary",
      render: (_: any, record: any) => (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleViewSummary(record._id);
          }}
          className="w-7 h-7 rounded-full bg-gradient-to-br from-green-400 to-emerald-600 shadow-[0_4px_12px_rgba(16,185,129,0.3)] hover:shadow-[0_6px_16px_rgba(16,185,129,0.4)] active:translate-y-1 active:shadow-none text-white flex items-center justify-center transition-all duration-200 group"
          title="View Summary"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            className="group-hover:scale-110 transition-transform"
          >
            <path
              d="M4 6H20M4 12H20M4 18H11"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      ),
    },
    {
      title: "Logs",
      key: "leadLog",
      render: (_: any, record: any) => (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleViewLeadLogs(record._id);
          }}
          className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-400 to-blue-600 shadow-[0_4px_12px_rgba(96,165,250,0.3)] hover:shadow-[0_6px_16px_rgba(96,165,250,0.4)] active:translate-y-1 active:shadow-none text-white flex items-center justify-center transition-all duration-200 group"
          title="View Logs"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            className="group-hover:scale-110 transition-transform"
          >
            <path
              d="M6 4V20M18 4V20M6 4H18M6 20H18M9 8H15M9 12H15M9 16H13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <div className="d-flex" style={{ gap: "8px", alignItems: "center" }}>
          {/* View button */}
          {/* <Tooltip title="View">
            <button
              className="w-7 h-7 rounded-full bg-gradient-to-br from-blue-500 to-cyan-600
                        shadow-[0_4px_12px_rgba(59,130,246,0.3)]
                        hover:shadow-[0_6px_16px_rgba(59,130,246,0.4)]
                        active:translate-y-[1px] active:shadow-none
                        text-white flex items-center justify-center
                        transition-all duration-200 ease-in-out group"
            >
              <EyeOutlined
                className="group-hover:scale-110 transition-transform duration-200"
                style={{ fontSize: "12px" }}
              />
            </button>
          </Tooltip> */}

          <button
            onClick={() => handleEdit(record)}
            className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600
                       shadow-[0_4px_12px_rgba(139,92,246,0.3)]
                       hover:shadow-[0_6px_16px_rgba(139,92,246,0.4)]
                       active:translate-y-[1px] active:shadow-none
                       text-white flex items-center justify-center
                       transition-all duration-200 ease-in-out group cursor-pointer"
            title="Edit"
          >
            <FaPen
              className="group-hover:scale-110 transition-transform duration-200"
              size={12}
            />
          </button>

          <button
            onClick={() => handleDeleteConfirmation(record?._id)}
            className="w-7 h-7 rounded-full bg-gradient-to-br from-rose-500 to-rose-700
                       shadow-[0_4px_12px_rgba(244,63,94,0.3)]
                       hover:shadow-[0_6px_16px_rgba(244,63,94,0.4)]
                       active:translate-y-1 active:shadow-none
                       text-white flex items-center justify-center
                       transition-all duration-200 group cursor-pointer"
            title="Delete"
          >
            <FaTrashAlt
              className="group-hover:scale-110 transition-transform"
              size={12}
            />
          </button>
        </div>
      ),
    },
  ];

  const applyFavouriteFilter = (fav: any) => {
    setStatusFilter(fav.status || []);
    setTimeFilter(fav.timeFilter);
    setStartDate(fav.startDate ? dayjs(fav.startDate) : null);
    setEndDate(fav.endDate ? dayjs(fav.endDate) : null);

    fetchRawData({
      timeFilter: fav.timeFilter,
      startDate: fav.startDate,
      endDate: fav.endDate,
      status: fav.status || null,
      page: 1,
    });
  };

  // State outside

  const FilterMenu = (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        // minWidth: "400px",
        maxWidth: "800px",
        background: "linear-gradient(145deg, #ffffff, #f8fafc)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "12px",
        overflow: "hidden",
        padding: "16px",
        gap: "12px",
      }}
      className="filter-menu"
    >
      {/* ---------------- Status Filter ---------------- */}
      <div
        style={{
          padding: "12px",
          borderRight: "1px solid #e5e7eb",
          height: "300px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: 600,
            fontSize: "16px",
            color: "#1f2937",
            paddingBottom: "8px",
            borderBottom: "2px solid #e5e7eb",
            backgroundColor: "#fff",
            position: "sticky",
            top: 0,
            zIndex: 10,
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <FilterOutlined style={{ color: "#3b82f6" }} />
            Status Filter
          </span>
          <Button
            type="link"
            size="small"
            style={{ padding: 0, color: "#ef4444" }}
            onClick={() => {
              setStatusFilter([]);
              setPage(1);
              fetchRawData({
                status: "",
                page: 1,
              });
            }}
          >
            Clear
          </Button>
        </div>
        <div
          style={{
            marginTop: "8px",
            overflowY: "auto",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "6px",
          }}
        >
          {statusOptions.map((opt: any) => (
            <div
              key={opt.value}
              style={{
                padding: "8px 12px",
                cursor: "pointer",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.2s ease",
                backgroundColor: statusFilter?.includes(opt.id)
                  ? "#e6f7ff"
                  : "transparent",
              }}
              onClick={() => handleStatusFilterChange(opt.id)}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = statusFilter?.includes(
                  opt.id,
                )
                  ? "#e6f7ff"
                  : "#f1f5f9")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = statusFilter?.includes(
                  opt.id,
                )
                  ? "#e6f7ff"
                  : "transparent")
              }
            >
              {opt.label}
            </div>
          ))}
        </div>
      </div>

      {/* ---------------- Time Filter ---------------- */}
      <div
        style={{
          padding: "12px",
          borderRight: "1px solid #e5e7eb",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "12px",
            fontWeight: 600,
            fontSize: "16px",
            color: "#1f2937",
            borderBottom: "2px solid #e5e7eb",
            paddingBottom: "8px",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <ClockCircleOutlined style={{ color: "#10b981" }} />
            Time Filter
          </span>
          <Button
            type="link"
            size="small"
            style={{ padding: 0, color: "#ef4444" }}
            onClick={() => {
              setTimeFilter(undefined);
              setStartDate(null);
              setEndDate(null);
              setTempStartDate(null);
              setTempEndDate(null);
              setPage(1);
              fetchRawData({
                timeFilter: undefined,
                startDate: null,
                endDate: null,
                page: 1,
              });
            }}
          >
            Clear
          </Button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {timeFilterOptions.map((opt: any) => (
            <div
              key={opt.value}
              style={{
                padding: "5px 5px",
                cursor: "pointer",
                borderRadius: "6px",
                fontSize: "14px",
                transition: "all 0.2s ease",
                backgroundColor:
                  timeFilter === opt.value ? "#e6f7ff" : "transparent",
              }}
              onClick={() => {
                setTimeFilter(opt.value);
                setPage(1);
                if (opt.value !== "custom") {
                  setStartDate(null);
                  setEndDate(null);
                  setTempStartDate(null);
                  setTempEndDate(null);
                  fetchRawData({
                    timeFilter: opt.value,
                    startDate: null,
                    endDate: null,
                    page: 1,
                  });
                }
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor =
                  timeFilter === opt.value ? "#e6f7ff" : "#f1f5f9")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor =
                  timeFilter === opt.value ? "#e6f7ff" : "transparent")
              }
            >
              {opt.label}
            </div>
          ))}
          <div
            style={{
              padding: "8px 12px",
              cursor: "pointer",
              borderRadius: "6px",
              fontSize: "14px",
              marginTop: "8px",
              background: "#f1f5f9",
              transition: "all 0.2s ease",
            }}
            onClick={() => setShowRangePicker(true)}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#e2e8f0")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#f1f5f9")
            }
          >
            Custom Range
          </div>
        </div>
      </div>

      {/* ---------------- Favorites ---------------- */}
      <div style={{ padding: "12px" }}>
        <h4
          style={{
            marginBottom: "12px",
            fontSize: "16px",
            fontWeight: 600,
            color: "#1f2937",
            borderBottom: "2px solid #e5e7eb",
            paddingBottom: "8px",
          }}
        >
          <i className="fas fa-star mr-2 text-yellow-500"></i> Favorites
        </h4>

        {/* Input + Save in one row */}
        <div style={{ display: "flex", gap: "6px", marginBottom: "10px" }}>
          <input
            value={newFavName}
            onChange={(e) => setNewFavName(e.target.value)}
            placeholder="Enter favorite name"
            style={{
              flex: 1,
              padding: "6px 8px",
              borderRadius: "6px",
              border: "1px solid #d1d5db",
            }}
          />
          <Button
            className="allbuttons"
            style={{ color: "white" }}
            onClick={() => {
              if (!newFavName) return;
              const fav = {
                id: Date.now(),
                label: newFavName,
                status: statusFilter,
                timeFilter,
                startDate: startDate ? startDate.format("YYYY-MM-DD") : null,
                endDate: endDate ? endDate.format("YYYY-MM-DD") : null,
              };
              addFavouriteFilter(fav);
              setNewFavName("");
            }}
          >
            Save
          </Button>
        </div>

        {/* Favourite buttons wrap below */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)", // âœ… 3 per row
            gap: "6px",
          }}
        >
          {favouriteFilters.map((f: any) => (
            <Button
              key={f.id}
              type={selectedFav === f.id ? "primary" : "default"}
              onClick={() => {
                if (selectedFav === f.id) {
                  // Unselect
                  setSelectedFav(null);
                  setSelectedFavLabel(null);
                  setStatusFilter([]);
                  setTimeFilter(undefined);
                  setStartDate(null);
                  setEndDate(null);
                  setPage(1);
                  fetchRawData({
                    timeFilter: undefined,
                    startDate: null,
                    endDate: null,
                    status: [],
                  });
                } else {
                  setSelectedFav(f.id);
                  setSelectedFavLabel(f.label); // âœ… save label for badge
                  applyFavouriteFilter(f);
                  setPage(1);
                  fetchRawData({
                    timeFilter: f.timeFilter,
                    startDate: f.startDate,
                    endDate: f.endDate,
                    status: f.status || [],
                  });
                }
              }}
              style={{
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "4px",
                paddingRight: "8px",
                width: "max-content", // fixed width
              }}
            >
              <Tooltip
                title={f.label}
                color="#CCCCCC"
                overlayInnerStyle={{
                  color: "#000", // âœ… font color
                  padding: "12px",
                }}
              >
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    flex: 1,
                  }}
                >
                  {f.label}
                </span>
              </Tooltip>
              <DeleteOutlined
                onClick={(e) => {
                  e.stopPropagation();
                  deleteFavouriteFilter(f.id);
                }}
                style={{ color: "#ef4444", padding: "0 4px" }}
              />
            </Button>
          ))}
        </div>
      </div>

      {/* ---------------- Custom Range Modal ---------------- */}
      {showRangePicker && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1500,
            background: "#fff",
            padding: "20px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            borderRadius: "12px",
            width: "90%",
            maxWidth: "400px",
          }}
        >
          <h4
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#1f2937",
              marginBottom: "16px",
            }}
          >
            Select Date Range
          </h4>
          <DatePicker.RangePicker
            value={
              tempStartDate && tempEndDate ? [tempStartDate, tempEndDate] : null
            }
            onChange={(dates) => {
              setTempStartDate(dates ? dates[0] : null);
              setTempEndDate(dates ? dates[1] : null);
            }}
            format="YYYY-MM-DD"
            style={{ marginBottom: "16px", width: "100%" }}
            allowClear={false}
            getPopupContainer={(triggerNode) => document.body}
            popupStyle={{ zIndex: 2000 }}
          />
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
          >
            <Button
              onClick={() => {
                setShowRangePicker(false);
                setTempStartDate(null);
                setTempEndDate(null);
              }}
              style={{ borderRadius: "6px" }}
            >
              Cancel
            </Button>
            <Button
              className="allbuttons"
              onClick={() => {
                if (tempStartDate && tempEndDate) {
                  setStartDate(tempStartDate);
                  setEndDate(tempEndDate);
                  setTimeFilter("custom");
                  setShowRangePicker(false);
                  setPage(1);
                  fetchRawData({
                    timeFilter: "custom",
                    startDate: tempStartDate.format("YYYY-MM-DD"),
                    endDate: tempEndDate.format("YYYY-MM-DD"),
                    page: 1,
                  });
                }
              }}
              disabled={!tempStartDate || !tempEndDate}
              style={{
                background: "#3b82f6",
                borderColor: "#3b82f6",
                borderRadius: "6px",
                color: "white",
              }}
            >
              Apply
            </Button>
          </div>
        </div>
      )}

      {/* ---------------- Responsive ---------------- */}
      <style>{`
      @media (max-width: 768px) {
        .filter-menu {
          grid-template-columns: 1fr !important;
          min-width: 100% !important;
        }
        .filter-menu > div {
          border-right: none !important;
          border-bottom: 1px solid #e5e7eb !important;
        }
        .filter-menu > div:last-child {
          border-bottom: none !important;
        }
      }
    `}</style>
    </div>
  );

  return (
    <div>
      <style>{`
        .log-message-content b, .log-message-content strong {
          color: #0f172a;
          font-weight: 600;
        }
        .log-message-content a {
          color: #22c55e;
          font-weight: 600;
          text-decoration: none;
        }
        .log-message-content em {
          color: #22c55e;
          font-style: normal;
          font-weight: 600;
        }
        .custom-search-input input::placeholder {
          color: #94a3b8 !important;
          opacity: 1;
        }
        .custom-search-input,
        .custom-search-input:hover,
        .custom-search-input.ant-input-affix-wrapper-focused {
          background-color: #071827 !important;
          border-color: #1f3b50 !important;
          box-shadow: none !important;
        }
        .custom-search-input .ant-input {
          background-color: transparent !important;
          color: #ffffff !important;
        }
        .custom-search-input .ant-input-prefix {
          color: #94a3b8 !important;
          margin-inline-end: 12px;
        }
        .custom-search-input:hover .ant-input-prefix,
        .custom-search-input:focus-within .ant-input-prefix {
          color: #94a3b8 !important;
        }
        .custom-search-input .ant-input-clear-icon {
          color: #94a3b8 !important;
        }
        .custom-lead-log-pagination .ant-pagination-item {
          border-radius: 4px !important;
          border-color: #f1f5f9 !important;
          background-color: #fff !important;
          min-width: 32px !important;
          height: 32px !important;
          line-height: 30px !important;
        }
        .custom-lead-log-pagination .ant-pagination-item a {
          color: #64748b !important;
          font-weight: 500 !important;
        }
        .custom-lead-log-pagination .ant-pagination-item-active {
          background-color: #0f172a !important;
          border-color: #0f172a !important;
        }
        .custom-lead-log-pagination .ant-pagination-item-active a {
          color: white !important;
        }
        .custom-lead-log-pagination .ant-pagination-item:hover {
          border-color: #0f172a !important;
        }
        .custom-lead-log-pagination .ant-pagination-item:hover a {
          color: #0f172a !important;
        }
        .custom-lead-log-pagination .ant-pagination-prev,
        .custom-lead-log-pagination .ant-pagination-next {
          min-width: 32px !important;
          height: 32px !important;
          line-height: 32px !important;
        }
        .custom-lead-log-pagination .ant-pagination-prev .ant-pagination-item-link,
        .custom-lead-log-pagination .ant-pagination-next .ant-pagination-item-link {
          border-radius: 4px !important;
          border-color: #f1f5f9 !important;
          background-color: #fff !important;
          color: #64748b !important;
        }
        .custom-lead-log-pagination .ant-pagination-prev:hover .ant-pagination-item-link,
        .custom-lead-log-pagination .ant-pagination-next:hover .ant-pagination-item-link {
          color: #0f172a !important;
          border-color: #0f172a !important;
        }
        .summary-add-button.ant-btn-primary,
        .summary-add-button.ant-btn-primary:focus {
          background-color: #1e5631 !important;
          border-color: #1e5631 !important;
          color: #ffffff !important;
        }
        .summary-add-button.ant-btn-primary:hover,
        .summary-add-button.ant-btn-primary:active {
          background-color: #154224 !important;
          border-color: #154224 !important;
          color: #ffffff !important;
        }
        .summary-open-composer {
          cursor: pointer;
          border: 1px dashed #aab3c0;
          background-color: #ffffff;
          transition:
            border-color 160ms ease,
            background-color 160ms ease,
            box-shadow 160ms ease;
        }
        .summary-open-composer:hover,
        .summary-open-composer:focus-visible {
          border-color: #1f7a45;
          border-style: dotted;
          background-color: #f8fffb;
          box-shadow: 0 0 0 2px rgba(31, 122, 69, 0.18);
          outline: none;
        }
        .summary-date-picker .ant-picker-input input::placeholder {
          color: #667085 !important;
          opacity: 1;
        }
        .summary-editor .tiptap p.is-editor-empty:first-child::before,
        .summary-editor .ProseMirror p.is-editor-empty:first-child::before {
          color: #667085 !important;
          opacity: 1;
        }
        .summary-history-description {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .summary-history-description p,
        .summary-history-description-measure p {
          margin: 0;
        }
        .summary-history-description ul,
        .summary-history-description ol,
        .summary-history-description-measure ul,
        .summary-history-description-measure ol {
          margin: 0;
          padding-left: 18px;
        }
        .summary-history-description a {
          color: #1677ff;
          text-decoration: underline;
        }
        .summary-history-tooltip {
          pointer-events: auto;
        }
        .summary-tab-section {
          min-height: 0;
        }
        .summary-scroll-region {
          scrollbar-width: thin;
          scrollbar-color: #cbd5e1 transparent;
        }
        .summary-scroll-region::-webkit-scrollbar {
          width: 6px;
        }
        .summary-scroll-region::-webkit-scrollbar-thumb {
          border-radius: 999px;
          background: #cbd5e1;
        }
        .summary-history-panel,
        .summary-composer-panel {
          max-height: min(720px, calc(100vh - 252px));
        }
        .summary-history-panel {
          overflow-y: auto;
        }
        .summary-composer-panel {
          overflow: hidden;
        }
        .lead-details-summary-grid {
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
        .summary-responsive-layout {
          grid-template-columns: minmax(0, 1fr);
        }
        .summary-responsive-layout.summary-responsive-layout--composer-open {
          grid-template-columns: minmax(0, 772px) minmax(0, 424px);
        }
        @media (max-width: 1024px) {
          .summary-responsive-layout.summary-responsive-layout--composer-open {
            grid-template-columns: minmax(0, 1fr);
          }
          .summary-responsive-layout--composer-open .summary-composer-panel {
            border-top: 1px solid #e5eaf0;
          }
          .summary-responsive-layout--composer-open .summary-history-panel {
            border-right: 0 !important;
          }
        }
        @media (max-width: 767px) {
          .lead-details-summary-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
          .lead-details-hero {
            min-height: auto !important;
            padding: 20px 16px 14px !important;
          }
          .lead-details-close {
            right: 12px !important;
            top: 10px !important;
          }
          .lead-details-hero-grid {
            padding-right: 0;
          }
          .lead-details-stats {
            width: 100% !important;
            max-width: 100% !important;
            margin-left: 0 !important;
          }
          .lead-details-actions {
            justify-content: start;
            padding-left: 88px;
          }
          .lead-details-tabs {
            display: flex;
            height: 64px;
            overflow-x: auto;
            overflow-y: hidden;
            scrollbar-width: thin;
            scrollbar-color: #cbd5e1 transparent;
          }
          .lead-details-tab {
            min-width: 132px;
            flex: 0 0 132px;
          }
          .summary-responsive-layout--composer-open .summary-composer-panel {
            padding: 18px 14px;
          }
        }
        @media (max-width: 520px) {
          .lead-details-summary-grid {
            grid-template-columns: minmax(0, 1fr);
          }
          .lead-details-actions {
            padding-left: 0;
          }
          .lead-details-timeline-row {
            grid-template-columns: 100px minmax(0, 1fr);
            gap: 8px;
          }
          .lead-details-timeline-meta {
            gap: 12px;
          }
          .lead-log-row {
            grid-template-columns: 24px 40px minmax(0, 1fr);
            gap: 8px;
          }
          .lead-log-timestamp {
            grid-column: 3;
            margin-top: 4px;
            text-align: left;
          }
        }
      `}</style>
      {/* Header */}
      <Row
        className="m-2"
        gutter={[12, 20]}
        align="middle"
        justify="space-between"
      >
        {/* Left side: Page Title */}
        <Col xs={23} sm={11} md={3} lg={3} xl={2}>
          <h2 className="headername" style={{ margin: 0 }}>
            {slug ? deslugify(slug) : "Leads"}
          </h2>
        </Col>

        {/* Middle: Total Records Card */}
        <Col xs={23} sm={11} md={10} lg={10} xl={5}>
          <Card
            hoverable
            style={{
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              padding: "6px 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            bodyStyle={{ padding: 0 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "16px",
                fontWeight: 500,
                color: "#001529",
              }}
            >
              <DatabaseOutlined
                style={{ color: "#1890ff", fontSize: "20px" }}
              />
              <span>Total Records:</span>
              <span style={{ fontSize: "22px", fontWeight: 700 }}>
                {totalCount}
              </span>
            </div>
          </Card>
        </Col>

        {/* Middle: Total Value Card */}
        <Col xs={23} sm={11} md={10} lg={10} xl={6}>
          <Card
            hoverable
            style={{
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              padding: "6px 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            bodyStyle={{ padding: 0 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "16px",
                fontWeight: 500,
                color: "#001529",
              }}
            >
              <FcMoneyTransfer style={{ color: "#1890ff", fontSize: "27px" }} />
              <span>Total Values:</span>
              <span style={{ fontSize: "22px", fontWeight: 700 }}>
                {"\u20B9"} {totalValue}
              </span>
            </div>
          </Card>
        </Col>

        {/* Right side: Search + Actions */}
        <Col xs={24} sm={24} md={24} lg={24} xl={11}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div className="flex">
              <Input
                placeholder="Search..."
                allowClear
                onChange={(e) => handleSearch(e?.target?.value ?? "")}
                style={{
                  width: "250px",
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
              />
              <Dropdown
                overlay={FilterMenu}
                trigger={["click"]}
                open={filterDropdownOpen}
                onOpenChange={(open) => setFilterDropdownOpen(open)}
              >
                <Button
                  icon={<FilterOutlined />}
                  style={{
                    height: "35px",
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                />
              </Dropdown>
            </div>

            <Space>
              {selectedRowKeys.length === 0 ? (
                <>
                  <Button
                    type="primary"
                    icon={<RiAddBoxFill />}
                    style={{ background: "#001529", minWidth: "140px" }}
                    onClick={handleAddRawData}
                  >
                    Add
                  </Button>
                  <Tooltip title="Transfer Leads">
                    <Button
                      icon={<FcMoneyTransfer style={{ fontSize: "22px" }} />}
                      style={{ padding: "0 10px", height: "32px" }}
                      onClick={() => setIsTransferModalOpen(true)}
                    />
                  </Tooltip>
                </>
              ) : (
                <Button
                  type="primary"
                  icon={<FaTrashAlt />}
                  style={{ background: "#001529", minWidth: "140px" }}
                  onClick={() => setBulkDelete(true)}
                >
                  Delete Selected
                </Button>
              )}
            </Space>
          </div>
        </Col>
      </Row>

      {/* Table */}
      <Row
        style={{
          width: "100%",
        }}
      >
        <Col span={24}>
          <Card className="w-full">
            <Spin spinning={loading}>
              <div className="scrollbar-hide custom-scroll-table">
                <Table
                  dataSource={sortedData}
                  columns={columns}
                  rowKey="_id"
                  pagination={{
                    current: page,
                    pageSize: 10,
                    total: totalCount,
                    showSizeChanger: false,
                  }}
                  scroll={{ x: "max-content" }}
                  rowSelection={{
                    type: "checkbox",
                    selectedRowKeys,
                    onChange: (newSelectedKeys, newSelectedRows) => {
                      setSelectedRowKeys(newSelectedKeys);
                      setSelectedRows(newSelectedRows);
                    },
                  }}
                  // âœ… sorting & filtering handler
                  onChange={handleTableChange}
                />
              </div>
            </Spin>
          </Card>
        </Col>
      </Row>

      <Drawer
        placement="right"
        onClose={closeViewDrawer}
        open={isViewModalVisible}
        width={
          activeViewLeadTab === "summary" && summaryComposerOpen
            ? "min(1220px, 100vw)"
            : "min(800px, 100vw)"
        }
        styles={{
          body: { padding: 0, backgroundColor: "#f8fafc" },
          header: { display: "none" },
        }}
      >
        {viewLead &&
          (() => {
            const summaries = Array.isArray(viewLead.summaries)
              ? viewLead.summaries
              : Array.isArray(viewLead.leadId?.summaries)
                ? viewLead.leadId.summaries
                : [];
            const toDateValue = (value?: string | Date | null) => {
              if (!value) return 0;
              if (
                typeof value === "string" &&
                /^\d{2}-\d{2}-\d{4}$/.test(value)
              ) {
                return dayjs(value, "DD-MM-YYYY", true).valueOf();
              }
              const parsedDate = dayjs(value);
              return parsedDate.isValid() ? parsedDate.valueOf() : 0;
            };
            const sortedSummaries = [...summaries].sort(
              (a: any, b: any) =>
                toDateValue(a?.date || a?.followUpDate) -
                toDateValue(b?.date || b?.followUpDate),
            );
            const leadStatusValue = viewLead.leadstatus;
            const currentStatus =
              (typeof leadStatusValue === "string"
                ? leadStatusValue.trim()
                : String(leadStatusValue?.name || "").trim()) || "N/A";
            const statusColor =
              typeof leadStatusValue === "object" && leadStatusValue?.color
                ? leadStatusValue.color
                : "#16a34a";
            const priority = viewLead.priority || "Medium";
            const priorityColor =
              priority === "High"
                ? "#ef4444"
                : priority === "Medium"
                  ? "#f59e0b"
                  : "#10b981";
            const phone = viewLead.phone ? String(viewLead.phone) : "";
            const email = viewLead.email ? String(viewLead.email) : "";
            const companyName = viewLead.company
              ? String(viewLead.company).trim()
              : "";
            const profileInitials = getInitials(
              viewLead.contactName || viewLead.title || "",
            );
            const addedOn = (() => {
              if (!viewLead.date) return "N/A";
              const parsed =
                typeof viewLead.date === "string" &&
                /^\d{2}-\d{2}-\d{4}$/.test(viewLead.date)
                  ? dayjs(viewLead.date, "DD-MM-YYYY", true)
                  : dayjs(viewLead.date);

              return parsed.isValid() ? parsed.format("DD MMM YYYY") : "N/A";
            })();
            const leadAmount = Number(viewLead.leadValue) || 0;
            const leadValue = new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: "INR",
              maximumFractionDigits: 0,
            }).format(leadAmount);
            const probabilityValue = formatProbability(viewLead.probability);
            const sourceName = viewLead.leadSource?.name || "-";
            const sourceColor = viewLead.leadSource?.color || "#7c3aed";
            const latestSummary = sortedSummaries[0];
            const latestLog = viewLeadLogs[0];
            const getUserName = (user: any) =>
              typeof user === "string"
                ? user
                : user?.username || user?.name || user?.fullName || "";
            const assignedToName =
              getUserName(viewLead.leadAssigne) ||
              getUserName(viewLead.leadAssignee) ||
              getUserName(viewLead.assignedTo) ||
              "N/A";
            const formatDisplayDate = (value?: string | Date | null) => {
              if (!value) return "N/A";

              const parsed =
                typeof value === "string" &&
                /^\d{1,2}-\d{1,2}-\d{4}$/.test(value)
                  ? dayjs(value, ["D-M-YYYY", "DD-MM-YYYY"], true)
                  : dayjs(value);

              return parsed.isValid() ? parsed.format("DD MMM YYYY") : "N/A";
            };
            const lastActivityDate =
              viewLead.lastActivityAt ||
              viewLead.lastActivityDate ||
              latestSummary?.date ||
              viewLead.updatedAt ||
              viewLead.createdAt;
            const expectedCloseDate =
              viewLead.expectedCloseDate ||
              viewLead.expected_close_date ||
              viewLead.expectedClose ||
              viewLead.expectedClosingDate ||
              viewLead.closeDate ||
              viewLead.closingDate ||
              viewLead.followUpDate ||
              latestSummary?.followUpDate;
            const leadTags = Array.isArray(viewLead.leadTags)
              ? viewLead.leadTags
              : [];
            const hasDescription = Boolean(
              viewLead.description && String(viewLead.description).trim(),
            );
            const descriptionHtml = hasDescription ? viewLead.description : "";
            const getPlainText = (html?: string) => {
              const temp = document.createElement("div");
              temp.innerHTML = html || "";
              return temp.textContent?.trim() || "Lead updated";
            };
            const inferLastActivityLabel = () => {
              const humanizeField = (value?: string) =>
                value
                  ? value
                      .replace(/([a-z])([A-Z])/g, "$1 $2")
                      .replace(/[_-]/g, " ")
                      .replace(/\blead\b/gi, "Lead")
                      .replace(/\b\w/g, (char) => char.toUpperCase())
                      .trim()
                  : "";
              const isGenericLabel = (value: string) =>
                /^(update|updated|lead updated|activity|crm)$/i.test(
                  value.trim(),
                );
              const explicitLabel =
                viewLead.lastActivityType ||
                viewLead.activityType ||
                latestSummary?.activityType ||
                latestSummary?.type ||
                latestLog?.activityType ||
                latestLog?.action ||
                latestLog?.type;
              const explicitField =
                latestLog?.field ||
                latestLog?.fieldName ||
                latestLog?.updatedField ||
                latestLog?.changedField ||
                latestSummary?.field ||
                latestSummary?.fieldName;

              if (explicitField && typeof explicitField === "string") {
                return `${humanizeField(explicitField)} Updated`;
              }

              if (
                explicitLabel &&
                typeof explicitLabel === "string" &&
                !isGenericLabel(explicitLabel)
              ) {
                return humanizeField(explicitLabel);
              }

              const activityText = getPlainText(
                String(latestLog?.message || latestSummary?.description || ""),
              ).replace(/\s+/g, " ");

              if (/whats\s*app|whatsapp/i.test(activityText)) return "WhatsApp";
              if (/email|mail/i.test(activityText)) return "Email";
              if (/call|phone/i.test(activityText)) return "Call";
              if (/added a new summary|summary added/i.test(activityText)) {
                return "Summary Added";
              }
              if (/summary/i.test(activityText)) return "Summary Updated";
              if (/status/i.test(activityText)) return "Status Updated";
              if (/priority/i.test(activityText)) return "Priority Updated";
              if (/assign|assignee/i.test(activityText)) {
                return "Assignee Updated";
              }
              if (/owner/i.test(activityText)) return "Owner Updated";
              if (/tag/i.test(activityText)) return "Tags Updated";
              if (/source/i.test(activityText)) return "Source Updated";
              if (/company/i.test(activityText)) return "Company Updated";
              if (/description/i.test(activityText)) {
                return "Description Updated";
              }
              if (/lead value|value/i.test(activityText)) {
                return "Lead Value Updated";
              }
              if (/expected|close date|closing|follow/i.test(activityText)) {
                return "Close Date Updated";
              }
              if (/updated/i.test(activityText)) return "Lead Details Updated";
              if (activityText && !isGenericLabel(activityText)) {
                return activityText.length > 34
                  ? `${activityText.slice(0, 34)}...`
                  : activityText;
              }

              return latestSummary ? "Summary" : latestLog ? "Activity" : "N/A";
            };
            const lastActivityLabel = inferLastActivityLabel();
            const getSummaryDescription = (summary: any) =>
              summary?.description || summary?.summary || "";
            const isEmptyHtml = (html?: string) =>
              !html || !html.trim() || html.trim() === "<p></p>";
            const currentStatusRecord =
              statuses.find((status) => status.name === currentStatus) ||
              (typeof leadStatusValue === "object" ? leadStatusValue : null) ||
              (currentStatus !== "N/A"
                ? {
                    _id: currentStatus,
                    name: currentStatus,
                    color: statusColor,
                  }
                : null);
            const pipelineStatuses = statuses.length
              ? statuses
              : currentStatus !== "N/A"
                ? [{ name: currentStatus, color: statusColor }]
                : [];
            const activeStageIndex = Math.max(
              0,
              pipelineStatuses.findIndex(
                (status: any) => status.name === currentStatus,
              ),
            );
            const activeStageColor =
              pipelineStatuses[activeStageIndex]?.color || statusColor;
            const drawerStatusOptions = statuses.length
              ? statuses
              : currentStatusRecord
                ? [currentStatusRecord]
                : [];
            const removedForThisLead = removedPipelineStages[viewLead._id] || [];
            const visiblePipelineStatuses = pipelineStatuses.filter(
              (s: any) => !removedForThisLead.includes(s.name),
            );
            const lastChainStage = drawerStageChain[drawerStageChain.length - 1];
            const chainActiveIndex = lastChainStage
              ? Math.max(0, visiblePipelineStatuses.findIndex((s: any) => s.name === lastChainStage.name))
              : visiblePipelineStatuses.findIndex((s: any) => s.name === (activeStageIndex >= 0 ? pipelineStatuses[activeStageIndex]?.name : ""));
            const chainActiveColor = lastChainStage?.color || activeStageColor;
            const currentStatusInChain = lastChainStage || currentStatusRecord;
            const statusChainActiveIndex = currentStatusInChain
              ? drawerStatusOptions.findIndex((s: any) => s.name === currentStatusInChain.name)
              : -1;
            const visibleStatusChain = statusChainActiveIndex >= 0
              ? drawerStatusOptions.slice(0, statusChainActiveIndex + 1).filter((s: any) => !removedForThisLead.includes(s.name))
              : [];

            const closeDrawer = () => {
              closeViewDrawer();
            };
            const headerCopyAction = (
              copyKey: string,
              value: string,
              icon: React.ReactNode,
              label: string,
              iconColor = "#dbe7f5",
            ) => {
              const copied = isClick === copyKey;
              const hasValue = Boolean(value);

              return (
                <div className="flex flex-col items-center text-center">
                  <Tooltip
                    title={
                      copied
                        ? "Copied"
                        : hasValue
                          ? `Copy ${label}`
                          : `${label} not available`
                    }
                    color="#f8fafc"
                    overlayInnerStyle={{ color: "#111827" }}
                  >
                    <Button
                      type="text"
                      shape="circle"
                      disabled={!hasValue}
                      icon={
                        copied ? (
                          <RiCheckLine size={17} />
                        ) : (
                          <span className="flex items-center justify-center text-[17px]">
                            {icon}
                          </span>
                        )
                      }
                      onClick={(event) => {
                        event.stopPropagation();
                        if (hasValue) {
                          handleViewLeadCopy(copyKey, value);
                        }
                      }}
                      style={{
                        width: 42,
                        height: 42,
                        color: copied ? "#22c55e" : iconColor,
                        backgroundColor: copied
                          ? "rgba(34,197,94,0.16)"
                          : "rgba(255,255,255,0.07)",
                        border: "1px solid rgba(255,255,255,0.12)",
                        boxShadow:
                          "inset 0 1px 0 rgba(255,255,255,0.08), 0 12px 24px rgba(0,0,0,0.2)",
                      }}
                    />
                  </Tooltip>
                  <p className="mt-2 mb-0 text-[12px] font-semibold leading-none text-slate-200">
                    {label}
                  </p>
                </div>
              );
            };
            const sectionTitle = (
              icon: React.ReactNode,
              title: string,
              action?: React.ReactNode,
            ) => (
              <div className="flex items-center justify-between gap-3 mb-4">
                <div className="flex items-center gap-3">
                  <span
                    className="inline-flex items-center justify-center w-9 h-9 rounded-lg"
                    style={{
                      backgroundColor: token?.colorFillTertiary || "#f8fafc",
                      color: ICON_COLOR,
                      border: `1px solid ${token?.colorBorderSecondary || "#e2e8f0"}`,
                    }}
                  >
                    {icon}
                  </span>
                  <h3 className="text-lg font-semibold text-slate-900 m-0">
                    {title}
                  </h3>
                </div>
                {action}
              </div>
            );
            const basicInfoItem = (
              Icon: React.ElementType<{
                size?: number | string;
                strokeWidth?: number | string;
                color?: string;
              }>,

              label: string,
              value: React.ReactNode,
              action?: React.ReactNode,
            ) => (
              <div className="flex min-w-0 items-start gap-4">
                <span
                  className="inline-flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-[12px] border"
                  style={{
                    borderColor: "#e5eaf0",
                    backgroundColor: "#ffffff",
                    boxShadow: "0 3px 10px rgba(15, 23, 42, 0.04)",
                  }}
                >
                  <Icon size={23} strokeWidth={2.2} color="#1677ff" />
                </span>
                <div className="min-w-0 flex-1 pt-1">
                  <p className="m-0 text-[14px] font-medium leading-tight text-[#697386]">
                    {label}
                  </p>
                  <div className="mt-2 break-words text-[15px] font-semibold leading-tight text-[#111827]">
                    {value || "-"}
                  </div>
                </div>
                {action}
              </div>
            );
            const summaryInfoCard = (
              Icon: React.ElementType<{
                size?: number | string;
                strokeWidth?: number | string;
                color?: string;
              }>,
              label: string,
              value: React.ReactNode,
              color: string,
              backgroundColor: string,
              valueColor = "#111827",
              subValue?: React.ReactNode,
            ) => (
              <div className="flex min-h-[86px] items-center gap-3 rounded-[10px] border border-[#e5e7eb] bg-white py-3 pl-3 pr-2 shadow-sm">
                <span
                  className="inline-flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-full"
                  style={{ backgroundColor }}
                >
                  <Icon size={27} strokeWidth={2.45} color={color} />
                </span>
                <div className="min-w-0 flex-1">
                  <p className="m-0 text-[14px] font-medium leading-tight text-[#697386]">
                    {label}
                  </p>
                  <div
                    className="mt-2 truncate text-[16px] font-semibold leading-tight"
                    style={{ color: valueColor }}
                  >
                    {value || "N/A"}
                  </div>
                  {subValue && (
                    <div className="mt-1 truncate text-[12px] font-medium leading-tight text-[#4b5563]">
                      {subValue}
                    </div>
                  )}
                </div>
              </div>
            );
            const getSummaryEventDate = (summary: any) =>
              summary?.date ||
              summary?.createdAt ||
              summary?.followUpDate ||
              viewLead.date;
            const getSummaryDateParts = (summary: any) => {
              const parsed = dayjs(getSummaryEventDate(summary));

              if (!parsed.isValid()) {
                return { day: "--", monthYear: "N/A", time: "--:--" };
              }

              return {
                day: parsed.format("DD"),
                monthYear: parsed.format("MMM YYYY"),
                time: parsed.format("HH:mm"),
              };
            };
            const formatSummaryFollowUpDate = (
              value?: string | Date | null,
            ) => {
              if (!value) return "N/A";

              const parsed =
                typeof value === "string" &&
                /^\d{1,2}-\d{1,2}-\d{4}/.test(value)
                  ? dayjs(
                      value,
                      [
                        "D-M-YYYY HH:mm",
                        "DD-MM-YYYY HH:mm",
                        "D-M-YYYY",
                        "DD-MM-YYYY",
                      ],
                      true,
                    )
                  : dayjs(value);
              return parsed.isValid()
                ? parsed.format("DD MMM YYYY, HH:mm")
                : "N/A";
            };
            const summaryTimelineMeta = [
              {
                icon: <Hourglass size={15} strokeWidth={2.6} />,
                color: "#4f9b67",
              },
              {
                icon: <LucideMail size={15} strokeWidth={2.5} />,
                color: "#1f7a45",
              },
              {
                icon: <Send size={15} strokeWidth={2.7} />,
                color: "#7c3aed",
              },
              {
                icon: <Bell size={15} strokeWidth={2.5} />,
                color: "#1677ff",
              },
              {
                icon: <FileText size={15} strokeWidth={2.5} />,
                color: "#f59e0b",
              },
            ];
            const getSummaryTimelineMeta = (index: number) =>
              summaryTimelineMeta[index % summaryTimelineMeta.length];
            const visibleSummaries = sortedSummaries;
            const nextSummaryDate = {
              day: dayjs().format("DD"),
              monthYear: dayjs().format("MMM YYYY"),
              time: "--:--",
            };
            const summaryDescriptionLength = Math.min(
              editor?.getText().length || 0,
              1000,
            );
            const updateSummaryFollowUpDate = (value: Dayjs | null) => {
              setNewSummary((previous) => {
                if (!value) {
                  return { ...previous, followUpDate: null };
                }

                const currentFollowUp =
                  previous.followUpDate || dayjs().hour(10).minute(0).second(0);

                return {
                  ...previous,
                  followUpDate: value
                    .hour(currentFollowUp.hour())
                    .minute(currentFollowUp.minute())
                    .second(0),
                };
              });
            };
            const updateSummaryFollowUpTime = (value: Dayjs | null) => {
              setNewSummary((previous) => {
                if (!value) {
                  return { ...previous, followUpDate: null };
                }

                const currentFollowUp = previous.followUpDate || dayjs();

                return {
                  ...previous,
                  followUpDate: currentFollowUp
                    .hour(value.hour())
                    .minute(value.minute())
                    .second(0),
                };
              });
            };
            const applyEditorLink = () => {
              if (!editor) return;

              const previousUrl = editor.getAttributes("link").href;
              const url = window.prompt("URL", previousUrl || "");

              if (url === null) return;
              if (url === "") {
                editor
                  .chain()
                  .focus()
                  .extendMarkRange("link")
                  .unsetLink()
                  .run();
                return;
              }

              editor
                .chain()
                .focus()
                .extendMarkRange("link")
                .setLink({ href: url })
                .run();
            };
            const summaryEditorTools = [
              {
                key: "bold",
                label: <strong>B</strong>,
                active: Boolean(editor?.isActive("bold")),
                onClick: () => editor?.chain().focus().toggleBold().run(),
              },
              {
                key: "italic",
                label: <em>I</em>,
                active: Boolean(editor?.isActive("italic")),
                onClick: () => editor?.chain().focus().toggleItalic().run(),
              },
              {
                key: "underline",
                label: <u>U</u>,
                active: Boolean(editor?.isActive("underline")),
                onClick: () => editor?.chain().focus().toggleUnderline().run(),
              },
              {
                key: "bullet",
                label: <List size={18} strokeWidth={2.4} />,
                active: Boolean(editor?.isActive("bulletList")),
                onClick: () => editor?.chain().focus().toggleBulletList().run(),
              },
              {
                key: "ordered",
                label: <ListOrdered size={18} strokeWidth={2.4} />,
                active: Boolean(editor?.isActive("orderedList")),
                onClick: () =>
                  editor?.chain().focus().toggleOrderedList().run(),
              },
              {
                key: "link",
                label: <Link2 size={17} strokeWidth={2.5} />,
                active: Boolean(editor?.isActive("link")),
                onClick: applyEditorLink,
              },
              {
                key: "clear",
                label: (
                  <span className="text-[14px] font-bold leading-none">
                    T<sub className="text-[10px]">x</sub>
                  </span>
                ),
                active: false,
                onClick: () =>
                  editor?.chain().focus().clearNodes().unsetAllMarks().run(),
              },
            ];
            return (
              <div className="min-h-full bg-slate-50 text-slate-900">
                <div
                  className="lead-details-hero relative px-[24px] pt-[26px] pb-[10px] text-white"
                  style={{
                    background:
                      "radial-gradient(circle at 12% 18%, rgba(18,94,166,0.28), transparent 32%), linear-gradient(135deg, #061728 0%, #03101f 56%, #071829 100%)",
                    position: "relative",
                    overflow: "visible",
                    minHeight: "172px",
                  }}
                >
                  <button
                    type="button"
                    onClick={closeDrawer}
                    className="lead-details-close"
                    style={{
                      position: "absolute",
                      top: "15px",
                      right: "22px",
                      width: "28px",
                      height: "28px",
                      borderRadius: "50%",
                      backgroundColor: "transparent",
                      border: "none",
                      color: "#d8e4f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      fontSize: "17px",
                      flexShrink: 0,
                      zIndex: 10,
                      lineHeight: 1,
                    }}
                  >
                    <CloseOutlined />
                  </button>

                  <div className="lead-details-hero-grid grid gap-4 pr-7 md:grid-cols-[minmax(0,1fr)_auto] md:items-start">
                    <div className="min-w-0">
                      <div className="flex min-w-0 items-start gap-4">
                        <Avatar
                          size={72}
                          className="shrink-0 shadow-lg"
                          style={{
                            border: "none",
                            backgroundColor: "#e6f0ff",
                            color: "#111827",
                            fontSize: 24,
                            fontWeight: 800,
                            boxShadow: "0 14px 32px rgba(0,0,0,0.28)",
                          }}
                        >
                          {profileInitials}
                        </Avatar>
                        <div className="min-w-0">
                          <h2 className="m-0 truncate text-[22px] font-bold leading-tight">
                            {viewLead.contactName || viewLead.title || "N/A"}
                          </h2>
                          {companyName && (
                            <p className="m-0 mt-0.5 truncate text-[14px] font-semibold text-slate-200">
                              {companyName}
                            </p>
                          )}
                          <div className="mt-1.5 flex flex-nowrap items-center gap-2 overflow-x-auto overflow-y-hidden pb-1">
                            <span
                              className="inline-flex h-[26px] items-center justify-center whitespace-nowrap rounded-md px-2.5 text-[10px] font-bold"
                              style={{
                                borderWidth: 1,
                                borderStyle: "solid",
                                borderColor: "#69b9ff",
                                backgroundColor: `${ACCENT}22`,
                                color: "#69b9ff",
                              }}
                            >
                              {viewLead.leadCode || "LEAD"}
                            </span>
                            <span
                              className="inline-flex h-[26px] items-center justify-center whitespace-nowrap rounded-md px-2.5 text-[10px] font-bold"
                              style={{
                                borderWidth: 1,
                                borderStyle: "solid",
                                borderColor: priorityColor,
                                backgroundColor: `${priorityColor}22`,
                                color: priorityColor,
                              }}
                            >
                              {priority}
                            </span>
                            <span
                              className="inline-flex h-[26px] max-w-[170px] items-center justify-center truncate whitespace-nowrap rounded-md px-2.5 text-[10px] font-bold"
                              style={{
                                borderWidth: 1,
                                borderStyle: "solid",
                                borderColor: statusColor,
                                backgroundColor: `${statusColor}22`,
                                color: statusColor,
                              }}
                            >
                              {currentStatus}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div
                        className="lead-details-stats mt-3 grid grid-cols-3 items-center gap-0"
                        style={{
                          width: 438,
                          maxWidth: "calc(100vw - 64px)",
                          marginLeft: -37,
                        }}
                      >
                        <div className="border-r border-white/15 px-2 text-center">
                          <p className="m-0 whitespace-nowrap text-[16px] font-bold leading-tight text-white tabular-nums">
                            {viewLead.rank || 0}
                          </p>
                          <p className="m-0 mt-0.5 text-[10px] font-semibold leading-tight text-[#b9c5d4]">
                            Rank
                          </p>
                        </div>
                        <div className="border-r border-white/15 px-2 text-center">
                          <p className="m-0 whitespace-nowrap text-[16px] font-bold leading-tight text-white">
                            {leadValue}
                          </p>
                          <p className="m-0 mt-0.5 text-[10px] font-semibold leading-tight text-[#b9c5d4]">
                            Lead Value
                          </p>
                        </div>
                        <div className="px-2 text-center">
                          <p className="m-0 whitespace-nowrap text-[16px] font-bold leading-tight text-white">
                            {addedOn}
                          </p>
                          <p className="m-0 mt-0.5 text-[10px] font-semibold leading-tight text-[#b9c5d4]">
                            Added on
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="lead-details-actions grid grid-cols-[repeat(2,72px)] justify-items-center gap-3 md:pt-[40px]">
                      {headerCopyAction(
                        `whatsapp-${phone}`,
                        phone,
                        <WhatsAppOutlined />,
                        "WhatsApp",
                        "#25d366",
                      )}
                      {headerCopyAction(
                        `email-${email}`,
                        email,
                        <MailOutlined />,
                        "Email",
                        "#dce6f2",
                      )}
                    </div>
                  </div>
                </div>

                <div className="lead-details-tabs sticky top-0 z-10 grid h-[76px] grid-cols-4 border-b border-[#dfe5ec] bg-white">
                  {[
                    {
                      key: "details",
                      icon: FileText,
                      label: "Details",
                    },
                    {
                      key: "summary",
                      icon: ChartNoAxesCombined,
                      label: "Summary",
                    },
                    {
                      key: "tags",
                      icon: LucideTags,
                      label: "Tags & Status",
                    },
                    {
                      key: "logs",
                      icon: Clock3,
                      label: "Logs",
                    },
                  ].map((tab) => {
                    const active = activeViewLeadTab === tab.key;
                    const tabColor = active ? "#1677ff" : "#4b5563";
                    const TabIcon = tab.icon;

                    return (
                      <button
                        key={tab.key}
                        type="button"
                        onClick={() => {
                          const nextTab = tab.key as
                            | "details"
                            | "summary"
                            | "tags"
                            | "logs";
                          setActiveViewLeadTab(nextTab);
                          if (nextTab !== "summary") {
                            closeSummaryComposer();
                          }
                          if (nextTab === "logs") {
                            fetchViewLeadLogs(viewLead._id);
                          }
                        }}
                        className="lead-details-tab relative flex items-center justify-center gap-1.5 px-2 text-[12px] font-semibold transition sm:gap-2.5 sm:px-3 sm:text-[14px]"
                        style={{
                          color: tabColor,
                          backgroundColor: "transparent",
                          fontWeight: 600,
                        }}
                      >
                        <span className="flex h-5 w-5 items-center justify-center leading-none">
                          <TabIcon
                            size={20}
                            strokeWidth={active ? 2.4 : 2.2}
                            color={tabColor}
                          />
                        </span>
                        <span>{tab.label}</span>
                        {active && (
                          <span
                            className="absolute bottom-[-1px] left-2 right-2 h-[3px] rounded-t-full"
                            style={{ backgroundColor: "#1677ff" }}
                          />
                        )}
                      </button>
                    );
                  })}
                </div>

                <div
                  className={`space-y-5 text-[15px] ${
                    activeViewLeadTab === "summary"
                      ? "px-2 py-3 sm:px-3 sm:py-5"
                      : "p-3 sm:p-4 md:p-6"
                  }`}
                >
                  {activeViewLeadTab === "details" && (
                    <>
                      <section id="lead-details">
                        <div className="mb-3 flex items-center justify-between">
                          <h3 className="m-0 text-[19px] font-semibold leading-tight text-[#111827]">
                            Basic Information
                          </h3>
                          <Button
                            icon={
                              <Pencil
                                size={19}
                                strokeWidth={2.6}
                                color="#1677ff"
                              />
                            }
                            onClick={() => setSectionEditVisible("basic")}
                            className="flex items-center justify-center gap-2 rounded-[8px] border border-[#e5e7eb] bg-white text-[14px] font-medium text-[#4b5563] shadow-sm"
                            style={{
                              width: 96,
                              height: 40,
                              padding: 0,
                            }}
                          >
                            Edit
                          </Button>
                        </div>

                        <div className="rounded-[12px] border border-[#e5e7eb] bg-white px-4 py-4 shadow-sm">
                          <div className="grid grid-cols-1 gap-x-12 gap-y-5 md:grid-cols-2">
                            {basicInfoItem(
                              LucideUser,
                              "Full Name",
                              viewLead.contactName || viewLead.title,
                            )}
                            {basicInfoItem(
                              Building2,
                              "Company",
                              viewLead.company,
                            )}
                            {basicInfoItem(
                              LucidePhone,
                              "Contact Number",
                              <span className="whitespace-nowrap tabular-nums">
                                {phone || "-"}
                              </span>,
                              phone ? (
                                <Tooltip
                                  title={isClick === "basic-phone" ? "Copied!" : "Copy"}
                                  overlayInnerStyle={{ fontSize: 12 }}
                                >
                                  <button
                                    type="button"
                                    onClick={() => handleViewLeadCopy("basic-phone", phone)}
                                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[6px] bg-transparent transition hover:bg-[#f1f5f9]"
                                    style={{ color: isClick === "basic-phone" ? "#22c55e" : "#64748b" }}
                                  >
                                    {isClick === "basic-phone" ? (
                                      <RiCheckLine size={15} />
                                    ) : (
                                      <RiFileCopyLine size={15} />
                                    )}
                                  </button>
                                </Tooltip>
                              ) : null,
                            )}
                            {basicInfoItem(
                              BriefcaseBusiness,
                              "Designation",
                              viewLead.designation ||
                                viewLead.jobTitle ||
                                viewLead.position ||
                                "-",
                            )}
                            {basicInfoItem(
                              LucideMail,
                              "Email Address",
                              email || "-",
                              email ? (
                                <Tooltip
                                  title={isClick === "basic-email" ? "Copied!" : "Copy"}
                                  overlayInnerStyle={{ fontSize: 12 }}
                                >
                                  <button
                                    type="button"
                                    onClick={() => handleViewLeadCopy("basic-email", email)}
                                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[6px] bg-transparent transition hover:bg-[#f1f5f9]"
                                    style={{ color: isClick === "basic-email" ? "#22c55e" : "#64748b" }}
                                  >
                                    {isClick === "basic-email" ? (
                                      <RiCheckLine size={15} />
                                    ) : (
                                      <RiFileCopyLine size={15} />
                                    )}
                                  </button>
                                </Tooltip>
                              ) : null,
                            )}
                            {basicInfoItem(
                              MapPin,
                              "Location",
                              viewLead.location ||
                                viewLead.country ||
                                viewLead.city ||
                                "-",
                            )}
                          </div>
                        </div>
                      </section>

                      <section className="rounded-[12px] border border-[#e5e7eb] bg-white px-4 py-3.5 shadow-sm">
                        <div className="mb-4 flex items-center justify-between">
                          <h3 className="m-0 text-[19px] font-semibold leading-tight text-[#111827]">
                            Description
                          </h3>
                          <Button
                            icon={
                              <Pencil
                                size={19}
                                strokeWidth={2.6}
                                color="#1677ff"
                              />
                            }
                            onClick={() => setSectionEditVisible("description")}
                            className="flex items-center justify-center gap-2 rounded-[8px] border border-[#e5e7eb] bg-white text-[14px] font-medium text-[#4b5563] shadow-sm"
                            style={{
                              width: 96,
                              height: 40,
                              padding: 0,
                            }}
                          >
                            Edit
                          </Button>
                        </div>

                        {hasDescription ? (
                          <div className="description-preview text-[14px] font-medium leading-[1.65] text-[#5f6b7a]">
                            <TwoLineClampWithTooltip text={descriptionHtml} tooltipMaxWidth="800px" />
                          </div>
                        ) : (
                          <p className="m-0 text-[14px] font-medium leading-[1.65] text-[#5f6b7a]">
                            No description added.
                          </p>
                        )}
                      </section>

                      <section className="rounded-[12px] border border-[#e5e7eb] bg-white px-4 py-3.5 shadow-sm">
                        <div className="mb-4 flex items-center justify-between">
                          <h3 className="m-0 text-[19px] font-semibold leading-tight text-[#111827]">
                            Source Information
                          </h3>
                          <Button
                            icon={
                              <Pencil
                                size={19}
                                strokeWidth={2.6}
                                color="#1677ff"
                              />
                            }
                            onClick={() => setSectionEditVisible("source")}
                            className="flex items-center justify-center gap-2 rounded-[8px] border border-[#e5e7eb] bg-white text-[14px] font-medium text-[#4b5563] shadow-sm"
                            style={{
                              width: 96,
                              height: 40,
                              padding: 0,
                            }}
                          >
                            Edit
                          </Button>
                        </div>

                        <div className="grid grid-cols-1 gap-x-16 gap-y-4 md:grid-cols-[280px_minmax(0,1fr)]">
                          <div>
                            <p className="m-0 text-[14px] font-medium leading-tight text-[#697386]">
                              Source
                            </p>
                            <span
                              className="mt-2 inline-flex min-h-[34px] items-center rounded-[7px] px-3.5 text-[14px] font-semibold leading-tight"
                              style={{
                                backgroundColor: `${sourceColor}1A`,
                                color: sourceColor,
                              }}
                            >
                              {sourceName}
                            </span>
                          </div>
                          <div
                            className="min-w-0"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              rowGap: 7,
                            }}
                          >
                            <p className="m-0 text-[14px] font-medium leading-tight text-[#697386]">
                              Source Link
                            </p>
                            <div className="mt-2 flex min-w-0 items-center gap-3">
                              {(() => {
                                const srcIcon = getSourceIconFromUrl(viewLead.link) ?? getSourceIcon(sourceName);
                                return srcIcon ? (
                                  <srcIcon.Icon
                                    size={20}
                                    className="shrink-0"
                                    style={{ color: srcIcon.color }}
                                  />
                                ) : (
                                  <LinkOutlined
                                    className="shrink-0 text-[20px]"
                                    style={{ color: "#1677ff" }}
                                  />
                                );
                              })()}
                              {viewLead.link ? (
                                <a
                                  href={viewLead.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="min-w-0 truncate text-[15px] font-medium leading-tight text-[#1677ff]"
                                >
                                  {viewLead.link}
                                </a>
                              ) : (
                                <span className="min-w-0 truncate text-[15px] font-medium leading-tight text-[#111827]">
                                  -
                                </span>
                              )}
                              {viewLead.link && (
                                <Tooltip
                                  title={isClick === "source-link" ? "Copied!" : "Copy"}
                                  overlayInnerStyle={{ fontSize: 12 }}
                                >
                                  <button
                                    type="button"
                                    onClick={() => handleViewLeadCopy("source-link", viewLead.link)}
                                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[6px] bg-transparent transition hover:bg-[#f1f5f9]"
                                    style={{ color: isClick === "source-link" ? "#22c55e" : "#64748b" }}
                                  >
                                    {isClick === "source-link" ? (
                                      <RiCheckLine size={15} />
                                    ) : (
                                      <RiFileCopyLine size={15} />
                                    )}
                                  </button>
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        </div>
                      </section>

                      <section className="pt-1">
                        <h3 className="mb-2 mt-3 text-[18px] font-semibold leading-tight text-[#111827]">
                          Summary
                        </h3>
                        <div className="lead-details-summary-grid grid gap-x-4 gap-y-3">
                          {summaryInfoCard(
                            IndianRupee,
                            "Lead Value",
                            leadValue,
                            "#16a34a",
                            "#dcfce7",
                            "#16a34a",
                          )}
                          {summaryInfoCard(
                            ProbabilityIcon,
                            "Probability",
                            probabilityValue,
                            "#2563eb",
                            "#dbeafe",
                            "#2563eb",
                          )}
                          {summaryInfoCard(
                            Flag,
                            "Stage",
                            currentStatus,
                            "#f59e0b",
                            "#fff7ed",
                            statusColor,
                          )}
                          {summaryInfoCard(
                            LucideUser,
                            "Assigned To",
                            assignedToName,
                            "#7c3aed",
                            "#f3e8ff",
                          )}
                          {summaryInfoCard(
                            Clock3,
                            "Last Activity",
                            formatDisplayDate(lastActivityDate),
                            "#f59e0b",
                            "#ffedd5",
                            "#111827",
                            lastActivityLabel,
                          )}
                          {summaryInfoCard(
                            CalendarDays,
                            "Expected Close Date",
                            formatDisplayDate(expectedCloseDate),
                            "#ef4444",
                            "#fee2e2",
                          )}
                        </div>
                      </section>

                      <section className="pt-3">
                        <div className="rounded-[10px] border border-[#e5e7eb] bg-white shadow-sm">
                          <h3 className="m-0 border-b border-[#eef2f6] px-3.5 py-3 text-[18px] font-semibold leading-tight text-[#111827]">
                            Tags & Status
                          </h3>

                          <div className="px-3.5 py-3">
                            <p className="m-0 mb-3 text-[15px] font-semibold text-[#111827]">
                              Tags
                            </p>
                            <div className="flex flex-wrap gap-2.5">
                              {leadTags.length ? (
                                leadTags.map((tag: any) => {
                                  const tagColor = tag.color || "#16a34a";
                                  return (
                                    <span
                                      key={tag._id || tag.name}
                                      className="inline-flex h-[34px] items-center gap-2 rounded-[7px] px-3 text-[13px] font-semibold"
                                      style={{
                                        backgroundColor: `${tagColor}18`,
                                        color: tagColor,
                                      }}
                                    >
                                      {tag.name}
                                      {tag._id && (
                                        <button
                                          type="button"
                                          className="inline-flex h-5 w-5 items-center justify-center border-0 bg-transparent p-0"
                                          style={{ color: tagColor }}
                                          onClick={(event) => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            handleRemoveTag(
                                              viewLead._id,
                                              tag._id,
                                              leadTags,
                                            );
                                          }}
                                          aria-label={`Remove ${tag.name}`}
                                        >
                                          <X size={14} strokeWidth={2.6} />
                                        </button>
                                      )}
                                    </span>
                                  );
                                })
                              ) : (
                                <span className="text-[13px] font-medium text-[#697386]">
                                  No tags added
                                </span>
                              )}

                              <Dropdown
                                trigger={["click"]}
                                menu={{
                                  items: allTags.map((tag) => {
                                    const tagColor = tag.color || "#16a34a";

                                    return {
                                      key: tag._id,
                                      label: (
                                        <span
                                          style={{
                                            color: tagColor,
                                            fontWeight: 700,
                                          }}
                                        >
                                          {tag.name}
                                        </span>
                                      ),
                                    };
                                  }),
                                  onClick: ({ key }) =>
                                    handleAddTag(
                                      viewLead._id,
                                      key,
                                      leadTags || [],
                                    ),
                                }}
                              >
                                <Button className="flex h-[34px] items-center gap-2 rounded-[7px] border border-[#e5e7eb] bg-white px-3 text-[13px] font-semibold text-[#1677ff] shadow-sm">
                                  <Plus size={16} strokeWidth={2.6} />
                                  Add Tag
                                </Button>
                              </Dropdown>
                            </div>
                          </div>

                          <div className="border-b border-[#eef2f6] rounded-md px-3.5 py-3">
                            <p className="m-0 mb-2 text-[15px] font-semibold text-[#111827]">Status</p>
                            <div className="flex flex-wrap items-center gap-2">
                              {visibleStatusChain.length > 0 ? (
                                visibleStatusChain.map((s: any, i: number) => (
                                  <React.Fragment key={`${s._id || s.name}-${i}`}>
                                    {i > 0 && <ChevronRight size={14} strokeWidth={2.5} className="text-[#9ca3af] shrink-0" />}
                                    <span
                                      className="inline-flex h-[34px] items-center rounded-[7px] px-3 text-[13px] font-semibold"
                                      style={{ backgroundColor: `${s.color || "#16a34a"}18`, color: s.color || "#16a34a" }}
                                    >
                                      {s.name}
                                    </span>
                                  </React.Fragment>
                                ))
                              ) : (
                                <span className="text-[13px] font-medium text-[#697386]">No status set</span>
                              )}
                              <Dropdown
                                trigger={["click"]}
                                menu={{
                                  items: drawerStatusOptions.map((status: any) => ({
                                    key: status._id || status.name,
                                    label: <span style={{ color: status.color || "#16a34a", fontWeight: 700 }}>{status.name}</span>,
                                  })),
                                  onClick: ({ key }) => {
                                    const selected = drawerStatusOptions.find((s: any) => (s._id || s.name) === key);
                                    if (selected) {
                                      handleStatusChange(viewLead._id, selected.name);
                                      setViewLead((previous: any) => previous ? { ...previous, leadstatus: selected } : previous);
                                      setDrawerStageChain((prev) => [...prev, selected]);
                                      setRemovedPipelineStages((prev) => {
                                        const updated = { ...prev, [viewLead._id]: (prev[viewLead._id] || []).filter((n) => n !== selected.name) };
                                        localStorage.setItem("crm_removedPipelineStages", JSON.stringify(updated));
                                        return updated;
                                      });
                                    }
                                  },
                                }}
                              >
                                <Button className="flex h-[34px] items-center gap-2 rounded-[7px] border border-[#e5e7eb] bg-white px-3 text-[13px] font-semibold text-[#1677ff] shadow-sm">
                                  <Plus size={16} strokeWidth={2.6} />
                                  Add
                                </Button>
                              </Dropdown>
                            </div>
                          </div>

                          <div className="px-3.5 pb-2 pt-3">
                            <div className="flex items-center justify-between mb-2">
                              <p className="m-0 text-[15px] font-semibold text-[#111827]">
                                Pipeline Stage
                              </p>
                              <Dropdown
                                trigger={["click"]}
                                menu={{
                                  items: pipelineStatuses.map((status: any) => {
                                    const sColor = status.color || "#16a34a";
                                    return {
                                      key: status._id || status.name,
                                      label: (
                                        <span style={{ color: sColor, fontWeight: 700 }}>
                                          {status.name}
                                        </span>
                                      ),
                                    };
                                  }),
                                  onClick: ({ key }) => {
                                    const selected = pipelineStatuses.find(
                                      (s: any) => (s._id || s.name) === key,
                                    );
                                    if (selected) {
                                      handleStatusChange(viewLead._id, selected.name);
                                      setViewLead((previous: any) =>
                                        previous ? { ...previous, leadstatus: selected } : previous,
                                      );
                                      setDrawerStageChain((prev) => [...prev, selected]);
                                      setRemovedPipelineStages((prev) => {
                                        const updated = { ...prev, [viewLead._id]: (prev[viewLead._id] || []).filter((n) => n !== selected.name) };
                                        localStorage.setItem("crm_removedPipelineStages", JSON.stringify(updated));
                                        return updated;
                                      });
                                    }
                                  },
                                }}
                              >
                                <Button className="flex h-[34px] items-center gap-2 rounded-[7px] border border-[#e5e7eb] bg-white px-3 text-[13px] font-semibold text-[#1677ff] shadow-sm">
                                  <Plus size={16} strokeWidth={2.6} />
                                  Add
                                </Button>
                              </Dropdown>
                            </div>
                            <div className="overflow-x-auto pb-1" style={{ scrollbarWidth: "thin", scrollbarColor: "#cbd5e1 transparent" }}>
                              <div
                                className="relative grid items-start pt-3"
                                style={{
                                  minWidth: `${Math.max(360, visiblePipelineStatuses.length * 76)}px`,
                                  gridTemplateColumns: `repeat(${visiblePipelineStatuses.length || 1}, minmax(0, 1fr))`,
                                }}
                              >
                                {visiblePipelineStatuses.length > 1 && (
                                  <span
                                    className="absolute top-[21px] h-[2px] rounded-full bg-[#9ca3af]"
                                    style={{
                                      left: `${50 / visiblePipelineStatuses.length}%`,
                                      right: `${50 / visiblePipelineStatuses.length}%`,
                                    }}
                                  />
                                )}
                                {visiblePipelineStatuses.length > 1 && chainActiveIndex > 0 && (
                                  <span
                                    className="absolute top-[21px] h-[2px] rounded-full"
                                    style={{
                                      left: `${50 / visiblePipelineStatuses.length}%`,
                                      right: `${((visiblePipelineStatuses.length - chainActiveIndex - 0.5) / visiblePipelineStatuses.length) * 100}%`,
                                      backgroundColor: chainActiveColor,
                                    }}
                                  />
                                )}
                                {visiblePipelineStatuses.map((status: any, index: number) => {
                                  const colored = index <= chainActiveIndex;
                                  const dotNode = (
                                    <div className="relative flex flex-1 flex-col items-center text-center cursor-pointer">
                                      <span
                                        className="relative z-[1] h-[18px] w-[18px] rounded-full"
                                        style={{
                                          backgroundColor: colored ? chainActiveColor : "#8b95a1",
                                          boxShadow: "0 0 0 1px rgba(15, 23, 42, 0.08)",
                                        }}
                                      />
                                      <span
                                        className="mt-2 max-w-[68px] text-[10px] font-semibold leading-tight"
                                        style={{ color: colored ? chainActiveColor : "#5f6673" }}
                                      >
                                        {status.name}
                                      </span>
                                    </div>
                                  );
                                  if (colored) {
                                    return (
                                      <Dropdown
                                        key={status._id || status.name || index}
                                        trigger={["click"]}
                                        menu={{
                                          items: [
                                            {
                                              key: "remove",
                                              label: (
                                                <span className="flex items-center gap-2 text-[#ef4444] font-semibold text-[13px]">
                                                  <Trash2 size={13} strokeWidth={2.2} />
                                                  Remove stage
                                                </span>
                                              ),
                                            },
                                          ],
                                          onClick: () => {
                                            setRemovedPipelineStages((prev) => ({ ...prev, [viewLead._id]: [...(prev[viewLead._id] || []), status.name] }));
                                          },
                                        }}
                                      >
                                        {dotNode}
                                      </Dropdown>
                                    );
                                  }
                                  return (
                                    <div
                                      key={status._id || status.name || index}
                                      className="relative flex flex-1 flex-col items-center text-center cursor-pointer"
                                      onClick={() => {
                                        handleStatusChange(viewLead._id, status.name);
                                        setViewLead((previous: any) =>
                                          previous ? { ...previous, leadstatus: status } : previous,
                                        );
                                        setDrawerStageChain((prev) => [...prev, status]);
                                      }}
                                    >
                                      <span
                                        className="relative z-[1] h-[18px] w-[18px] rounded-full"
                                        style={{
                                          backgroundColor: "#8b95a1",
                                          boxShadow: "0 0 0 1px rgba(15, 23, 42, 0.08)",
                                        }}
                                      />
                                      <span
                                        className="mt-2 max-w-[68px] text-[10px] font-semibold leading-tight"
                                        style={{ color: "#5f6673" }}
                                      >
                                        {status.name}
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>

                      </section>
                    </>
                  )}

                  {activeViewLeadTab === "summary" && (
                    <section className="summary-tab-section overflow-hidden rounded-[10px] border border-[#dfe5ec] bg-white shadow-sm">
                      <Spin spinning={summaryLoading}>
                        <div
                          className={`summary-responsive-layout grid bg-[#fbfcfe] ${
                            summaryComposerOpen
                              ? "summary-responsive-layout--composer-open"
                              : ""
                          }`}
                        >
                          <div
                            ref={summaryPanelRef}
                            className={`summary-history-panel summary-scroll-region min-w-0 pb-6 ${
                              summaryComposerOpen
                                ? "px-4 lg:border-r lg:border-[#e5eaf0] lg:pl-5 lg:pr-4"
                                : "px-4 sm:px-5"
                            }`}
                          >
                            <div className="sticky top-0 z-20 bg-[#fbfcfe] mb-4 pt-6 pb-3 flex flex-wrap items-center justify-between gap-4">
                              <div className="flex items-center gap-3">
                                <Activity
                                  size={19}
                                  strokeWidth={2.4}
                                  color="#1f7a45"
                                />
                                <h4 className="m-0 text-[16px] font-bold text-[#111827]">
                                  Follow-up History
                                </h4>
                              </div>
                            </div>

                            <div className="relative">
                              {visibleSummaries.length ? (
                                visibleSummaries.map((summary, index) => {
                                  const dateParts =
                                    getSummaryDateParts(summary);
                                  const meta = getSummaryTimelineMeta(index);
                                  const descriptionHtml =
                                    getSummaryDescription(summary);
                                  const followUpDate =
                                    formatSummaryFollowUpDate(
                                      summary.followUpDate ||
                                        summary.nextActionDate,
                                    );
                                  const addedBy =
                                    getUserName(summary.createdBy) ||
                                    getUserName(summary.addedBy) ||
                                    getUserName(summary.user) ||
                                    "You";
                                  const selectedForEditing =
                                    Boolean(editingSummaryId) &&
                                    String(summary._id) ===
                                      String(editingSummaryId);

                                  return (
                                    <div
                                      key={
                                        summary._id ||
                                        `${dateParts.day}-${index}`
                                      }
                                      className="lead-details-timeline-row relative grid grid-cols-[118px_minmax(0,1fr)] gap-3 pb-4 last:pb-0"
                                    >
                                      <div className="lead-details-timeline-meta relative flex items-start gap-6">
                                        <span className="absolute left-[14px] top-0 bottom-[-18px] w-px bg-[#d8dde6]" />
                                        <span
                                          className="relative z-[1] mt-[10px] flex h-[29px] w-[29px] shrink-0 items-center justify-center rounded-full text-white shadow-sm"
                                          style={{
                                            color: "#ffffff",
                                            backgroundColor: meta.color,
                                            border:
                                              "1px solid rgba(15,23,42,0.05)",
                                          }}
                                        >
                                          {meta.icon}
                                        </span>
                                        <div
                                          className="w-[58px] shrink-0 pt-[8px]"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            rowGap: 10,
                                          }}
                                        >
                                          <p className="m-0 text-[18px] font-bold leading-none text-[#111827]">
                                            {dateParts.day}
                                          </p>
                                          <p className="m-0 whitespace-nowrap text-[11px] font-medium leading-none text-[#111827]">
                                            {dateParts.monthYear}
                                          </p>
                                          <p className="m-0 text-[11px] font-normal leading-none text-[#111827]">
                                            {dateParts.time}
                                          </p>
                                        </div>
                                      </div>

                                      <div
                                        className={`relative rounded-[8px] border px-4 py-3 ${
                                          selectedForEditing
                                            ? "border-[#1f7a45] bg-[#f4fbf6] shadow-[0_0_0_2px_rgba(31,122,69,0.16)]"
                                            : "border-[#e2e7ef] bg-white shadow-[0_10px_24px_rgba(15,23,42,0.06)]"
                                        }`}
                                      >
                                        <span
                                          className={`absolute left-[-7px] top-[32px] h-3.5 w-3.5 rotate-45 border-b border-l ${
                                            selectedForEditing
                                              ? "border-[#1f7a45] bg-[#f4fbf6]"
                                              : "border-[#e2e7ef] bg-white"
                                          }`}
                                        />
                                        <div className="absolute right-3 top-3 z-10 flex h-8 items-center justify-end gap-2">
                                            <Tooltip title="Edit">
                                              <span className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center">
                                                <button
                                                  type="button"
                                                  onClick={() =>
                                                    openSummaryComposerForEdit(
                                                      summary,
                                                    )
                                                  }
                                                  className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-[4px] border border-[#e5e7eb] bg-white p-0 leading-none text-[#334155] transition hover:border-[#cbd5e1] hover:bg-[#f8fafc]"
                                                  aria-label="Edit"
                                                >
                                                  <Pencil
                                                    size={15}
                                                    strokeWidth={2.1}
                                                    className="pointer-events-none"
                                                  />
                                                </button>
                                              </span>
                                            </Tooltip>
                                            <Tooltip title="Delete">
                                              <span className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center">
                                                <button
                                                  type="button"
                                                  onClick={() => {
                                                    if (
                                                      !summary._id ||
                                                      !viewLead._id
                                                    ) {
                                                      return;
                                                    }

                                                    setSummaryDeleteTarget({
                                                      rawDataId: viewLead._id,
                                                      summaryId: summary._id,
                                                    });
                                                  }}
                                                  className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-[4px] border border-[#e5e7eb] bg-white p-0 leading-none text-[#ef4444] transition hover:border-[#fca5a5] hover:bg-[#fff7f7]"
                                                  aria-label="Delete"
                                                >
                                                  <Trash2
                                                    size={15}
                                                    strokeWidth={2.1}
                                                    className="pointer-events-none"
                                                  />
                                                </button>
                                              </span>
                                            </Tooltip>
                                        </div>

                                        <TwoLineClampWithTooltip
                                          text={
                                            isEmptyHtml(descriptionHtml)
                                              ? "No description"
                                              : descriptionHtml
                                          }
                                          preserveFormatting
                                          tooltipPlacement="topLeft"
                                          className="summary-history-description mr-[76px] text-[14px] font-medium leading-relaxed text-[#4b5563]"
                                        />

                                        <div className="mt-2 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-[#eef2f6] pt-2 text-[13px] font-semibold text-[#3f5f4c]">
                                          <span className="inline-flex items-center gap-2">
                                            <Calendar
                                              size={17}
                                              strokeWidth={2.3}
                                            />
                                            Follow up: {followUpDate}
                                          </span>
                                          <span className="hidden h-5 w-px bg-[#dfe5ec] sm:inline-flex" />
                                          <span className="inline-flex items-center gap-2 text-[#4b5563]">
                                            <CircleUserRound
                                              size={17}
                                              strokeWidth={2.3}
                                            />
                                            Added by: {addedBy}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="rounded-[8px] border border-dashed border-[#cfd7e3] bg-white px-5 py-10 text-center text-[14px] font-semibold text-[#64748b]">
                                  No summaries found
                                </div>
                              )}

                              <div className="lead-details-timeline-row relative mt-1 grid grid-cols-[118px_minmax(0,1fr)] gap-3">
                                <div className="lead-details-timeline-meta relative flex items-start gap-6">
                                  <span className="absolute left-[14px] top-0 bottom-0 w-px border-l border-dashed border-[#c7ced8]" />
                                  <span className="relative z-[1] mt-[10px] flex h-[29px] w-[29px] shrink-0 items-center justify-center rounded-full border border-dashed border-[#94a3b8] bg-white text-[#1f7a45]">
                                    <Plus size={17} strokeWidth={2.4} />
                                  </span>
                                  <div
                                    className="w-[58px] shrink-0 pt-[8px]"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      rowGap: 10,
                                    }}
                                  >
                                    <p className="m-0 text-[18px] font-bold leading-none text-[#111827]">
                                      {nextSummaryDate.day}
                                    </p>
                                    <p className="m-0 whitespace-nowrap text-[11px] font-medium leading-none text-[#111827]">
                                      {nextSummaryDate.monthYear}
                                    </p>
                                    <p className="m-0 text-[11px] font-normal leading-none text-[#111827]">
                                      {nextSummaryDate.time}
                                    </p>
                                  </div>
                                </div>

                                <button
                                  ref={addSummaryBtnRef}
                                  type="button"
                                  onClick={openSummaryComposer}
                                  className="summary-open-composer group flex min-h-[96px] items-center gap-4 rounded-[8px] px-5 py-4 text-left"
                                >
                                  <span className="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-full bg-[#146c43] text-white shadow-sm transition group-hover:bg-[#1f7a45]">
                                    <Plus size={24} strokeWidth={2.4} />
                                  </span>
                                  <span className="min-w-0">
                                    <span className="block text-[16px] font-bold leading-tight text-[#111827]">
                                      Add new summary
                                    </span>
                                    <span className="mt-2 block text-[13px] font-medium leading-tight text-[#4b5563]">
                                      Click to add a new follow-up summary
                                    </span>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>

                          {summaryComposerOpen && (
                            <aside className="summary-composer-panel min-w-0 bg-white py-6 pl-4 pr-6 h-full flex flex-col">
                              {/* Header */}
                              <div className="mb-6 flex items-center justify-between gap-3">
                                <div className="flex min-w-0 items-center gap-3">
                                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#edf6f0] text-[#1e5631]">
                                    <Pencil size={20} strokeWidth={2.5} />
                                  </span>
                                  <h4 className="m-0 truncate text-lg font-bold text-gray-900">
                                    {editingSummaryId
                                      ? "Update Summary"
                                      : "Add New Summary"}
                                  </h4>
                                </div>
                                <Tooltip title="Close">
                                  <button
                                    type="button"
                                    onClick={closeSummaryComposer}
                                    className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-0 bg-transparent text-[#64748b] transition hover:bg-[#f1f5f9] hover:text-[#111827]"
                                    aria-label="Close summary composer"
                                  >
                                    <X size={17} strokeWidth={2.2} />
                                  </button>
                                </Tooltip>
                              </div>

                              <div className="summary-scroll-region min-h-0 flex-1 space-y-6 overflow-y-auto pr-1">
                                {/* Description */}
                                <div>
                                  <label className="mb-2 block text-[13px] font-semibold text-gray-800">
                                    Description
                                  </label>
                                  <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
                                    {/* Toolbar */}
                                    <div className="flex items-center overflow-x-auto border-b border-gray-100 bg-[#f9fafb] px-2 py-2">
                                      <div className="inline-flex items-center gap-2">
                                        {summaryEditorTools.map((tool, index) => (
                                          <React.Fragment key={tool.key}>
                                            {index === 3 && (
                                              <span className="mx-1 h-6 w-px shrink-0 bg-gray-200" />
                                            )}
                                            <button
                                              type="button"
                                              onMouseDown={(event) => {
                                                event.preventDefault();
                                              }}
                                              onClick={tool.onClick}
                                              aria-pressed={tool.active}
                                              className="flex h-8 w-8 items-center justify-center rounded border border-gray-200 text-gray-600 transition hover:bg-gray-100 hover:text-gray-900"
                                              style={{
                                                borderColor: tool.active
                                                  ? "#1e5631"
                                                  : "#e5e7eb",
                                                backgroundColor: tool.active
                                                  ? "#edf6f0"
                                                  : "#ffffff",
                                                color: tool.active
                                                  ? "#1e5631"
                                                  : "#4b5563",
                                                boxShadow:
                                                  "0 1px 2px rgba(0,0,0,0.02)",
                                              }}
                                            >
                                              {tool.label}
                                            </button>
                                          </React.Fragment>
                                        ))}
                                      </div>
                                    </div>
                                    {/* Editor Area */}
                                    <div className="relative bg-white min-h-[160px]">
                                      <EditorContent
                                        editor={editor}
                                        className="summary-editor min-h-[140px] w-full p-3 text-sm text-gray-800 outline-none"
                                      />
                                      <span className="absolute bottom-2 right-3 text-xs font-medium text-gray-400">
                                        {summaryDescriptionLength} / 1000
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                {/* Follow-up Date & Time */}
                                <div>
                                  <label className="mb-2 block text-[13px] font-semibold text-gray-800">
                                    Follow-up Date & Time
                                  </label>
                                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                    <DatePicker
                                      value={newSummary.followUpDate}
                                      onChange={updateSummaryFollowUpDate}
                                      format="DD-MM-YYYY"
                                      placeholder="Select date"
                                      className="summary-date-picker h-[42px] w-full rounded-lg border-gray-200"
                                      prefix={
                                        <Calendar
                                          size={16}
                                          className="mr-2 text-[#667085]"
                                        />
                                      }
                                      suffixIcon={null}
                                    />
                                    <TimePicker
                                      value={newSummary.followUpDate}
                                      onChange={updateSummaryFollowUpTime}
                                      format="HH:mm"
                                      needConfirm={false}
                                      placeholder="Select time"
                                      className="summary-date-picker h-[42px] w-full rounded-lg border-gray-200"
                                      prefix={
                                        <Clock
                                          size={16}
                                          className="mr-2 text-[#667085]"
                                        />
                                      }
                                      suffixIcon={null}
                                    />
                                  </div>
                                </div>

                                {/* Actions */}
                                <div
                                  className="flex items-center justify-end"
                                  style={{
                                    marginTop: 10,
                                    paddingTop: 0,
                                    gap: 10,
                                  }}
                                >
                                  <Button
                                    onClick={resetSummaryForm}
                                    className="rounded-[5px] border-gray-200 text-[12px] font-semibold text-gray-700 hover:border-gray-300 hover:text-gray-900"
                                    style={{
                                      width: 88,
                                      height: 38,
                                      padding: "0 16px",
                                    }}
                                  >
                                    Clear
                                  </Button>
                                  <Button
                                    type="primary"
                                    onClick={handleDrawerAddSummary}
                                    icon={
                                      editingSummaryId ? (
                                        <Pencil size={17} strokeWidth={2.4} />
                                      ) : (
                                        <Plus size={17} strokeWidth={2.4} />
                                      )
                                    }
                                    className="summary-add-button flex items-center justify-center rounded-[5px] border-none bg-[#1e5631] text-[12px] font-semibold shadow-sm"
                                    style={{
                                      width: 144,
                                      height: 38,
                                      padding: "0 18px",
                                    }}
                                  >
                                    {editingSummaryId
                                      ? "Update"
                                      : "Add Summary"}
                                  </Button>
                                </div>
                              </div>
                            </aside>
                          )}
                        </div>
                      </Spin>

                      <div className="flex flex-wrap items-center justify-between gap-3 border-t border-[#e5eaf0] bg-[#f8fafc] px-4 py-2 sm:px-6">
                        <span className="flex items-center gap-2 text-[12px] font-medium text-[#4b5563]">
                          <Clock size={17} strokeWidth={2.3} color="#64748b" />
                          All times are in Asia/Kolkata (IST)
                        </span>
                        <Button
                          onClick={closeDrawer}
                          className="h-[42px] rounded-[7px] px-7 text-[14px] font-bold text-[#111827]"
                        >
                          Close
                        </Button>
                      </div>
                    </section>
                  )}

                  {activeViewLeadTab === "tags" && (
                    <section
                      id="lead-tags"
                      className="rounded-[10px] border border-[#e5e7eb] bg-white shadow-sm"
                    >
                      <h3 className="m-0 border-b border-[#eef2f6] px-3.5 py-3 text-[18px] font-semibold leading-tight text-[#111827]">
                        Tags & Status
                      </h3>

                      <div className="px-3.5 py-3">
                        <p className="m-0 mb-3 text-[15px] font-semibold text-[#111827]">
                          Tags
                        </p>
                        <div className="flex flex-wrap gap-2.5">
                          {leadTags.length ? (
                            leadTags.map((tag: any) => {
                              const tagColor = tag.color || "#16a34a";
                              return (
                                <span
                                  key={tag._id || tag.name}
                                  className="inline-flex h-[34px] items-center gap-2 rounded-[7px] px-3 text-[13px] font-semibold"
                                  style={{
                                    backgroundColor: `${tagColor}18`,
                                    color: tagColor,
                                  }}
                                >
                                  {tag.name}
                                  {tag._id && (
                                    <button
                                      type="button"
                                      className="inline-flex h-5 w-5 items-center justify-center border-0 bg-transparent p-0"
                                      style={{ color: tagColor }}
                                      onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        handleRemoveTag(
                                          viewLead._id,
                                          tag._id,
                                          leadTags,
                                        );
                                      }}
                                      aria-label={`Remove ${tag.name}`}
                                    >
                                      <X size={14} strokeWidth={2.6} />
                                    </button>
                                  )}
                                </span>
                              );
                            })
                          ) : (
                            <span className="text-[13px] font-medium text-[#697386]">
                              No tags added
                            </span>
                          )}

                          <Dropdown
                            trigger={["click"]}
                            menu={{
                              items: allTags.map((tag) => {
                                const tagColor = tag.color || "#16a34a";
                                return {
                                  key: tag._id,
                                  label: (
                                    <span
                                      style={{
                                        color: tagColor,
                                        fontWeight: 700,
                                      }}
                                    >
                                      {tag.name}
                                    </span>
                                  ),
                                };
                              }),
                              onClick: ({ key }) =>
                                handleAddTag(viewLead._id, key, leadTags || []),
                            }}
                          >
                            <Button className="flex h-[34px] items-center gap-2 rounded-[7px] border border-[#e5e7eb] bg-white px-3 text-[13px] font-semibold text-[#1677ff] shadow-sm">
                              <Plus size={16} strokeWidth={2.6} />
                              Add Tag
                            </Button>
                          </Dropdown>
                        </div>
                      </div>

                      <div className="border-b border-[#eef2f6] rounded-md px-3.5 py-3">
                        <p className="m-0 mb-2 text-[15px] font-semibold text-[#111827]">Status</p>
                        <div className="flex flex-wrap items-center gap-2">
                          {visibleStatusChain.length > 0 ? (
                            visibleStatusChain.map((s: any, i: number) => (
                              <React.Fragment key={`${s._id || s.name}-${i}`}>
                                {i > 0 && <ChevronRight size={14} strokeWidth={2.5} className="text-[#9ca3af] shrink-0" />}
                                <span
                                  className="inline-flex h-[34px] items-center rounded-[7px] px-3 text-[13px] font-semibold"
                                  style={{ backgroundColor: `${s.color || "#16a34a"}18`, color: s.color || "#16a34a" }}
                                >
                                  {s.name}
                                </span>
                              </React.Fragment>
                            ))
                          ) : (
                            <span className="text-[13px] font-medium text-[#697386]">No status set</span>
                          )}
                          <Dropdown
                            trigger={["click"]}
                            menu={{
                              items: drawerStatusOptions.map((status: any) => ({
                                key: status._id || status.name,
                                label: <span style={{ color: status.color || "#16a34a", fontWeight: 700 }}>{status.name}</span>,
                              })),
                              onClick: ({ key }) => {
                                const selected = drawerStatusOptions.find((s: any) => (s._id || s.name) === key);
                                if (selected) {
                                  handleStatusChange(viewLead._id, selected.name);
                                  setViewLead((previous: any) => previous ? { ...previous, leadstatus: selected } : previous);
                                  setDrawerStageChain((prev) => [...prev, selected]);
                                }
                              },
                            }}
                          >
                            <Button className="flex h-[34px] items-center gap-2 rounded-[7px] border border-[#e5e7eb] bg-white px-3 text-[13px] font-semibold text-[#1677ff] shadow-sm">
                              <Plus size={16} strokeWidth={2.6} />
                              Add
                            </Button>
                          </Dropdown>
                        </div>
                      </div>

                      <div className="px-3.5 pb-2 pt-3">
                        <div className="flex items-center justify-between mb-2">
                          <p className="m-0 text-[15px] font-semibold text-[#111827]">
                            Pipeline Stage
                          </p>
                          <Dropdown
                            trigger={["click"]}
                            menu={{
                              items: pipelineStatuses.map((status: any) => {
                                const sColor = status.color || "#16a34a";
                                return {
                                  key: status._id || status.name,
                                  label: (
                                    <span style={{ color: sColor, fontWeight: 700 }}>
                                      {status.name}
                                    </span>
                                  ),
                                };
                              }),
                              onClick: ({ key }) => {
                                const selected = pipelineStatuses.find(
                                  (s: any) => (s._id || s.name) === key,
                                );
                                if (selected) {
                                  handleStatusChange(viewLead._id, selected.name);
                                  setViewLead((previous: any) =>
                                    previous ? { ...previous, leadstatus: selected } : previous,
                                  );
                                  setDrawerStageChain((prev) => [...prev, selected]);
                                }
                              },
                            }}
                          >
                            <Button className="flex h-[34px] items-center gap-2 rounded-[7px] border border-[#e5e7eb] bg-white px-3 text-[13px] font-semibold text-[#1677ff] shadow-sm">
                              <Plus size={16} strokeWidth={2.6} />
                              Add
                            </Button>
                          </Dropdown>
                        </div>
                        <div className="overflow-x-auto pb-1" style={{ scrollbarWidth: "thin", scrollbarColor: "#cbd5e1 transparent" }}>
                          <div
                            className="relative grid items-start pt-3"
                            style={{
                              minWidth: `${Math.max(360, visiblePipelineStatuses.length * 76)}px`,
                              gridTemplateColumns: `repeat(${visiblePipelineStatuses.length || 1}, minmax(0, 1fr))`,
                            }}
                          >
                            {visiblePipelineStatuses.length > 1 && (
                              <span
                                className="absolute top-[21px] h-[2px] rounded-full bg-[#9ca3af]"
                                style={{
                                  left: `${50 / visiblePipelineStatuses.length}%`,
                                  right: `${50 / visiblePipelineStatuses.length}%`,
                                }}
                              />
                            )}
                            {visiblePipelineStatuses.length > 1 && chainActiveIndex > 0 && (
                              <span
                                className="absolute top-[21px] h-[2px] rounded-full"
                                style={{
                                  left: `${50 / visiblePipelineStatuses.length}%`,
                                  right: `${((visiblePipelineStatuses.length - chainActiveIndex - 0.5) / visiblePipelineStatuses.length) * 100}%`,
                                  backgroundColor: chainActiveColor,
                                }}
                              />
                            )}
                            {visiblePipelineStatuses.map((status: any, index: number) => {
                              const colored = index <= chainActiveIndex;
                              const dotNode = (
                                <div className="relative flex flex-1 flex-col items-center text-center cursor-pointer">
                                  <span
                                    className="relative z-[1] h-[18px] w-[18px] rounded-full"
                                    style={{
                                      backgroundColor: colored ? chainActiveColor : "#8b95a1",
                                      boxShadow: "0 0 0 1px rgba(15, 23, 42, 0.08)",
                                    }}
                                  />
                                  <span
                                    className="mt-2 max-w-[68px] text-[10px] font-semibold leading-tight"
                                    style={{ color: colored ? chainActiveColor : "#5f6673" }}
                                  >
                                    {status.name}
                                  </span>
                                </div>
                              );
                              if (colored) {
                                return (
                                  <Dropdown
                                    key={status._id || status.name || index}
                                    trigger={["click"]}
                                    menu={{
                                      items: [
                                        {
                                          key: "remove",
                                          label: (
                                            <span className="flex items-center gap-2 text-[#ef4444] font-semibold text-[13px]">
                                              <Trash2 size={13} strokeWidth={2.2} /> Remove stage
                                            </span>
                                          ),
                                        },
                                      ],
                                      onClick: () => {
                                        setRemovedPipelineStages((prev) => ({ ...prev, [viewLead._id]: [...(prev[viewLead._id] || []), status.name] }));
                                      },
                                    }}
                                  >
                                    {dotNode}
                                  </Dropdown>
                                );
                              }
                              return (
                                <div
                                  key={status._id || status.name || index}
                                  className="relative flex flex-1 flex-col items-center text-center cursor-pointer"
                                  onClick={() => {
                                    handleStatusChange(viewLead._id, status.name);
                                    setViewLead((previous: any) =>
                                      previous ? { ...previous, leadstatus: status } : previous,
                                    );
                                    setDrawerStageChain((prev) => [...prev, status]);
                                  }}
                                >
                                  <span
                                    className="relative z-[1] h-[18px] w-[18px] rounded-full"
                                    style={{
                                      backgroundColor: "#8b95a1",
                                      boxShadow: "0 0 0 1px rgba(15, 23, 42, 0.08)",
                                    }}
                                  />
                                  <span
                                    className="mt-2 max-w-[68px] text-[10px] font-semibold leading-tight"
                                    style={{ color: "#5f6673" }}
                                  >
                                    {status.name}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </section>
                  )}

                  {activeViewLeadTab === "logs" && (
                    <section
                      id="lead-logs"
                      className="overflow-hidden rounded-[12px] border border-[#f1f5f9] bg-white shadow-sm"
                    >
                      <Spin spinning={viewLeadLogsLoading}>
                        <div className="overflow-x-auto">
                          <table className="w-full min-w-[720px] table-fixed border-collapse bg-white">
                            <colgroup>
                              <col className="w-[22%]" />
                              <col className="w-[52%]" />
                              <col className="w-[26%]" />
                            </colgroup>
                            <thead className="bg-white">
                              <tr className="h-[50px]">
                                <th className="px-5 py-0 text-left align-middle">
                                  <span className="flex items-center gap-3 whitespace-nowrap text-sm font-bold text-[#111827]">
                                    <ClockCircleOutlined className="text-base" /> Updated At
                                  </span>
                                </th>
                                <th className="px-5 py-0 text-left align-middle">
                                  <span className="flex items-center gap-3 text-sm font-bold text-[#111827]">
                                    <MessageOutlined className="text-base" /> Log Details
                                  </span>
                                </th>
                                <th className="px-5 py-0 text-left align-middle">
                                  <span className="flex items-center gap-3 whitespace-nowrap text-sm font-bold text-[#111827]">
                                    <UserOutlined className="text-base" /> Updated By
                                  </span>
                                </th>
                              </tr>
                              <tr>
                                <th colSpan={3} className="px-5">
                                  <div className="h-px bg-[#f1f5f9]" />
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {viewLeadLogs.length > 0 ? (
                                viewLeadLogs.map((log, index) => {
                                  const createdAt = dayjs(log.createdAt).utc().local();
                                  const date = createdAt.isValid()
                                    ? createdAt.format("DD MMM YYYY")
                                    : "N/A";
                                  const time = createdAt.isValid()
                                    ? createdAt.format("hh:mm A")
                                    : "";
                                  const userName = getLogUpdaterName(log);
                                  const userRole = getLogUpdaterRole(log, teamMembers);
                                  const userInitials = getInitials(userName);
                                  const message = String(log.message || "");
                                  const isSummaryAdded = message
                                    .toLowerCase()
                                    .includes("added a new summary");
                                  const activityVisual = getLeadLogActivityVisual(log);

                                  return (
                                    <tr
                                      key={log._id || index}
                                      className="border-b border-[#f1f5f9] transition-colors hover:bg-slate-50/50 last:border-b-0"
                                    >
                                      <td className="relative h-[72px] border-r border-[#f1f5f9] py-3 pl-4 pr-2 align-middle">
                                        <span className="absolute bottom-0 left-[35px] top-0 border-l border-dashed border-[#cbd5e1]" />
                                        <div className="relative flex items-center gap-3">
                                          <span
                                            className="relative z-[1] flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full border shadow-sm"
                                            style={{
                                              backgroundColor: activityVisual.backgroundColor,
                                              borderColor: activityVisual.backgroundColor,
                                              color: activityVisual.color,
                                            }}
                                          >
                                            {activityVisual.icon}
                                          </span>
                                          <span className="flex min-w-0 flex-col">
                                            <span className="whitespace-nowrap text-sm font-bold tracking-tight text-slate-900">
                                              {date}
                                            </span>
                                            <span className="mt-1 text-xs font-medium text-slate-400">
                                              {time}
                                            </span>
                                          </span>
                                        </div>
                                      </td>

                                      <td className="border-r border-[#f1f5f9] px-4 py-3 align-middle max-w-0 overflow-hidden">
                                        <div
                                          dangerouslySetInnerHTML={{ __html: message || "No message" }}
                                          className="log-message-content break-words overflow-wrap-anywhere text-sm font-medium leading-relaxed text-slate-800 opacity-95"
                                          style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
                                        />
                                        {isSummaryAdded && (
                                          <div className="mt-3 inline-flex items-center rounded-md border border-[#ffedd5] bg-[#fff7ed] px-2.5 py-1 text-[11px] font-bold tracking-wide text-[#ea580c]">
                                            Summary Added
                                          </div>
                                        )}
                                      </td>

                                      <td className="px-4 py-3 align-middle">
                                        <div className="flex items-center gap-3">
                                          <span className="flex h-[45px] w-[45px] shrink-0 items-center justify-center rounded-xl border border-slate-100 bg-[#f8fafc] text-[11px] font-bold text-slate-700 shadow-sm">
                                            {userInitials}
                                          </span>
                                          <span className="flex min-w-0 flex-col">
                                            <span className="whitespace-nowrap text-sm font-bold leading-tight tracking-tight text-slate-900">
                                              {userName}
                                            </span>
                                            {userRole && (
                                              <span className="mt-1 whitespace-nowrap text-xs font-medium text-slate-400">
                                                {userRole}
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={3} className="px-6 py-8 text-center text-sm font-medium text-slate-500">
                                    No logs available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </Spin>
                      <div className="flex items-center justify-between border-t border-slate-100 bg-white px-5 py-3">
                        <div className="text-sm font-medium tracking-normal text-[#6b7280]">
                          {`Showing ${
                            viewLeadLogsPagination.total === 0
                              ? 0
                              : (viewLeadLogsPagination.current - 1) *
                                  viewLeadLogsPagination.pageSize +
                                1
                          } to ${Math.min(
                            viewLeadLogsPagination.current *
                              viewLeadLogsPagination.pageSize,
                            viewLeadLogsPagination.total,
                          )} of ${viewLeadLogsPagination.total} logs`}
                        </div>
                        <Pagination
                          current={viewLeadLogsPagination.current}
                          pageSize={viewLeadLogsPagination.pageSize}
                          total={viewLeadLogsPagination.total}
                          onChange={(page) => fetchViewLeadLogs(viewLead._id, page)}
                          showSizeChanger={false}
                          className="custom-lead-log-pagination"
                        />
                      </div>
                    </section>
                  )}
                </div>
              </div>
            );
          })()}
      </Drawer>

      <Drawer
        placement="right"
        onClose={() => {
          setIsViewModalVisible(false);
          setViewLead(null);
        }}
        open={false}
        width={400}
        styles={{
          body: { padding: 0, backgroundColor: "#fff" },
          header: { display: "none" },
        }}
      >
        {false && viewLead && (
          <div className="text-sm">
            {/* Header */}
            <div
              style={{ backgroundColor: "#001529" }}
              className="text-white p-4 relative"
            >
              <button
                onClick={() => {
                  setIsViewModalVisible(false);
                  setViewLead(null);
                }}
                className="absolute top-2 right-2 text-white text-lg font-bold hover:text-gray-300"
              >
                &times;
              </button>
              <div className="flex items-center gap-4">
                <img
                  src={
                    viewLead.profilePhoto
                      ? `${process.env.REACT_APP_IMAGE_URL}/rawdata/${viewLead.profilePhoto}`
                      : "download.png"
                  }
                  alt="Profile"
                  className="w-16 h-16 rounded-full object-cover border-2 border-white"
                />
                <div>
                  <h2 className="text-lg font-semibold">
                    {viewLead.contactName}
                  </h2>
                  <p className="text-sm">{viewLead.company}</p>
                  <div className="flex items-center gap-2 text-xs text-gray-200 mt-1">
                    <span className="font-medium">{viewLead.leadCode}</span>
                    <span>â€¢</span>
                    <div>
                      <span
                        className={`px-2 py-1 rounded text-xs font-semibold ${
                          viewLead.priority === "High"
                            ? "bg-red-500 text-white"
                            : viewLead.priority === "Medium"
                              ? "bg-yellow-500 text-white"
                              : "bg-green-500 text-white"
                        }`}
                      >
                        {viewLead.priority}
                      </span>
                    </div>
                    <span>â€¢</span>
                    <span
                      className="px-2 py-0.5 rounded text-xs font-semibold"
                      style={{
                        backgroundColor: viewLead.leadstatus?.color,
                        color: "#fff",
                      }}
                    >
                      {viewLead.leadstatus?.name}
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-3 text-center mt-4">
                <div>
                  <p className="font-bold text-base">{viewLead.rank || 0}</p>
                  <p className="text-xs">Rank</p>
                </div>
                <div>
                  <p className="font-bold text-base">
                    {viewLead.leadValue || 0}
                  </p>
                  <p className="text-xs">Lead Value</p>
                </div>
                <div>
                  <p className="font-bold text-base">
                    {viewLead.date || "N/A"}
                  </p>
                  <p className="text-xs">Date</p>
                </div>
              </div>
            </div>

            {/* Lead Info (Highlighted) */}
            <div className="bg-gradient-to-br from-gray-50 via-white to-gray-50 min-h-screen p-3">
              {/* Lead Information Card */}
              <div className="relative p-6 bg-white rounded-2xl shadow-md mb-8 transition hover:shadow-xl border border-transparent bg-clip-padding">
                <div className="absolute inset-0 rounded-2xl border-[1.5px] border-transparent bg-gradient-to-r from-blue-200 via-purple-200 to-pink-200 pointer-events-none"></div>

                {/* Header */}
                <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-100 relative z-10">
                  <div className="flex items-center gap-3">
                    <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
                      <FaInfoCircle className="text-blue-600" />
                    </h2>
                    <div>
                      <p className="font-semibold text-gray-900 text-lg">
                        Lead Information
                      </p>
                      <p className="text-xs text-gray-500">
                        Details about this potential customer
                      </p>
                    </div>
                  </div>
                  <button className="text-gray-400 hover:text-gray-600 transition-colors">
                    <i className="fas fa-ellipsis-v"></i>
                  </button>
                </div>

                {/* Info Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative z-10">
                  {/* Title */}
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                      Title
                    </p>
                    <Tooltip
                      title={viewLead.title}
                      color="#CCCCCC"
                      overlayInnerStyle={{
                        color: "#000", // âœ… font color
                        padding: "12px",
                      }}
                    >
                      <div className="px-3 py-2 rounded-lg bg-gradient-to-r from-purple-50 to-purple-100 border border-purple-200 hover:shadow-sm transition cursor-pointer">
                        <p className="text-sm font-medium text-purple-800 line-clamp-2">
                          {viewLead.title}
                        </p>
                      </div>
                    </Tooltip>
                  </div>

                  {/* Company */}
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                      Company
                    </p>
                    <Tooltip
                      title={viewLead.company}
                      color="#CCCCCC"
                      overlayInnerStyle={{
                        color: "#000", // âœ… font color
                        padding: "12px",
                      }}
                    >
                      <div className="px-3 py-2 rounded-lg bg-gradient-to-r from-green-50 to-green-100 border border-green-200 hover:shadow-sm transition cursor-pointer">
                        <p className="text-sm font-medium text-green-800 line-clamp-2">
                          {viewLead.company}
                        </p>
                      </div>
                    </Tooltip>
                  </div>

                  {/* Source */}
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                      Source
                    </p>
                    <div className="px-3 py-2 rounded-lg bg-gray-50 border border-gray-200 inline-block">
                      <span
                        className="text-xs font-medium py-1.5 px-4 rounded-full inline-flex items-center gap-2 shadow-sm"
                        style={{
                          backgroundColor:
                            `${viewLead.leadSource?.color}20` || "#f1f5f9",
                          color: viewLead.leadSource?.color || "#64748b",
                          border:
                            `1px solid ${viewLead.leadSource?.color}40` ||
                            "#e2e8f0",
                          minWidth: "90px", // âœ… ensures pill has more width
                        }}
                      >
                        <i className="fas fa-bullhorn text-[12px] items-center align-middle text-center"></i>
                        {viewLead.leadSource?.name}
                      </span>
                    </div>
                  </div>

                  {/* Link */}
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                      <div
                        className="lead-source-wrapper-one cursor-pointer"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        Link
                        {/* Copy icon */}
                        <Tooltip
                          title={
                            isClick === viewLead.link ? "Copied" : "Copy Link"
                          }
                          color="#CCCCCC"
                          overlayInnerStyle={{
                            color: "#000", // âœ… font color
                            padding: "12px",
                          }}
                        >
                          {isClick === viewLead.link ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                lineHeight: 1,
                              }}
                            >
                              <RiCheckLine
                                size={15}
                                style={{ color: "#1890ff" }}
                              />
                              <span
                                style={{
                                  fontSize: "7px",
                                  color: "#1890ff",
                                  marginTop: "2px",
                                }}
                              >
                                Copied
                              </span>
                            </div>
                          ) : (
                            <RiFileCopyLine
                              size={15}
                              className="copy-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleViewLeadCopy(
                                  viewLead.link.toString(),
                                  viewLead.link,
                                );
                              }}
                            />
                          )}
                        </Tooltip>
                      </div>
                    </p>
                    <Tooltip
                      title={viewLead.link}
                      color="#CCCCCC"
                      overlayInnerStyle={{
                        color: "#000", // âœ… font color
                        padding: "12px",
                      }}
                    >
                      <a
                        href={viewLead.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-between px-3 py-2 rounded-lg bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200 hover:shadow-sm transition group transform hover:scale-[1.02] active:scale-[0.98]"
                      >
                        <p className="text-sm font-medium text-blue-700 truncate pr-2">
                          {viewLead.link}
                        </p>
                        <i className="fas fa-external-link-alt text-blue-400 text-xs group-hover:text-blue-600"></i>
                      </a>
                    </Tooltip>
                  </div>
                </div>
              </div>

              {/* Additional Information Card */}
              <div className="relative p-6 bg-white rounded-2xl shadow-md transition hover:shadow-xl border border-transparent bg-clip-padding">
                <div className="absolute inset-0 rounded-2xl border-[1.5px] border-transparent bg-gradient-to-r from-green-200 via-blue-200 to-teal-200 pointer-events-none"></div>

                {/* Header */}
                <div className="flex items-center gap-2 mb-6 pb-4 border-b border-gray-100 relative z-10">
                  <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
                    <FaAddressCard className="text-green-600" />
                  </h2>
                  <p className="font-semibold text-gray-900 text-lg">
                    Additional Information
                  </p>
                </div>

                {/* Contact Information */}
                <div className="mb-8 relative z-10">
                  <p className="font-semibold text-gray-700 mb-2 text-sm">
                    Contact Information
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li
                      className="flex items-center gap-2 cursor-pointer hover:text-green-700 transition"
                      onClick={() =>
                        navigator.clipboard.writeText(viewLead.phone)
                      }
                    >
                      <PhoneOutlined className="text-green-600" />
                      <div
                        className="lead-source-wrapper-one cursor-pointer"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span>{viewLead.phone}</span>
                        {/* Copy icon */}
                        <Tooltip
                          title={
                            isClick === viewLead.phone ? "Copied" : "Copy Link"
                          }
                          color="#CCCCCC"
                          overlayInnerStyle={{
                            color: "#000", // âœ… font color
                            padding: "12px",
                          }}
                        >
                          {isClick === viewLead.phone ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                lineHeight: 1,
                              }}
                            >
                              <RiCheckLine
                                size={15}
                                style={{ color: "#1890ff" }}
                              />
                              <span
                                style={{
                                  fontSize: "7px",
                                  color: "#1890ff",
                                  marginTop: "2px",
                                }}
                              >
                                Copied
                              </span>
                            </div>
                          ) : (
                            <RiFileCopyLine
                              size={15}
                              className="copy-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleViewLeadCopy(
                                  viewLead.phone.toString(),
                                  viewLead.phone,
                                );
                              }}
                            />
                          )}
                        </Tooltip>
                      </div>
                    </li>
                    <li
                      className="flex items-center gap-2 cursor-pointer hover:text-red-700 transition"
                      onClick={() =>
                        navigator.clipboard.writeText(viewLead.email || "N/A")
                      }
                    >
                      <MailOutlined className="text-red-600" />
                      <div
                        className="lead-source-wrapper-one cursor-pointer"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span>{viewLead.email || "N/A"}</span>
                        {/* Copy icon */}
                        <Tooltip
                          title={
                            isClick === viewLead.email ? "Copied" : "Copy Link"
                          }
                          color="#CCCCCC"
                          overlayInnerStyle={{
                            color: "#000", // âœ… font color
                            padding: "12px",
                          }}
                        >
                          {isClick === viewLead.email ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                lineHeight: 1,
                              }}
                            >
                              <RiCheckLine
                                size={15}
                                style={{ color: "#1890ff" }}
                              />
                              <span
                                style={{
                                  fontSize: "7px",
                                  color: "#1890ff",
                                  marginTop: "2px",
                                }}
                              >
                                Copied
                              </span>
                            </div>
                          ) : (
                            <RiFileCopyLine
                              size={15}
                              className="copy-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleViewLeadCopy(
                                  viewLead.email.toString(),
                                  viewLead.email,
                                );
                              }}
                            />
                          )}
                        </Tooltip>
                      </div>
                    </li>
                  </ul>
                </div>

                {/* Lead Owner & Platform ID */}
                <div className="mb-8 grid grid-cols-2 gap-x-8 text-sm relative z-10">
                  <div>
                    <p className="font-semibold text-gray-700 mb-1">
                      Lead Owner
                    </p>
                    <p className="text-gray-600">
                      {viewLead.leadowner?.username}{" "}
                      <span className="text-gray-400">
                        ({viewLead.leadowner?.employeeId})
                      </span>
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-700 mb-1">
                      Source Platform ID
                    </p>
                    <span className="px-2.5 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium shadow-sm">
                      {viewLead.platform?.username || "N/A"}
                    </span>
                  </div>
                </div>

                {/* Tags */}
                <div className="relative z-10">
                  <p className="font-semibold text-gray-700 mb-2 text-sm">
                    Tags
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {viewLead.leadTags?.map((tag: any, i: any) => (
                      <TagBadge key={i} tag={tag.name} color={tag.color} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Drawer>

      {/* Add Modal */}
      <AddRawDataModal
        visible={isAddModalVisible}
        onCancel={() => setIsAddModalVisible(false)}
        onCreate={handleCreate}
        refreshRawData={fetchRawData}
      />

      {/* Section Edit Modals */}
      <Modal
        open={!!sectionEditVisible}
        onCancel={() => { setSectionEditVisible(null); sectionEditForm.resetFields(); }}
        footer={null}
        width={700}
        destroyOnClose
        className="custom-modal"
        style={{
          top: 20,
          maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          position: "relative",
        }}
        bodyStyle={{
          overflowY: "auto",
          fontFamily: "inter, sans-serif",
        }}
        styles={{
          header: {
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "#f1f5ffff",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
        }}
        title={
          <div style={{ color: "#4b5563", fontFamily: "inter, sans-serif", fontSize: "20px", fontWeight: 500 }}>
            {sectionEditVisible === "basic" && "Edit Basic Information"}
            {sectionEditVisible === "description" && "Edit Description"}
            {sectionEditVisible === "source" && "Edit Source Information"}
          </div>
        }
      >
        <Form
          form={sectionEditForm}
          onFinish={handleSectionEditSubmit}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          colon={false}
          style={{ margin: 0 }}
        >
          <div className="elements">
            {sectionEditVisible === "basic" && (
              <>
                <Form.Item
                  name="contactName"
                  label={<span style={{ color: "#4b5563", fontFamily: "inter, sans-serif", fontSize: "14px", paddingLeft: "15px", fontWeight: 500 }}>Full Name</span>}
                  required={false}
                >
                  <Input size="large" placeholder="Enter full name" className="Allinput" />
                </Form.Item>
                <Form.Item
                  name="company"
                  label={<span style={{ color: "#4b5563", fontFamily: "inter, sans-serif", fontSize: "14px", paddingLeft: "15px", fontWeight: 500 }}>Company</span>}
                  required={false}
                >
                  <Input size="large" placeholder="Enter company name" className="Allinput" />
                </Form.Item>
                <Form.Item
                  name="phone"
                  label={<span style={{ color: "#4b5563", fontFamily: "inter, sans-serif", fontSize: "14px", paddingLeft: "15px", fontWeight: 500 }}>Contact Number</span>}
                  required={false}
                >
                  <Input size="large" placeholder="Enter phone number" className="Allinput" />
                </Form.Item>
                <Form.Item
                  name="email"
                  label={<span style={{ color: "#4b5563", fontFamily: "inter, sans-serif", fontSize: "14px", paddingLeft: "15px", fontWeight: 500 }}>Email Address</span>}
                  required={false}
                  rules={[{ type: "email", message: "Invalid email format" }]}
                >
                  <Input size="large" placeholder="Enter email" className="Allinput" />
                </Form.Item>
                <Form.Item
                  name="country"
                  label={<span style={{ color: "#4b5563", fontFamily: "inter, sans-serif", fontSize: "14px", paddingLeft: "15px", fontWeight: 500 }}>Location</span>}
                  required={false}
                >
                  <Input size="large" placeholder="Enter country / city" className="Allinput" />
                </Form.Item>
              </>
            )}
            {sectionEditVisible === "description" && (
              <Form.Item
                name="description"
                label={<span style={{ color: "#4b5563", fontFamily: "inter, sans-serif", fontSize: "14px", paddingLeft: "15px", fontWeight: 500 }}>Description</span>}
                required={false}
              >
                <Input.TextArea rows={5} placeholder="Enter description..." className="textarea-input" style={{ resize: "none" }} />
              </Form.Item>
            )}
            {sectionEditVisible === "source" && (
              <>
                <Form.Item
                  name="leadSource"
                  label={<span style={{ color: "#4b5563", fontFamily: "inter, sans-serif", fontSize: "14px", paddingLeft: "15px", fontWeight: 500 }}>Source</span>}
                  required={false}
                >
                  <Select size="large" placeholder="Select Lead Source" allowClear className="CustomSelect">
                    {sectionSources.map((s: any) => (
                      <Select.Option key={s._id} value={s._id}>{s.name}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="link"
                  label={<span style={{ color: "#4b5563", fontFamily: "inter, sans-serif", fontSize: "14px", paddingLeft: "15px", fontWeight: 500 }}>Source Link</span>}
                  required={false}
                >
                  <Input size="large" placeholder="Enter source link" className="Allinput" />
                </Form.Item>
              </>
            )}
          </div>

          <Row justify="end">
            <Col xs={24} sm={24} md={24} xl={24} xxl={20} className="d-flex justify-content-end me-3">
              <div className="button-wrapper">
                <button
                  className="allcanclebutton"
                  type="button"
                  onClick={() => { setSectionEditVisible(null); sectionEditForm.resetFields(); }}
                  disabled={sectionEditLoading}
                >
                  Cancel
                </button>
                <button className="allsubmitebutton" type="submit" disabled={sectionEditLoading}>
                  {sectionEditLoading ? "Updating..." : "Update"}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/* Edit Modal */}
      <EditRawDataModal
        visible={isEditModalVisible}
        currentRawDataId={currentRawDataId?._id}
        onCancel={() => setIsEditModalVisible(false)}
        onUpdate={handleUpdate}
      />

      {/* Delete Modal */}
      <Modal
        open={!!deleteId || bulkDelete}
        onOk={async () => {
          try {
            if (bulkDelete) {
              await Promise.all(
                selectedRowKeys.map((id: any) => deleteRawData(id)),
              );
              message.success("Selected records deleted successfully");
              setSelectedRowKeys([]);
              setSelectedRows([]);
              setBulkDelete(false);
            } else if (deleteId) {
              await deleteRawData(deleteId);
              message.success("RawData deleted successfully");
              setDeleteId(null);
            }
            fetchRawData();
          } catch (error) {
            console.error("Delete error:", error);
            message.error("Failed to delete record(s)");
          }
        }}
        onCancel={() => {
          setDeleteId(null);
          setBulkDelete(false);
        }}
        okText="Yes"
        cancelText="No"
        width={500}
        centered={false}
        destroyOnClose
        className="custom-modal"
        style={{
          bottom: 20,
          top: "10vw",
          maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          position: "relative",
        }}
        title={
          <div style={{ marginLeft: "11px", width: "100%", paddingRight: 20 }}>
            Confirmation
          </div>
        }
        okButtonProps={{
          style: {
            backgroundColor: "#ff4d4f",
            borderColor: "#ff4d4f",
            color: "white",
          },
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          content: { padding: 0, overflow: "hidden" },
          footer: {
            borderTop: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          body: {
            padding: "22px",
            overflowY: "auto",
            fontFamily: "inter, sans-serif",
          },
        }}
      >
        {bulkDelete ? (
          <p>
            Are you sure you want to delete {selectedRowKeys.length} record(s)?
          </p>
        ) : (
          <p>Are you sure you want to delete this RawData?</p>
        )}
      </Modal>

      {/* Summary Delete Confirmation Modal */}
      <Modal
        open={!!summaryDeleteTarget}
        onOk={handleConfirmDeleteSummary}
        onCancel={() => setSummaryDeleteTarget(null)}
        confirmLoading={summaryLoading}
        okText="Yes"
        cancelText="No"
        width={500}
        centered={false}
        destroyOnClose
        className="custom-modal"
        style={{
          bottom: 20,
          top: "10vw",
          maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          position: "relative",
        }}
        title={
          <div
            style={{
              marginLeft: "11px",
              width: "100%",
              paddingRight: 20,
            }}
          >
            Confirmation
          </div>
        }
        okButtonProps={{
          style: {
            backgroundColor: "#ff4d4f",
            borderColor: "#ff4d4f",
            color: "white",
          },
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          content: { padding: 0, overflow: "hidden" },
          footer: {
            borderTop: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          body: {
            padding: "22px",
            overflowY: "auto",
            fontFamily: "inter, sans-serif",
          },
        }}
      >
        <p>Are you sure you want to delete this Summary?</p>
      </Modal>

      {/* Lead Log Modal */}
      <Modal
        open={isLogModalOpen}
        onCancel={() => setIsLogModalOpen(false)}
        footer={null}
        width={1100}
        closeIcon={null}
        centered
        destroyOnClose
        styles={{
          mask: {
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          },
          content: {
            padding: 0,
            overflow: "hidden",
            borderRadius: "16px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          },
          body: {
            padding: 0,
            fontFamily: "'Inter', sans-serif",
          },
        }}
      >
        <div className="flex flex-col h-[85vh] max-h-[850px]">
          {/* Custom Header */}
          <div className="flex items-center justify-between bg-[#0b1120] py-3 pl-3 pr-5 text-white">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-[16px] border-0 bg-[#183235] shadow-[0_10px_24px_rgba(0,0,0,0.18)]">
                <svg
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                  className="block"
                  style={{ transform: "translateX(0.5px)" }}
                  aria-hidden="true"
                >
                  <path
                    d="M7.5 3.75H16.15L21 8.6V23.25H7.5V3.75Z"
                    stroke="#8df2ad"
                    strokeWidth="2.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.15 3.75V8.6H21"
                    stroke="#8df2ad"
                    strokeWidth="2.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.6 12.15H17.9"
                    stroke="#8df2ad"
                    strokeWidth="2.35"
                    strokeLinecap="round"
                  />
                  <path
                    d="M10.6 16.25H17.9"
                    stroke="#8df2ad"
                    strokeWidth="2.35"
                    strokeLinecap="round"
                  />
                  <path
                    d="M10.6 20.35H15.8"
                    stroke="#8df2ad"
                    strokeWidth="2.35"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div>
                <h2 className="m-0 text-lg font-bold tracking-tight text-white">
                  Lead Log
                </h2>
                <p className="m-0 mt-0.5 text-xs font-medium text-slate-400 opacity-80">
                  Complete activity history and updates for this lead
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div>
                <Input
                  placeholder="Search logs..."
                  allowClear
                  prefix={<SearchOutlined className="text-base" />}
                  value={logSearchText}
                  onChange={(e) => {
                    setLogSearchText(e.target.value);
                    if (currentLeadLogId) {
                      handleViewLeadLogs(currentLeadLogId, 1, e.target.value);
                    }
                  }}
                  className="custom-search-input h-10 w-80 rounded-xl border-slate-800 bg-[#071827] text-sm text-white hover:border-slate-700 focus:border-slate-700"
                  style={{
                    backgroundColor: "#071827",
                    border: "1px solid #1e293b",
                  }}
                />
              </div>
              <Button
                type="text"
                icon={<CloseOutlined className="text-slate-400 text-lg" />}
                onClick={() => setIsLogModalOpen(false)}
                className="flex h-9 w-9 items-center justify-center rounded-full border-none transition-all hover:bg-slate-800/50"
              />
            </div>
          </div>

          {/* Table Container */}
          <div className="flex-1 overflow-auto bg-white">
            <Spin spinning={logLoading}>
              <div className="min-w-[900px]">
                <table className="w-full table-fixed border-collapse">
                  <colgroup>
                    <col className="w-[22%]" />
                    <col className="w-[52%]" />
                    <col className="w-[26%]" />
                  </colgroup>
                  <thead className="bg-white">
                    <tr className="h-[52px]">
                      <th className="px-7 py-0 text-left align-middle">
                        <span className="flex items-center gap-3 text-sm font-bold text-[#111827]">
                          <ClockCircleOutlined className="text-base" /> Updated
                          At
                        </span>
                      </th>
                      <th className="px-5 py-0 text-left align-middle">
                        <span className="flex items-center gap-3 text-sm font-bold text-[#111827]">
                          <MessageOutlined className="text-base" /> Log Details
                        </span>
                      </th>
                      <th className="px-5 py-0 text-left align-middle">
                        <span className="flex items-center gap-3 text-sm font-bold text-[#111827]">
                          <UserOutlined className="text-base" /> Updated By
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={3} className="px-7">
                        <div className="h-px bg-[#f1f5f9]" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                  {selectedLeadLogs.length > 0 ? (
                    selectedLeadLogs.map((log, index) => {
                      const createdAt = dayjs(log.createdAt).utc().local();
                      const date = createdAt.format("DD MMM YYYY");
                      const time = createdAt.format("hh:mm A");
                      const userName = getLogUpdaterName(log);
                      const userRole = getLogUpdaterRole(log, teamMembers);
                      const userInitials = getInitials(userName);
                      const message = String(log.message || "");
                      const isSummaryAdded = message
                        .toLowerCase()
                        .includes("added a new summary");
                      const activityVisual = getLeadLogActivityVisual(log);

                      return (
                        <tr
                          key={log._id || index}
                          className="border-b border-[#f1f5f9] transition-colors hover:bg-slate-50/50"
                        >
                          {/* Updated At */}
                          <td className="relative h-[76px] border-r border-[#f1f5f9] pl-7 pr-2 py-3 align-middle">
                            <span className="absolute bottom-0 left-[47px] top-0 border-l border-dashed border-[#cbd5e1]" />
                            <div className="relative flex items-center gap-3">
                              <span
                                className="relative z-[1] flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full border shadow-sm"
                                style={{
                                  backgroundColor:
                                    activityVisual.backgroundColor,
                                  borderColor: activityVisual.backgroundColor,
                                  color: activityVisual.color,
                                }}
                              >
                                {activityVisual.icon}
                              </span>
                              <span className="flex flex-col">
                                <span className="whitespace-nowrap text-sm font-bold tracking-tight text-slate-900">
                                  {date}
                                </span>
                                <span className="mt-1 text-xs font-medium text-slate-400">
                                  {time}
                                </span>
                              </span>
                            </div>
                          </td>

                          {/* Log Details */}
                          <td className="border-r border-[#f1f5f9] px-3 py-3 align-middle max-w-0 overflow-hidden">
                            <div
                              dangerouslySetInnerHTML={{ __html: message }}
                              className="log-message-content break-words text-sm font-medium leading-relaxed text-slate-800 opacity-95"
                              style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
                            />
                            {isSummaryAdded && (
                              <div className="inline-flex items-center mt-3 bg-[#fff7ed] text-[#ea580c] border border-[#ffedd5] rounded-md font-bold px-2.5 py-1 text-[11px] tracking-wide">
                                Summary Added
                              </div>
                            )}
                          </td>

                          {/* Updated By */}
                          <td className="px-3 py-3 align-middle">
                            <div className="flex items-center gap-3">
                              <span className="flex h-[45px] w-[45px] shrink-0 items-center justify-center rounded-xl border border-slate-100 bg-[#f8fafc] text-[11px] font-bold text-slate-700 shadow-sm">
                                {userInitials}
                              </span>
                              <span className="flex min-w-0 flex-col">
                                <span className="whitespace-nowrap text-sm font-bold leading-tight tracking-tight text-slate-900">
                                  {userName}
                                </span>
                                {userRole && (
                                  <span className="mt-1 whitespace-nowrap text-xs font-medium text-slate-400">
                                    {userRole}
                                  </span>
                                )}
                              </span>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan={3}
                        className="py-24 text-center text-lg italic text-slate-400"
                      >
                        No logs available
                      </td>
                    </tr>
                  )}
                  </tbody>
                </table>
              </div>
            </Spin>
          </div>

          {/* Footer / Pagination */}
          <div className="flex items-center justify-between rounded-b-2xl border-t border-slate-100 bg-white px-5 py-3">
            <div className="text-sm font-medium tracking-normal text-[#6b7280]">
              {`Showing ${
                logsPagination.total === 0
                  ? 0
                  : (logsPagination.current - 1) * logsPagination.pageSize + 1
              } to ${Math.min(
                logsPagination.current * logsPagination.pageSize,
                logsPagination.total,
              )} of ${logsPagination.total} logs`}
            </div>
            <Pagination
              current={logsPagination.current}
              pageSize={logsPagination.pageSize}
              total={logsPagination.total}
              onChange={(page) => {
                if (currentLeadLogId) {
                  handleViewLeadLogs(currentLeadLogId, page, logSearchText);
                }
              }}
              showSizeChanger={false}
              className="custom-lead-log-pagination"
            />
          </div>
        </div>
      </Modal>

      {/* Summary Modal */}
      <Modal
        title={
          <div className="flex justify-between items-center w-full">
            <span className="text-xl font-bold">Summary</span>
          </div>
        }
        open={isSummaryModalOpen}
        onCancel={() => setIsSummaryModalOpen(false)}
        footer={null}
        width={650}
        centered
        destroyOnClose
        style={{
          bottom: 20,
          top: 20,
          maxHeight: "calc(100vh - 50px)",
          margin: "0 auto",
          position: "relative",
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          body: {
            overflowY: "auto",
            fontFamily: "inter, sans-serif",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <Spin spinning={summaryLoading}>
          <div className="elements relative">
            <div className="bg-white shadow-md rounded-lg overflow-hidden">
              {/* ðŸ”½ Scrollable table body */}
              <div
                ref={scrollRef}
                className="max-h-[400px] overflow-y-auto"
                style={{ scrollBehavior: "smooth" }}
              >
                <table className="w-full bg-white">
                  {/* Sticky Header */}
                  <thead
                    className="sticky top-[-1px] bg-gray-200 z-20 shadow-md"
                    style={{
                      boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                    }}
                  >
                    <tr>
                      <th className="border p-2 text-left w-[19%]">
                        <ClockCircleOutlined className="mr-2" /> Date
                      </th>
                      <th className="border p-2 text-left w-[30%]">
                        <MessageOutlined className="mr-2" /> Description
                      </th>
                      <th className="border p-2 text-left w-[20%]">
                        <ClockCircleOutlined className="mr-2" /> FollowDt
                      </th>
                      <th className="border p-2 text-left w-[11%]">Action</th>
                    </tr>
                  </thead>

                  {/* Table Body */}
                  <tbody>
                    {summaryData.length > 0 ? (
                      summaryData.map((summary, idx) => {
                        const htmlContent = summary.description || "";
                        if (!htmlContent || htmlContent.trim() === "<p></p>") {
                          return (
                            <tr
                              key={idx}
                              className="hover:bg-gray-100 transition"
                            >
                              <td className="border p-2">
                                {formatDateTime(summary.date)}
                              </td>
                              <td className="border p-2 text-gray-400">
                                No description
                              </td>
                              <td className="border p-2">
                                {formatDateTime(summary.followUpDate)}
                              </td>
                              <td className="border p-2 text-center">â€”</td>
                            </tr>
                          );
                        }

                        // Convert HTML to plain text for preview and tooltip logic
                        const tempDiv = document.createElement("div");
                        tempDiv.innerHTML = htmlContent;
                        const plainText =
                          tempDiv.textContent || tempDiv.innerText || "";

                        const previewContent = (
                          <TwoLineClampWithTooltip text={htmlContent} />
                        );

                        return (
                          <tr
                            key={idx}
                            className={`hover:bg-gray-100 transition ${summaryData.length === 1 ? "h-[162px]" : ""} ${summaryData.length === 2 ? "h-[90px]" : ""} ${summaryData.length === 3 ? "h-[60px]" : ""} ${summaryData.length === 4 ? "h-[45px]" : ""} ${summaryData.length === 5 ? "h-[40px]" : ""}`}
                          >
                            <td className="border p-2">
                              {formatDateTime(summary.date)}
                            </td>
                            <td className="border p-2">{previewContent}</td>
                            <td className="border p-2">
                              {formatDateTime(summary.followUpDate)}
                            </td>
                            <td className="border p-2 text-center">
                              <DeleteOutlined
                                className="text-red-500 cursor-pointer hover:text-red-700"
                                onClick={async () => {
                                  try {
                                    setSummaryLoading(true);
                                    await deleteRawDataSummary(
                                      currentSummaryrawDataId,
                                      summary._id,
                                    );
                                    message.success(
                                      "Summary deleted successfully",
                                    );
                                    const res = await getRawDataById(
                                      currentSummaryrawDataId,
                                    );
                                    const summaries =
                                      res?.data?.summaries || [];
                                    setSummaryData(summaries);
                                    if (
                                      currentSummaryrawDataId &&
                                      viewLeadRequestRef.current ===
                                        currentSummaryrawDataId
                                    ) {
                                      setViewLead((previous: any) =>
                                        previous
                                          ? { ...previous, summaries }
                                          : previous,
                                      );
                                      await fetchViewLeadLogs(
                                        currentSummaryrawDataId,
                                      );
                                    }
                                  } catch (err) {
                                    message.error(
                                      //@ts-ignore
                                      err.response?.data?.message ||
                                        "Error deleting summary",
                                    );
                                  } finally {
                                    setSummaryLoading(false);
                                  }
                                }}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={4}
                          className="text-center p-4 text-gray-500 h-[165px]"
                        >
                          No summaries found
                        </td>
                      </tr>
                    )}
                  </tbody>

                  {/* Sticky Add-New Row */}
                  <tfoot className="sticky bottom-0 bg-white z-20 border-t border-gray-300">
                    <tr className="align-top hover:bg-gray-50">
                      <td className="border p-2 w-[19%] align-top">
                        <DatePicker
                          value={newSummary.date}
                          showTime={{ format: "HH:mm" }}
                          format="DD-MM-YYYY HH:mm"
                          onChange={(val) =>
                            setNewSummary({ ...newSummary, date: val })
                          }
                          needConfirm={false}
                          style={{ width: "100%" }}
                          className="custom-date"
                        />
                      </td>

                      <td className="border p-2 align-top w-[50%]">
                        <Form.Item
                          required={false}
                          rules={[
                            {
                              required: true,
                              message: "Please enter description",
                            },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <div className="border rounded bg-white">
                            <Toolbar />
                            <div
                              className="border rounded bg-white max-h-[120px] overflow-y-auto"
                              style={{
                                scrollbarWidth: "thin",
                                scrollbarColor: "#cbd5e1 #f1f5f9",
                              }}
                            >
                              <EditorContent
                                editor={editor}
                                className="outline-none min-h-[60px] max-h-[60px] p-2 break-words"
                                style={{
                                  resize: "none",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                  width: "100%",
                                }}
                              />
                            </div>
                          </div>
                        </Form.Item>
                      </td>

                      <td className="border p-2 w-[21%] align-top">
                        <DatePicker
                          placeholder="FollowUp date"
                          showTime={{
                            format: "HH:mm",
                            defaultValue: dayjs().hour(10).minute(0).second(0),
                          }}
                          format="DD-MM-YYYY HH:mm"
                          onChange={(val) => {
                            if (val) {
                              // Set time to 10:00 AM
                              const dateWith10AM = dayjs(val)
                                .hour(10)
                                .minute(0)
                                .second(0);
                              setNewSummary({
                                ...newSummary,
                                followUpDate: dateWith10AM,
                              });
                            } else {
                              setNewSummary({
                                ...newSummary,
                                followUpDate: null,
                              });
                            }
                          }}
                          needConfirm={false}
                          style={{ width: "100%" }}
                          className="custom-date"
                          defaultPickerValue={dayjs()
                            .hour(10)
                            .minute(0)
                            .second(0)}
                        />
                      </td>

                      <td className="border p-2 text-center w-[10%] align-top">
                        <div className="text-gray-400">â€”</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>

          {/* Footer Add Button */}
          <div className="flex justify-end mt-3">
            <Button
              className="allbuttons"
              style={{
                color: "white",
                marginBottom: "10px",
                marginRight: "5px",
              }}
              onClick={async () => {
                if (!descValue?.trim() || descValue === "<p></p>") {
                  return message.error("Please enter a description");
                }

                const htmlContent = editor?.getHTML() || "";
                const plainText = editor?.getText().trim() || "";
                if (!plainText || htmlContent === "<p></p>") {
                  return message.error("Please enter a description");
                }

                try {
                  setSummaryLoading(true);
                  await updateRawData(
                    currentSummaryrawDataId,
                    (() => {
                      const formData = new FormData();
                      formData.append(
                        "newSummary",
                        JSON.stringify({
                          description: htmlContent,
                          date: newSummary.date?.toISOString(),
                          ...(newSummary.followUpDate
                            ? {
                                followUpDate:
                                  newSummary.followUpDate.toISOString(),
                              }
                            : {}),
                        }),
                      );
                      return formData;
                    })(),
                  );

                  message.success("Summary added successfully");

                  // Reset editor and form
                  editor?.commands.clearContent();
                  setDescValue("");
                  setNewSummary({
                    date: dayjs(),
                    description: "",
                    followUpDate: null,
                  });

                  // Refresh data
                  const res = await getRawDataById(currentSummaryrawDataId);
                  const summaries = res?.data?.summaries || [];
                  setSummaryData(summaries);
                  if (
                    currentSummaryrawDataId &&
                    viewLeadRequestRef.current === currentSummaryrawDataId
                  ) {
                    setViewLead((previous: any) =>
                      previous ? { ...previous, summaries } : previous,
                    );
                    await fetchViewLeadLogs(currentSummaryrawDataId);
                  }
                } catch (err: any) {
                  message.error(
                    err.response?.data?.message || "Error adding summary",
                  );
                } finally {
                  setSummaryLoading(false);
                }
              }}
            >
              Add Summary
            </Button>
          </div>
        </Spin>
      </Modal>

      {/* Transfer Modal */}
      {/* <Modal
        title="Transfer Leads"
        open={isTransferModalOpen}
        onCancel={() => setIsTransferModalOpen(false)}
        onOk={handleTransferRawData}
        okText="Transfer"
      >
        <div style={{ marginBottom: '16px' }}>
          <label>Source Developer:</label>
          <Select
            placeholder="Select Source Developer"
            style={{ width: '100%', marginTop: '8px' }}
            options={developers.map(dev => ({ label: dev.username, value: dev._id }))}
            value={transferDeveloperId}
            onChange={setTransferDeveloperId}
          />
        </div>
        <div>
          <label>Target Developer:</label>
          <Select
            placeholder="Select Target Developer"
            style={{ width: '100%', marginTop: '8px' }}
            options={developerTransferOptions}
            value={selectedTargetDeveloper}
            onChange={setSelectedTargetDeveloper}
          />
        </div>
      </Modal> */}
      <Modal
        title={
          <div style={{ paddingTop: "8px" }}>
            <span style={{ fontWeight: 600, fontSize: 18 }}>
              Transfer Leads
            </span>
          </div>
        }
        open={isTransferModalOpen}
        onCancel={() => setIsTransferModalOpen(false)}
        onOk={handleTransferRawData}
        okText="Transfer"
        cancelText="Cancel"
        okButtonProps={{ style: { backgroundColor: "#1677ff" } }}
        cancelButtonProps={{ style: { borderColor: "#d9d9d9" } }}
        width={480}
        centered
        styles={{
          body: { padding: "24px 24px 16px 24px" },
          footer: { padding: "12px 24px", borderTop: "1px solid #f0f0f0" },
          header: { padding: "20px 24px 8px 24px", borderBottom: "none" },
        }}
      >
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", marginBottom: 8, fontWeight: 500 }}>
            Source Developer:
          </label>
          <Select
            placeholder="Select Source Developer"
            style={{ width: "100%" }}
            options={developers.map((dev) => ({
              label: dev.username,
              value: dev._id,
            }))}
            value={transferDeveloperId}
            onChange={setTransferDeveloperId}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: 8, fontWeight: 500 }}>
            Target Developer:
          </label>
          <Select
            placeholder="Select Target Developer"
            style={{ width: "100%" }}
            options={developerTransferOptions}
            value={selectedTargetDeveloper}
            onChange={setSelectedTargetDeveloper}
          />
        </div>
      </Modal>
    </div>
  );
};

export default RawDataPage;
